export default class Constants {
  static ProviderNames = {
    Easebuzz: "easebuzz",
    ConnexPay: "connexpay",
  }
  static VALIDATION_MESSAGES = {
    title: [{ type: 'required', message: 'This field is required' }],
    firstName: [
      { type: 'required', message: 'This field is required.' },
      { type: 'pattern', message: 'Name must be alphabetic characters only' },
      {
        type: 'minlength',
        message: 'First name should be of minimum of 1 character.'
      }
    ],
    middleName: [
      { type: 'required', message: 'This field is required' },
      { type: 'pattern', message: 'Only alphabets allowed' }
    ],
    lastName: [
      { type: 'required', message: 'This field is required' },
      { type: 'pattern', message: 'Name must be alphabetic characters only' },
      {
        type: 'minlength',
        message: 'Last name should be of minimum of 2 character.'
      }
    ],
    rank: [{ type: 'required', message: 'Please select rank' }],
    phone: [
      { type: 'required', message: 'This field is required' },
      {
        type: 'minlength',
        message: 'Mobile number should be of minimum of 10 digits.'
      },
      {
        type: 'maxlength',
        message: 'Mobile number should not be greater than 10 digits.'
      },
      {
        type: 'pattern',
        message: 'Contact number should contain numeric values only.'
      }
    ],
    email: [
      { type: 'required', message: 'This field is required' },
      { type: 'pattern', message: 'Enter a valid email' }
    ],

    cardNumber: [
      { type: 'required', message: 'This field is required' },
      {
        type: 'minlength',
        message: 'Card number should be of minimum of 15 digits.'
      },
      {
        type: 'maxlength',
        message: 'Card number should not be greater than 16 digits.'
      },
      {
        type: 'pattern',
        message: 'Card number should contain numeric values only.'
      }
    ],
    cvv: [
      { type: 'required', message: 'This field is required' },
      {
        type: 'minlength',
        message: 'Cvv code should be of minimum of 3 digits.'
      },
      {
        type: 'maxlength',
        message: 'Cvv code should not be greater than 4 digits.'
      },
      {
        type: 'pattern',
        message: 'Cvv code should contain numeric values only.'
      }
    ],
    expiryDate: [
      { type: 'required', message: 'This field is required' },
      { type: 'pattern', message: 'Enter a valid expiry' }
    ],
    GSTIN: [
      { type: 'required', message: 'This field is required' },
      { type: 'pattern', message: 'Enter a valid GSTIN number.' }
    ],
    holderName: [
      { type: 'required', message: 'This field is required' },
      { type: 'pattern', message: 'Only alphabets allowed' }
    ],
    address: [
      { type: 'required', message: 'This field is required' },
      { type: 'pattern', message: 'Only alphabets allowed' }
    ],
    state: [
      { type: 'required', message: 'This field is required' },
      { type: 'pattern', message: 'Only alphabets allowed' }
    ],

    PanCardNumber: [
      { type: 'required', message: 'This field is required' },
      { type: 'pattern', message: 'Enter valid PAN number' }
    ]
  };

  static BookMyGetawayLoginUrl = "https://bookmygetaway.co.uk/login";

  static NIMBLLACCESSKEY = [
    {
      accountId: 'ftd-demo',
      accesskey: 'access_key_NYP0EYJRyQEy60GD'
    },
    {
      accountId: 'ftd-live',
      accesskey: 'access_key_RqLvaL1ZYODw47QZ'
    }
  ];

  static dateFormat = 'MM/DD/YYYY HH:mm';

  static NewsearchBarForDeeplink = [];

  static COUNTRIES = [
    {
      code: 'AF',
      name: 'Afghanistan',
      states: [
        {
          code: 'BDS',
          name: 'Badakhshan'
        },
        {
          code: 'BDG',
          name: 'Badghis'
        },
        {
          code: 'BGL',
          name: 'Baghlan'
        },
        {
          code: 'BAL',
          name: 'Balkh'
        },
        {
          code: 'BAM',
          name: 'Bamyan'
        },
        {
          code: 'DAY',
          name: 'Daykundi'
        },
        {
          code: 'FRA',
          name: 'Farah'
        },
        {
          code: 'FYB',
          name: 'Faryab'
        },
        {
          code: 'GHA',
          name: 'Ghazni'
        },
        {
          code: 'GHO',
          name: 'Ghōr'
        },
        {
          code: 'HEL',
          name: 'Helmand'
        },
        {
          code: 'HER',
          name: 'Herat'
        },
        {
          code: 'JOW',
          name: 'Jowzjan'
        },
        {
          code: 'KAB',
          name: 'Kabul'
        },
        {
          code: 'KAN',
          name: 'Kandahar'
        },
        {
          code: 'KAP',
          name: 'Kapisa'
        },
        {
          code: 'KHO',
          name: 'Khost'
        },
        {
          code: 'KNR',
          name: 'Kunar'
        },
        {
          code: 'KDZ',
          name: 'Kunduz Province'
        },
        {
          code: 'LAG',
          name: 'Laghman'
        },
        {
          code: 'LOG',
          name: 'Logar'
        },
        {
          code: 'NAN',
          name: 'Nangarhar'
        },
        {
          code: 'NIM',
          name: 'Nimruz'
        },
        {
          code: 'NUR',
          name: 'Nuristan'
        },
        {
          code: 'PIA',
          name: 'Paktia'
        },
        {
          code: 'PKA',
          name: 'Paktika'
        },
        {
          code: 'PAN',
          name: 'Panjshir'
        },
        {
          code: 'PAR',
          name: 'Parwan'
        },
        {
          code: 'SAM',
          name: 'Samangan'
        },
        {
          code: 'SAR',
          name: 'Sar-e Pol'
        },
        {
          code: 'TAK',
          name: 'Takhar'
        },
        {
          code: 'URU',
          name: 'Urozgan'
        },
        {
          code: 'ZAB',
          name: 'Zabul'
        }
      ]
    },
    {
      code: 'AX',
      name: 'Aland Islands',
      states: []
    },
    {
      code: 'AL',
      name: 'Albania',
      states: [
        {
          code: '01',
          name: 'Berat County'
        },
        {
          code: 'BR',
          name: 'Berat District'
        },
        {
          code: 'BU',
          name: 'Bulqizë District'
        },
        {
          code: 'DL',
          name: 'Delvinë District'
        },
        {
          code: 'DV',
          name: 'Devoll District'
        },
        {
          code: '09',
          name: 'Dibër County'
        },
        {
          code: 'DI',
          name: 'Dibër District'
        },
        {
          code: '02',
          name: 'Durrës County'
        },
        {
          code: 'DR',
          name: 'Durrës District'
        },
        {
          code: '03',
          name: 'Elbasan County'
        },
        {
          code: '04',
          name: 'Fier County'
        },
        {
          code: 'FR',
          name: 'Fier District'
        },
        {
          code: '05',
          name: 'Gjirokastër County'
        },
        {
          code: 'GJ',
          name: 'Gjirokastër District'
        },
        {
          code: 'GR',
          name: 'Gramsh District'
        },
        {
          code: 'HA',
          name: 'Has District'
        },
        {
          code: 'KA',
          name: 'Kavajë District'
        },
        {
          code: 'ER',
          name: 'Kolonjë District'
        },
        {
          code: '06',
          name: 'Korçë County'
        },
        {
          code: 'KO',
          name: 'Korçë District'
        },
        {
          code: 'KR',
          name: 'Krujë District'
        },
        {
          code: 'KC',
          name: 'Kuçovë District'
        },
        {
          code: '07',
          name: 'Kukës County'
        },
        {
          code: 'KU',
          name: 'Kukës District'
        },
        {
          code: 'KB',
          name: 'Kurbin District'
        },
        {
          code: '08',
          name: 'Lezhë County'
        },
        {
          code: 'LE',
          name: 'Lezhë District'
        },
        {
          code: 'LB',
          name: 'Librazhd District'
        },
        {
          code: 'LU',
          name: 'Lushnjë District'
        },
        {
          code: 'MM',
          name: 'Malësi e Madhe District'
        },
        {
          code: 'MK',
          name: 'Mallakastër District'
        },
        {
          code: 'MT',
          name: 'Mat District'
        },
        {
          code: 'MR',
          name: 'Mirditë District'
        },
        {
          code: 'PQ',
          name: 'Peqin District'
        },
        {
          code: 'PR',
          name: 'Përmet District'
        },
        {
          code: 'PG',
          name: 'Pogradec District'
        },
        {
          code: 'PU',
          name: 'Pukë District'
        },
        {
          code: 'SR',
          name: 'Sarandë District'
        },
        {
          code: '10',
          name: 'Shkodër County'
        },
        {
          code: 'SH',
          name: 'Shkodër District'
        },
        {
          code: 'SK',
          name: 'Skrapar District'
        },
        {
          code: 'TE',
          name: 'Tepelenë District'
        },
        {
          code: '11',
          name: 'Tirana County'
        },
        {
          code: 'TR',
          name: 'Tirana District'
        },
        {
          code: 'TP',
          name: 'Tropojë District'
        },
        {
          code: '12',
          name: 'Vlorë County'
        },
        {
          code: 'VL',
          name: 'Vlorë District'
        }
      ]
    },
    {
      code: 'DZ',
      name: 'Algeria',
      states: [
        {
          code: '01',
          name: 'Adrar'
        },
        {
          code: '44',
          name: 'Aïn Defla'
        },
        {
          code: '46',
          name: 'Aïn Témouchent'
        },
        {
          code: '16',
          name: 'Algiers'
        },
        {
          code: '23',
          name: 'Annaba'
        },
        {
          code: '05',
          name: 'Batna'
        },
        {
          code: '08',
          name: 'Béchar'
        },
        {
          code: '06',
          name: 'Béjaïa'
        },
        {
          code: '53',
          name: 'Béni Abbès'
        },
        {
          code: '07',
          name: 'Biskra'
        },
        {
          code: '09',
          name: 'Blida'
        },
        {
          code: '52',
          name: 'Bordj Baji Mokhtar'
        },
        {
          code: '34',
          name: 'Bordj Bou Arréridj'
        },
        {
          code: '10',
          name: 'Bouïra'
        },
        {
          code: '35',
          name: 'Boumerdès'
        },
        {
          code: '02',
          name: 'Chlef'
        },
        {
          code: '25',
          name: 'Constantine'
        },
        {
          code: '56',
          name: 'Djanet'
        },
        {
          code: '17',
          name: 'Djelfa'
        },
        {
          code: '32',
          name: 'El Bayadh'
        },
        {
          code: '49',
          name: "El M'ghair"
        },
        {
          code: '50',
          name: 'El Menia'
        },
        {
          code: '39',
          name: 'El Oued'
        },
        {
          code: '36',
          name: 'El Tarf'
        },
        {
          code: '47',
          name: 'Ghardaïa'
        },
        {
          code: '24',
          name: 'Guelma'
        },
        {
          code: '33',
          name: 'Illizi'
        },
        {
          code: '58',
          name: 'In Guezzam'
        },
        {
          code: '57',
          name: 'In Salah'
        },
        {
          code: '18',
          name: 'Jijel'
        },
        {
          code: '40',
          name: 'Khenchela'
        },
        {
          code: '03',
          name: 'Laghouat'
        },
        {
          code: '28',
          name: "M'Sila"
        },
        {
          code: '29',
          name: 'Mascara'
        },
        {
          code: '26',
          name: 'Médéa'
        },
        {
          code: '43',
          name: 'Mila'
        },
        {
          code: '27',
          name: 'Mostaganem'
        },
        {
          code: '45',
          name: 'Naama'
        },
        {
          code: '31',
          name: 'Oran'
        },
        {
          code: '30',
          name: 'Ouargla'
        },
        {
          code: '51',
          name: 'Ouled Djellal'
        },
        {
          code: '04',
          name: 'Oum El Bouaghi'
        },
        {
          code: '48',
          name: 'Relizane'
        },
        {
          code: '20',
          name: 'Saïda'
        },
        {
          code: '19',
          name: 'Sétif'
        },
        {
          code: '22',
          name: 'Sidi Bel Abbès'
        },
        {
          code: '21',
          name: 'Skikda'
        },
        {
          code: '41',
          name: 'Souk Ahras'
        },
        {
          code: '11',
          name: 'Tamanghasset'
        },
        {
          code: '12',
          name: 'Tébessa'
        },
        {
          code: '14',
          name: 'Tiaret'
        },
        {
          code: '54',
          name: 'Timimoun'
        },
        {
          code: '37',
          name: 'Tindouf'
        },
        {
          code: '42',
          name: 'Tipasa'
        },
        {
          code: '38',
          name: 'Tissemsilt'
        },
        {
          code: '15',
          name: 'Tizi Ouzou'
        },
        {
          code: '13',
          name: 'Tlemcen'
        },
        {
          code: '55',
          name: 'Touggourt'
        }
      ]
    },
    {
      code: 'AS',
      name: 'American Samoa',
      states: []
    },
    {
      code: 'AD',
      name: 'Andorra',
      states: [
        {
          code: '07',
          name: 'Andorra la Vella'
        },
        {
          code: '02',
          name: 'Canillo'
        },
        {
          code: '03',
          name: 'Encamp'
        },
        {
          code: '08',
          name: 'Escaldes-Engordany'
        },
        {
          code: '04',
          name: 'La Massana'
        },
        {
          code: '05',
          name: 'Ordino'
        },
        {
          code: '06',
          name: 'Sant Julià de Lòria'
        }
      ]
    },
    {
      code: 'AO',
      name: 'Angola',
      states: [
        {
          code: 'BGO',
          name: 'Bengo Province'
        },
        {
          code: 'BGU',
          name: 'Benguela Province'
        },
        {
          code: 'BIE',
          name: 'Bié Province'
        },
        {
          code: 'CAB',
          name: 'Cabinda Province'
        },
        {
          code: 'CCU',
          name: 'Cuando Cubango Province'
        },
        {
          code: 'CNO',
          name: 'Cuanza Norte Province'
        },
        {
          code: 'CUS',
          name: 'Cuanza Sul'
        },
        {
          code: 'CNN',
          name: 'Cunene Province'
        },
        {
          code: 'HUA',
          name: 'Huambo Province'
        },
        {
          code: 'HUI',
          name: 'Huíla Province'
        },
        {
          code: 'LUA',
          name: 'Luanda Province'
        },
        {
          code: 'LNO',
          name: 'Lunda Norte Province'
        },
        {
          code: 'LSU',
          name: 'Lunda Sul Province'
        },
        {
          code: 'MAL',
          name: 'Malanje Province'
        },
        {
          code: 'MOX',
          name: 'Moxico Province'
        },
        {
          code: 'UIG',
          name: 'Uíge Province'
        },
        {
          code: 'ZAI',
          name: 'Zaire Province'
        }
      ]
    },
    {
      code: 'AI',
      name: 'Anguilla',
      states: []
    },
    {
      code: 'AQ',
      name: 'Antarctica',
      states: []
    },
    {
      code: 'AG',
      name: 'Antigua and Barbuda',
      states: [
        {
          code: '10',
          name: 'Barbuda'
        },
        {
          code: '11',
          name: 'Redonda'
        },
        {
          code: '03',
          name: 'Saint George Parish'
        },
        {
          code: '04',
          name: 'Saint John Parish'
        },
        {
          code: '05',
          name: 'Saint Mary Parish'
        },
        {
          code: '06',
          name: 'Saint Paul Parish'
        },
        {
          code: '07',
          name: 'Saint Peter Parish'
        },
        {
          code: '08',
          name: 'Saint Philip Parish'
        }
      ]
    },
    {
      code: 'AR',
      name: 'Argentina',
      states: [
        {
          code: 'B',
          name: 'Buenos Aires'
        },
        {
          code: 'K',
          name: 'Catamarca'
        },
        {
          code: 'H',
          name: 'Chaco'
        },
        {
          code: 'U',
          name: 'Chubut'
        },
        {
          code: 'C',
          name: 'Ciudad Autónoma de Buenos Aires'
        },
        {
          code: 'X',
          name: 'Córdoba'
        },
        {
          code: 'W',
          name: 'Corrientes'
        },
        {
          code: 'E',
          name: 'Entre Ríos'
        },
        {
          code: 'P',
          name: 'Formosa'
        },
        {
          code: 'Y',
          name: 'Jujuy'
        },
        {
          code: 'L',
          name: 'La Pampa'
        },
        {
          code: 'F',
          name: 'La Rioja'
        },
        {
          code: 'M',
          name: 'Mendoza'
        },
        {
          code: 'N',
          name: 'Misiones'
        },
        {
          code: 'Q',
          name: 'Neuquén'
        },
        {
          code: 'R',
          name: 'Río Negro'
        },
        {
          code: 'A',
          name: 'Salta'
        },
        {
          code: 'J',
          name: 'San Juan'
        },
        {
          code: 'D',
          name: 'San Luis'
        },
        {
          code: 'Z',
          name: 'Santa Cruz'
        },
        {
          code: 'S',
          name: 'Santa Fe'
        },
        {
          code: 'G',
          name: 'Santiago del Estero'
        },
        {
          code: 'V',
          name: 'Tierra del Fuego'
        },
        {
          code: 'T',
          name: 'Tucumán'
        }
      ]
    },
    {
      code: 'AM',
      name: 'Armenia',
      states: [
        {
          code: 'AG',
          name: 'Aragatsotn Region'
        },
        {
          code: 'AR',
          name: 'Ararat Province'
        },
        {
          code: 'AV',
          name: 'Armavir Region'
        },
        {
          code: 'GR',
          name: 'Gegharkunik Province'
        },
        {
          code: 'KT',
          name: 'Kotayk Region'
        },
        {
          code: 'LO',
          name: 'Lori Region'
        },
        {
          code: 'SH',
          name: 'Shirak Region'
        },
        {
          code: 'SU',
          name: 'Syunik Province'
        },
        {
          code: 'TV',
          name: 'Tavush Region'
        },
        {
          code: 'VD',
          name: 'Vayots Dzor Region'
        },
        {
          code: 'ER',
          name: 'Yerevan'
        }
      ]
    },
    {
      code: 'AW',
      name: 'Aruba',
      states: []
    },
    {
      code: 'AU',
      name: 'Australia',
      states: [
        {
          code: 'ACT',
          name: 'Australian Capital Territory'
        },
        {
          code: 'NSW',
          name: 'New South Wales'
        },
        {
          code: 'NT',
          name: 'Northern Territory'
        },
        {
          code: 'QLD',
          name: 'Queensland'
        },
        {
          code: 'SA',
          name: 'South Australia'
        },
        {
          code: 'TAS',
          name: 'Tasmania'
        },
        {
          code: 'VIC',
          name: 'Victoria'
        },
        {
          code: 'WA',
          name: 'Western Australia'
        }
      ]
    },
    {
      code: 'AT',
      name: 'Austria',
      states: [
        {
          code: '1',
          name: 'Burgenland'
        },
        {
          code: '2',
          name: 'Carinthia'
        },
        {
          code: '3',
          name: 'Lower Austria'
        },
        {
          code: '5',
          name: 'Salzburg'
        },
        {
          code: '6',
          name: 'Styria'
        },
        {
          code: '7',
          name: 'Tyrol'
        },
        {
          code: '4',
          name: 'Upper Austria'
        },
        {
          code: '9',
          name: 'Vienna'
        },
        {
          code: '8',
          name: 'Vorarlberg'
        }
      ]
    },
    {
      code: 'AZ',
      name: 'Azerbaijan',
      states: [
        {
          code: 'ABS',
          name: 'Absheron District'
        },
        {
          code: 'AGM',
          name: 'Agdam District'
        },
        {
          code: 'AGS',
          name: 'Agdash District'
        },
        {
          code: 'AGC',
          name: 'Aghjabadi District'
        },
        {
          code: 'AGA',
          name: 'Agstafa District'
        },
        {
          code: 'AGU',
          name: 'Agsu District'
        },
        {
          code: 'AST',
          name: 'Astara District'
        },
        {
          code: 'BAB',
          name: 'Babek District'
        },
        {
          code: 'BA',
          name: 'Baku'
        },
        {
          code: 'BAL',
          name: 'Balakan District'
        },
        {
          code: 'BAR',
          name: 'Barda District'
        },
        {
          code: 'BEY',
          name: 'Beylagan District'
        },
        {
          code: 'BIL',
          name: 'Bilasuvar District'
        },
        {
          code: 'DAS',
          name: 'Dashkasan District'
        },
        {
          code: 'FUZ',
          name: 'Fizuli District'
        },
        {
          code: 'GA',
          name: 'Ganja'
        },
        {
          code: 'GAD',
          name: 'Gədəbəy'
        },
        {
          code: 'QOB',
          name: 'Gobustan District'
        },
        {
          code: 'GOR',
          name: 'Goranboy District'
        },
        {
          code: 'GOY',
          name: 'Goychay'
        },
        {
          code: 'GYG',
          name: 'Goygol District'
        },
        {
          code: 'HAC',
          name: 'Hajigabul District'
        },
        {
          code: 'IMI',
          name: 'Imishli District'
        },
        {
          code: 'ISM',
          name: 'Ismailli District'
        },
        {
          code: 'CAB',
          name: 'Jabrayil District'
        },
        {
          code: 'CAL',
          name: 'Jalilabad District'
        },
        {
          code: 'CUL',
          name: 'Julfa District'
        },
        {
          code: 'KAL',
          name: 'Kalbajar District'
        },
        {
          code: 'KAN',
          name: 'Kangarli District'
        },
        {
          code: 'XAC',
          name: 'Khachmaz District'
        },
        {
          code: 'XIZ',
          name: 'Khizi District'
        },
        {
          code: 'XCI',
          name: 'Khojali District'
        },
        {
          code: 'KUR',
          name: 'Kurdamir District'
        },
        {
          code: 'LAC',
          name: 'Lachin District'
        },
        {
          code: 'LAN',
          name: 'Lankaran'
        },
        {
          code: 'LA',
          name: 'Lankaran District'
        },
        {
          code: 'LER',
          name: 'Lerik District'
        },
        {
          code: 'XVD',
          name: 'Martuni'
        },
        {
          code: 'MAS',
          name: 'Masally District'
        },
        {
          code: 'MI',
          name: 'Mingachevir'
        },
        {
          code: 'NX',
          name: 'Nakhchivan Autonomous Republic'
        },
        {
          code: 'NEF',
          name: 'Neftchala District'
        },
        {
          code: 'OGU',
          name: 'Oghuz District'
        },
        {
          code: 'ORD',
          name: 'Ordubad District'
        },
        {
          code: 'QAB',
          name: 'Qabala District'
        },
        {
          code: 'QAX',
          name: 'Qakh District'
        },
        {
          code: 'QAZ',
          name: 'Qazakh District'
        },
        {
          code: 'QBA',
          name: 'Quba District'
        },
        {
          code: 'QBI',
          name: 'Qubadli District'
        },
        {
          code: 'QUS',
          name: 'Qusar District'
        },
        {
          code: 'SAT',
          name: 'Saatly District'
        },
        {
          code: 'SAB',
          name: 'Sabirabad District'
        },
        {
          code: 'SAD',
          name: 'Sadarak District'
        },
        {
          code: 'SAL',
          name: 'Salyan District'
        },
        {
          code: 'SMX',
          name: 'Samukh District'
        },
        {
          code: 'SBN',
          name: 'Shabran District'
        },
        {
          code: 'SAH',
          name: 'Shahbuz District'
        },
        {
          code: 'SA',
          name: 'Shaki'
        },
        {
          code: 'SAK',
          name: 'Shaki District'
        },
        {
          code: 'SMI',
          name: 'Shamakhi District'
        },
        {
          code: 'SKR',
          name: 'Shamkir District'
        },
        {
          code: 'SAR',
          name: 'Sharur District'
        },
        {
          code: 'SR',
          name: 'Shirvan'
        },
        {
          code: 'SUS',
          name: 'Shusha District'
        },
        {
          code: 'SIY',
          name: 'Siazan District'
        },
        {
          code: 'SM',
          name: 'Sumqayit'
        },
        {
          code: 'TAR',
          name: 'Tartar District'
        },
        {
          code: 'TOV',
          name: 'Tovuz District'
        },
        {
          code: 'UCA',
          name: 'Ujar District'
        },
        {
          code: 'YAR',
          name: 'Yardymli District'
        },
        {
          code: 'YE',
          name: 'Yevlakh'
        },
        {
          code: 'YEV',
          name: 'Yevlakh District'
        },
        {
          code: 'ZAN',
          name: 'Zangilan District'
        },
        {
          code: 'ZAQ',
          name: 'Zaqatala District'
        },
        {
          code: 'ZAR',
          name: 'Zardab District'
        }
      ]
    },
    {
      code: 'BH',
      name: 'Bahrain',
      states: [
        {
          code: '13',
          name: 'Capital'
        },
        {
          code: '16',
          name: 'Central'
        },
        {
          code: '15',
          name: 'Muharraq'
        },
        {
          code: '17',
          name: 'Northern'
        },
        {
          code: '14',
          name: 'Southern'
        }
      ]
    },
    {
      code: 'BD',
      name: 'Bangladesh',
      states: [
        {
          code: '05',
          name: 'Bagerhat District'
        },
        {
          code: '33',
          name: 'Bahadia'
        },
        {
          code: '01',
          name: 'Bandarban District'
        },
        {
          code: '02',
          name: 'Barguna District'
        },
        {
          code: '06',
          name: 'Barisal District'
        },
        {
          code: 'A',
          name: 'Barisal Division'
        },
        {
          code: '07',
          name: 'Bhola District'
        },
        {
          code: '03',
          name: 'Bogra District'
        },
        {
          code: '04',
          name: 'Brahmanbaria District'
        },
        {
          code: '09',
          name: 'Chandpur District'
        },
        {
          code: '45',
          name: 'Chapai Nawabganj District'
        },
        {
          code: '10',
          name: 'Chittagong District'
        },
        {
          code: 'B',
          name: 'Chittagong Division'
        },
        {
          code: '12',
          name: 'Chuadanga District'
        },
        {
          code: '08',
          name: 'Comilla District'
        },
        {
          code: '11',
          name: "Cox's Bazar District"
        },
        {
          code: '13',
          name: 'Dhaka District'
        },
        {
          code: 'C',
          name: 'Dhaka Division'
        },
        {
          code: '14',
          name: 'Dinajpur District'
        },
        {
          code: '15',
          name: 'Faridpur District'
        },
        {
          code: '16',
          name: 'Feni District'
        },
        {
          code: '19',
          name: 'Gaibandha District'
        },
        {
          code: '18',
          name: 'Gazipur District'
        },
        {
          code: '17',
          name: 'Gopalganj District'
        },
        {
          code: '20',
          name: 'Habiganj District'
        },
        {
          code: '21',
          name: 'Jamalpur District'
        },
        {
          code: '22',
          name: 'Jessore District'
        },
        {
          code: '25',
          name: 'Jhalokati District'
        },
        {
          code: '23',
          name: 'Jhenaidah District'
        },
        {
          code: '24',
          name: 'Joypurhat District'
        },
        {
          code: '29',
          name: 'Khagrachari District'
        },
        {
          code: '27',
          name: 'Khulna District'
        },
        {
          code: 'D',
          name: 'Khulna Division'
        },
        {
          code: '26',
          name: 'Kishoreganj District'
        },
        {
          code: '28',
          name: 'Kurigram District'
        },
        {
          code: '30',
          name: 'Kushtia District'
        },
        {
          code: '31',
          name: 'Lakshmipur District'
        },
        {
          code: '32',
          name: 'Lalmonirhat District'
        },
        {
          code: '36',
          name: 'Madaripur District'
        },
        {
          code: '39',
          name: 'Meherpur District'
        },
        {
          code: '38',
          name: 'Moulvibazar District'
        },
        {
          code: '35',
          name: 'Munshiganj District'
        },
        {
          code: '34',
          name: 'Mymensingh District'
        },
        {
          code: 'H',
          name: 'Mymensingh Division'
        },
        {
          code: '48',
          name: 'Naogaon District'
        },
        {
          code: '43',
          name: 'Narail District'
        },
        {
          code: '40',
          name: 'Narayanganj District'
        },
        {
          code: '44',
          name: 'Natore District'
        },
        {
          code: '41',
          name: 'Netrokona District'
        },
        {
          code: '46',
          name: 'Nilphamari District'
        },
        {
          code: '47',
          name: 'Noakhali District'
        },
        {
          code: '49',
          name: 'Pabna District'
        },
        {
          code: '52',
          name: 'Panchagarh District'
        },
        {
          code: '51',
          name: 'Patuakhali District'
        },
        {
          code: '50',
          name: 'Pirojpur District'
        },
        {
          code: '53',
          name: 'Rajbari District'
        },
        {
          code: '54',
          name: 'Rajshahi District'
        },
        {
          code: 'E',
          name: 'Rajshahi Division'
        },
        {
          code: '56',
          name: 'Rangamati Hill District'
        },
        {
          code: '55',
          name: 'Rangpur District'
        },
        {
          code: 'F',
          name: 'Rangpur Division'
        },
        {
          code: '58',
          name: 'Satkhira District'
        },
        {
          code: '62',
          name: 'Shariatpur District'
        },
        {
          code: '57',
          name: 'Sherpur District'
        },
        {
          code: '59',
          name: 'Sirajganj District'
        },
        {
          code: '61',
          name: 'Sunamganj District'
        },
        {
          code: '60',
          name: 'Sylhet District'
        },
        {
          code: 'G',
          name: 'Sylhet Division'
        },
        {
          code: '63',
          name: 'Tangail District'
        },
        {
          code: '64',
          name: 'Thakurgaon District'
        }
      ]
    },
    {
      code: 'BB',
      name: 'Barbados',
      states: [
        {
          code: '01',
          name: 'Christ Church'
        },
        {
          code: '02',
          name: 'Saint Andrew'
        },
        {
          code: '03',
          name: 'Saint George'
        },
        {
          code: '04',
          name: 'Saint James'
        },
        {
          code: '05',
          name: 'Saint John'
        },
        {
          code: '06',
          name: 'Saint Joseph'
        },
        {
          code: '07',
          name: 'Saint Lucy'
        },
        {
          code: '08',
          name: 'Saint Michael'
        },
        {
          code: '09',
          name: 'Saint Peter'
        },
        {
          code: '10',
          name: 'Saint Philip'
        },
        {
          code: '11',
          name: 'Saint Thomas'
        }
      ]
    },
    {
      code: 'BY',
      name: 'Belarus',
      states: [
        {
          code: 'BR',
          name: 'Brest Region'
        },
        {
          code: 'HO',
          name: 'Gomel Region'
        },
        {
          code: 'HR',
          name: 'Grodno Region'
        },
        {
          code: 'HM',
          name: 'Minsk'
        },
        {
          code: 'MI',
          name: 'Minsk Region'
        },
        {
          code: 'MA',
          name: 'Mogilev Region'
        },
        {
          code: 'VI',
          name: 'Vitebsk Region'
        }
      ]
    },
    {
      code: 'BE',
      name: 'Belgium',
      states: [
        {
          code: 'VAN',
          name: 'Antwerp'
        },
        {
          code: 'BRU',
          name: 'Brussels-Capital Region'
        },
        {
          code: 'VOV',
          name: 'East Flanders'
        },
        {
          code: 'VLG',
          name: 'Flanders'
        },
        {
          code: 'VBR',
          name: 'Flemish Brabant'
        },
        {
          code: 'WHT',
          name: 'Hainaut'
        },
        {
          code: 'WLG',
          name: 'Liège'
        },
        {
          code: 'VLI',
          name: 'Limburg'
        },
        {
          code: 'WLX',
          name: 'Luxembourg'
        },
        {
          code: 'WNA',
          name: 'Namur'
        },
        {
          code: 'WAL',
          name: 'Wallonia'
        },
        {
          code: 'WBR',
          name: 'Walloon Brabant'
        },
        {
          code: 'VWV',
          name: 'West Flanders'
        }
      ]
    },
    {
      code: 'BZ',
      name: 'Belize',
      states: [
        {
          code: 'BZ',
          name: 'Belize District'
        },
        {
          code: 'CY',
          name: 'Cayo District'
        },
        {
          code: 'CZL',
          name: 'Corozal District'
        },
        {
          code: 'OW',
          name: 'Orange Walk District'
        },
        {
          code: 'SC',
          name: 'Stann Creek District'
        },
        {
          code: 'TOL',
          name: 'Toledo District'
        }
      ]
    },
    {
      code: 'BJ',
      name: 'Benin',
      states: [
        {
          code: 'AL',
          name: 'Alibori Department'
        },
        {
          code: 'AK',
          name: 'Atakora Department'
        },
        {
          code: 'AQ',
          name: 'Atlantique Department'
        },
        {
          code: 'BO',
          name: 'Borgou Department'
        },
        {
          code: 'CO',
          name: 'Collines Department'
        },
        {
          code: 'DO',
          name: 'Donga Department'
        },
        {
          code: 'KO',
          name: 'Kouffo Department'
        },
        {
          code: 'LI',
          name: 'Littoral Department'
        },
        {
          code: 'MO',
          name: 'Mono Department'
        },
        {
          code: 'OU',
          name: 'Ouémé Department'
        },
        {
          code: 'PL',
          name: 'Plateau Department'
        },
        {
          code: 'ZO',
          name: 'Zou Department'
        }
      ]
    },
    {
      code: 'BM',
      name: 'Bermuda',
      states: [
        {
          code: 'DEV',
          name: 'Devonshire'
        },
        {
          code: 'HA',
          name: 'Hamilton'
        },
        {
          code: 'PAG',
          name: 'Paget'
        },
        {
          code: 'PEM',
          name: 'Pembroke'
        },
        {
          code: 'SGE',
          name: "Saint George's"
        },
        {
          code: 'SAN',
          name: 'Sandys'
        },
        {
          code: 'SMI',
          name: "Smith's"
        },
        {
          code: 'SOU',
          name: 'Southampton'
        },
        {
          code: 'WAR',
          name: 'Warwick'
        }
      ]
    },
    {
      code: 'BT',
      name: 'Bhutan',
      states: [
        {
          code: '33',
          name: 'Bumthang District'
        },
        {
          code: '12',
          name: 'Chukha District'
        },
        {
          code: '22',
          name: 'Dagana District'
        },
        {
          code: 'GA',
          name: 'Gasa District'
        },
        {
          code: '13',
          name: 'Haa District'
        },
        {
          code: '44',
          name: 'Lhuntse District'
        },
        {
          code: '42',
          name: 'Mongar District'
        },
        {
          code: '11',
          name: 'Paro District'
        },
        {
          code: '43',
          name: 'Pemagatshel District'
        },
        {
          code: '23',
          name: 'Punakha District'
        },
        {
          code: '45',
          name: 'Samdrup Jongkhar District'
        },
        {
          code: '14',
          name: 'Samtse District'
        },
        {
          code: '31',
          name: 'Sarpang District'
        },
        {
          code: '15',
          name: 'Thimphu District'
        },
        {
          code: '41',
          name: 'Trashigang District'
        },
        {
          code: '32',
          name: 'Trongsa District'
        },
        {
          code: '21',
          name: 'Tsirang District'
        },
        {
          code: '24',
          name: 'Wangdue Phodrang District'
        },
        {
          code: '34',
          name: 'Zhemgang District'
        }
      ]
    },
    {
      code: 'BO',
      name: 'Bolivia',
      states: [
        {
          code: 'B',
          name: 'Beni Department'
        },
        {
          code: 'H',
          name: 'Chuquisaca Department'
        },
        {
          code: 'C',
          name: 'Cochabamba Department'
        },
        {
          code: 'L',
          name: 'La Paz Department'
        },
        {
          code: 'O',
          name: 'Oruro Department'
        },
        {
          code: 'N',
          name: 'Pando Department'
        },
        {
          code: 'P',
          name: 'Potosí Department'
        },
        {
          code: 'S',
          name: 'Santa Cruz Department'
        },
        {
          code: 'T',
          name: 'Tarija Department'
        }
      ]
    },
    {
      code: 'BQ',
      name: 'Bonaire, Sint Eustatius and Saba',
      states: [
        {
          code: 'BQ1',
          name: 'Bonaire'
        },
        {
          code: 'BQ2',
          name: 'Saba'
        },
        {
          code: 'BQ3',
          name: 'Sint Eustatius'
        }
      ]
    },
    {
      code: 'BA',
      name: 'Bosnia and Herzegovina',
      states: [
        {
          code: '05',
          name: 'Bosnian Podrinje Canton'
        },
        {
          code: 'BRC',
          name: 'Brčko District'
        },
        {
          code: '10',
          name: 'Canton 10'
        },
        {
          code: '06',
          name: 'Central Bosnia Canton'
        },
        {
          code: 'BIH',
          name: 'Federation of Bosnia and Herzegovina'
        },
        {
          code: '07',
          name: 'Herzegovina-Neretva Canton'
        },
        {
          code: '02',
          name: 'Posavina Canton'
        },
        {
          code: 'SRP',
          name: 'Republika Srpska'
        },
        {
          code: '09',
          name: 'Sarajevo Canton'
        },
        {
          code: '03',
          name: 'Tuzla Canton'
        },
        {
          code: '01',
          name: 'Una-Sana Canton'
        },
        {
          code: '08',
          name: 'West Herzegovina Canton'
        },
        {
          code: '04',
          name: 'Zenica-Doboj Canton'
        }
      ]
    },
    {
      code: 'BW',
      name: 'Botswana',
      states: [
        {
          code: 'CE',
          name: 'Central District'
        },
        {
          code: 'GH',
          name: 'Ghanzi District'
        },
        {
          code: 'KG',
          name: 'Kgalagadi District'
        },
        {
          code: 'KL',
          name: 'Kgatleng District'
        },
        {
          code: 'KW',
          name: 'Kweneng District'
        },
        {
          code: 'NG',
          name: 'Ngamiland'
        },
        {
          code: 'NE',
          name: 'North-East District'
        },
        {
          code: 'NW',
          name: 'North-West District'
        },
        {
          code: 'SE',
          name: 'South-East District'
        },
        {
          code: 'SO',
          name: 'Southern District'
        }
      ]
    },
    {
      code: 'BV',
      name: 'Bouvet Island',
      states: []
    },
    {
      code: 'BR',
      name: 'Brazil',
      states: [
        {
          code: 'AC',
          name: 'Acre'
        },
        {
          code: 'AL',
          name: 'Alagoas'
        },
        {
          code: 'AP',
          name: 'Amapá'
        },
        {
          code: 'AM',
          name: 'Amazonas'
        },
        {
          code: 'BA',
          name: 'Bahia'
        },
        {
          code: 'CE',
          name: 'Ceará'
        },
        {
          code: 'DF',
          name: 'Distrito Federal'
        },
        {
          code: 'ES',
          name: 'Espírito Santo'
        },
        {
          code: 'GO',
          name: 'Goiás'
        },
        {
          code: 'MA',
          name: 'Maranhão'
        },
        {
          code: 'MT',
          name: 'Mato Grosso'
        },
        {
          code: 'MS',
          name: 'Mato Grosso do Sul'
        },
        {
          code: 'MG',
          name: 'Minas Gerais'
        },
        {
          code: 'PA',
          name: 'Pará'
        },
        {
          code: 'PB',
          name: 'Paraíba'
        },
        {
          code: 'PR',
          name: 'Paraná'
        },
        {
          code: 'PE',
          name: 'Pernambuco'
        },
        {
          code: 'PI',
          name: 'Piauí'
        },
        {
          code: 'RJ',
          name: 'Rio de Janeiro'
        },
        {
          code: 'RN',
          name: 'Rio Grande do Norte'
        },
        {
          code: 'RS',
          name: 'Rio Grande do Sul'
        },
        {
          code: 'RO',
          name: 'Rondônia'
        },
        {
          code: 'RR',
          name: 'Roraima'
        },
        {
          code: 'SC',
          name: 'Santa Catarina'
        },
        {
          code: 'SP',
          name: 'São Paulo'
        },
        {
          code: 'SE',
          name: 'Sergipe'
        },
        {
          code: 'TO',
          name: 'Tocantins'
        }
      ]
    },
    {
      code: 'IO',
      name: 'British Indian Ocean Territory',
      states: []
    },
    {
      code: 'BN',
      name: 'Brunei',
      states: [
        {
          code: 'BE',
          name: 'Belait District'
        },
        {
          code: 'BM',
          name: 'Brunei-Muara District'
        },
        {
          code: 'TE',
          name: 'Temburong District'
        },
        {
          code: 'TU',
          name: 'Tutong District'
        }
      ]
    },
    {
      code: 'BG',
      name: 'Bulgaria',
      states: [
        {
          code: '01',
          name: 'Blagoevgrad Province'
        },
        {
          code: '02',
          name: 'Burgas Province'
        },
        {
          code: '08',
          name: 'Dobrich Province'
        },
        {
          code: '07',
          name: 'Gabrovo Province'
        },
        {
          code: '26',
          name: 'Haskovo Province'
        },
        {
          code: '09',
          name: 'Kardzhali Province'
        },
        {
          code: '10',
          name: 'Kyustendil Province'
        },
        {
          code: '11',
          name: 'Lovech Province'
        },
        {
          code: '12',
          name: 'Montana Province'
        },
        {
          code: '13',
          name: 'Pazardzhik Province'
        },
        {
          code: '14',
          name: 'Pernik Province'
        },
        {
          code: '15',
          name: 'Pleven Province'
        },
        {
          code: '16',
          name: 'Plovdiv Province'
        },
        {
          code: '17',
          name: 'Razgrad Province'
        },
        {
          code: '18',
          name: 'Ruse Province'
        },
        {
          code: '27',
          name: 'Shumen'
        },
        {
          code: '19',
          name: 'Silistra Province'
        },
        {
          code: '20',
          name: 'Sliven Province'
        },
        {
          code: '21',
          name: 'Smolyan Province'
        },
        {
          code: '22',
          name: 'Sofia City Province'
        },
        {
          code: '23',
          name: 'Sofia Province'
        },
        {
          code: '24',
          name: 'Stara Zagora Province'
        },
        {
          code: '25',
          name: 'Targovishte Province'
        },
        {
          code: '03',
          name: 'Varna Province'
        },
        {
          code: '04',
          name: 'Veliko Tarnovo Province'
        },
        {
          code: '05',
          name: 'Vidin Province'
        },
        {
          code: '06',
          name: 'Vratsa Province'
        },
        {
          code: '28',
          name: 'Yambol Province'
        }
      ]
    },
    {
      code: 'BF',
      name: 'Burkina Faso',
      states: [
        {
          code: 'BAL',
          name: 'Balé Province'
        },
        {
          code: 'BAM',
          name: 'Bam Province'
        },
        {
          code: 'BAN',
          name: 'Banwa Province'
        },
        {
          code: 'BAZ',
          name: 'Bazèga Province'
        },
        {
          code: '01',
          name: 'Boucle du Mouhoun Region'
        },
        {
          code: 'BGR',
          name: 'Bougouriba Province'
        },
        {
          code: 'BLG',
          name: 'Boulgou'
        },
        {
          code: '02',
          name: 'Cascades Region'
        },
        {
          code: '03',
          name: 'Centre'
        },
        {
          code: '04',
          name: 'Centre-Est Region'
        },
        {
          code: '05',
          name: 'Centre-Nord Region'
        },
        {
          code: '06',
          name: 'Centre-Ouest Region'
        },
        {
          code: '07',
          name: 'Centre-Sud Region'
        },
        {
          code: 'COM',
          name: 'Comoé Province'
        },
        {
          code: '08',
          name: 'Est Region'
        },
        {
          code: 'GAN',
          name: 'Ganzourgou Province'
        },
        {
          code: 'GNA',
          name: 'Gnagna Province'
        },
        {
          code: 'GOU',
          name: 'Gourma Province'
        },
        {
          code: '09',
          name: 'Hauts-Bassins Region'
        },
        {
          code: 'HOU',
          name: 'Houet Province'
        },
        {
          code: 'IOB',
          name: 'Ioba Province'
        },
        {
          code: 'KAD',
          name: 'Kadiogo Province'
        },
        {
          code: 'KEN',
          name: 'Kénédougou Province'
        },
        {
          code: 'KMD',
          name: 'Komondjari Province'
        },
        {
          code: 'KMP',
          name: 'Kompienga Province'
        },
        {
          code: 'KOS',
          name: 'Kossi Province'
        },
        {
          code: 'KOP',
          name: 'Koulpélogo Province'
        },
        {
          code: 'KOT',
          name: 'Kouritenga Province'
        },
        {
          code: 'KOW',
          name: 'Kourwéogo Province'
        },
        {
          code: 'LER',
          name: 'Léraba Province'
        },
        {
          code: 'LOR',
          name: 'Loroum Province'
        },
        {
          code: 'MOU',
          name: 'Mouhoun'
        },
        {
          code: 'NAO',
          name: 'Nahouri Province'
        },
        {
          code: 'NAM',
          name: 'Namentenga Province'
        },
        {
          code: 'NAY',
          name: 'Nayala Province'
        },
        {
          code: '10',
          name: 'Nord Region, Burkina Faso'
        },
        {
          code: 'NOU',
          name: 'Noumbiel Province'
        },
        {
          code: 'OUB',
          name: 'Oubritenga Province'
        },
        {
          code: 'OUD',
          name: 'Oudalan Province'
        },
        {
          code: 'PAS',
          name: 'Passoré Province'
        },
        {
          code: '11',
          name: 'Plateau-Central Region'
        },
        {
          code: 'PON',
          name: 'Poni Province'
        },
        {
          code: '12',
          name: 'Sahel Region'
        },
        {
          code: 'SNG',
          name: 'Sanguié Province'
        },
        {
          code: 'SMT',
          name: 'Sanmatenga Province'
        },
        {
          code: 'SEN',
          name: 'Séno Province'
        },
        {
          code: 'SIS',
          name: 'Sissili Province'
        },
        {
          code: 'SOM',
          name: 'Soum Province'
        },
        {
          code: 'SOR',
          name: 'Sourou Province'
        },
        {
          code: '13',
          name: 'Sud-Ouest Region'
        },
        {
          code: 'TAP',
          name: 'Tapoa Province'
        },
        {
          code: 'TUI',
          name: 'Tuy Province'
        },
        {
          code: 'YAG',
          name: 'Yagha Province'
        },
        {
          code: 'YAT',
          name: 'Yatenga Province'
        },
        {
          code: 'ZIR',
          name: 'Ziro Province'
        },
        {
          code: 'ZON',
          name: 'Zondoma Province'
        },
        {
          code: 'ZOU',
          name: 'Zoundwéogo Province'
        }
      ]
    },
    {
      code: 'BI',
      name: 'Burundi',
      states: [
        {
          code: 'BB',
          name: 'Bubanza Province'
        },
        {
          code: 'BM',
          name: 'Bujumbura Mairie Province'
        },
        {
          code: 'BL',
          name: 'Bujumbura Rural Province'
        },
        {
          code: 'BR',
          name: 'Bururi Province'
        },
        {
          code: 'CA',
          name: 'Cankuzo Province'
        },
        {
          code: 'CI',
          name: 'Cibitoke Province'
        },
        {
          code: 'GI',
          name: 'Gitega Province'
        },
        {
          code: 'KR',
          name: 'Karuzi Province'
        },
        {
          code: 'KY',
          name: 'Kayanza Province'
        },
        {
          code: 'KI',
          name: 'Kirundo Province'
        },
        {
          code: 'MA',
          name: 'Makamba Province'
        },
        {
          code: 'MU',
          name: 'Muramvya Province'
        },
        {
          code: 'MY',
          name: 'Muyinga Province'
        },
        {
          code: 'MW',
          name: 'Mwaro Province'
        },
        {
          code: 'NG',
          name: 'Ngozi Province'
        },
        {
          code: 'RM',
          name: 'Rumonge Province'
        },
        {
          code: 'RT',
          name: 'Rutana Province'
        },
        {
          code: 'RY',
          name: 'Ruyigi Province'
        }
      ]
    },
    {
      code: 'KH',
      name: 'Cambodia',
      states: [
        {
          code: '1',
          name: 'Banteay Meanchey'
        },
        {
          code: '2',
          name: 'Battambang'
        },
        {
          code: '3',
          name: 'Kampong Cham'
        },
        {
          code: '4',
          name: 'Kampong Chhnang'
        },
        {
          code: '5',
          name: 'Kampong Speu'
        },
        {
          code: '6',
          name: 'Kampong Thom'
        },
        {
          code: '7',
          name: 'Kampot'
        },
        {
          code: '8',
          name: 'Kandal'
        },
        {
          code: '23',
          name: 'Kep'
        },
        {
          code: '9',
          name: 'Koh Kong'
        },
        {
          code: '10',
          name: 'Kratie'
        },
        {
          code: '11',
          name: 'Mondulkiri'
        },
        {
          code: '22',
          name: 'Oddar Meanchey'
        },
        {
          code: '24',
          name: 'Pailin'
        },
        {
          code: '12',
          name: 'Phnom Penh'
        },
        {
          code: '13',
          name: 'Preah Vihear'
        },
        {
          code: '14',
          name: 'Prey Veng'
        },
        {
          code: '15',
          name: 'Pursat'
        },
        {
          code: '16',
          name: 'Ratanakiri'
        },
        {
          code: '17',
          name: 'Siem Reap'
        },
        {
          code: '18',
          name: 'Sihanoukville'
        },
        {
          code: '19',
          name: 'Stung Treng'
        },
        {
          code: '20',
          name: 'Svay Rieng'
        },
        {
          code: '21',
          name: 'Takeo'
        }
      ]
    },
    {
      code: 'CM',
      name: 'Cameroon',
      states: [
        {
          code: 'AD',
          name: 'Adamawa'
        },
        {
          code: 'CE',
          name: 'Centre'
        },
        {
          code: 'ES',
          name: 'East'
        },
        {
          code: 'EN',
          name: 'Far North'
        },
        {
          code: 'LT',
          name: 'Littoral'
        },
        {
          code: 'NO',
          name: 'North'
        },
        {
          code: 'NW',
          name: 'Northwest'
        },
        {
          code: 'SU',
          name: 'South'
        },
        {
          code: 'SW',
          name: 'Southwest'
        },
        {
          code: 'OU',
          name: 'West'
        }
      ]
    },
    {
      code: 'CA',
      name: 'Canada',
      states: [
        {
          code: 'AB',
          name: 'Alberta'
        },
        {
          code: 'BC',
          name: 'British Columbia'
        },
        {
          code: 'MB',
          name: 'Manitoba'
        },
        {
          code: 'NB',
          name: 'New Brunswick'
        },
        {
          code: 'NL',
          name: 'Newfoundland and Labrador'
        },
        {
          code: 'NT',
          name: 'Northwest Territories'
        },
        {
          code: 'NS',
          name: 'Nova Scotia'
        },
        {
          code: 'NU',
          name: 'Nunavut'
        },
        {
          code: 'ON',
          name: 'Ontario'
        },
        {
          code: 'PE',
          name: 'Prince Edward Island'
        },
        {
          code: 'QC',
          name: 'Quebec'
        },
        {
          code: 'SK',
          name: 'Saskatchewan'
        },
        {
          code: 'YT',
          name: 'Yukon'
        }
      ]
    },
    {
      code: 'CV',
      name: 'Cape Verde',
      states: [
        {
          code: 'B',
          name: 'Barlavento Islands'
        },
        {
          code: 'BV',
          name: 'Boa Vista'
        },
        {
          code: 'BR',
          name: 'Brava'
        },
        {
          code: 'MA',
          name: 'Maio Municipality'
        },
        {
          code: 'MO',
          name: 'Mosteiros'
        },
        {
          code: 'PA',
          name: 'Paul'
        },
        {
          code: 'PN',
          name: 'Porto Novo'
        },
        {
          code: 'PR',
          name: 'Praia'
        },
        {
          code: 'RB',
          name: 'Ribeira Brava Municipality'
        },
        {
          code: 'RG',
          name: 'Ribeira Grande'
        },
        {
          code: 'RS',
          name: 'Ribeira Grande de Santiago'
        },
        {
          code: 'SL',
          name: 'Sal'
        },
        {
          code: 'CA',
          name: 'Santa Catarina'
        },
        {
          code: 'CF',
          name: 'Santa Catarina do Fogo'
        },
        {
          code: 'CR',
          name: 'Santa Cruz'
        },
        {
          code: 'SD',
          name: 'São Domingos'
        },
        {
          code: 'SF',
          name: 'São Filipe'
        },
        {
          code: 'SO',
          name: 'São Lourenço dos Órgãos'
        },
        {
          code: 'SM',
          name: 'São Miguel'
        },
        {
          code: 'SV',
          name: 'São Vicente'
        },
        {
          code: 'S',
          name: 'Sotavento Islands'
        },
        {
          code: 'TA',
          name: 'Tarrafal'
        },
        {
          code: 'TS',
          name: 'Tarrafal de São Nicolau'
        }
      ]
    },
    {
      code: 'KY',
      name: 'Cayman Islands',
      states: []
    },
    {
      code: 'CF',
      name: 'Central African Republic',
      states: [
        {
          code: 'BB',
          name: 'Bamingui-Bangoran Prefecture'
        },
        {
          code: 'BGF',
          name: 'Bangui'
        },
        {
          code: 'BK',
          name: 'Basse-Kotto Prefecture'
        },
        {
          code: 'HM',
          name: 'Haut-Mbomou Prefecture'
        },
        {
          code: 'HK',
          name: 'Haute-Kotto Prefecture'
        },
        {
          code: 'KG',
          name: 'Kémo Prefecture'
        },
        {
          code: 'LB',
          name: 'Lobaye Prefecture'
        },
        {
          code: 'HS',
          name: 'Mambéré-Kadéï'
        },
        {
          code: 'MB',
          name: 'Mbomou Prefecture'
        },
        {
          code: 'KB',
          name: 'Nana-Grébizi Economic Prefecture'
        },
        {
          code: 'NM',
          name: 'Nana-Mambéré Prefecture'
        },
        {
          code: 'MP',
          name: "Ombella-M'Poko Prefecture"
        },
        {
          code: 'UK',
          name: 'Ouaka Prefecture'
        },
        {
          code: 'AC',
          name: 'Ouham Prefecture'
        },
        {
          code: 'OP',
          name: 'Ouham-Pendé Prefecture'
        },
        {
          code: 'SE',
          name: 'Sangha-Mbaéré'
        },
        {
          code: 'VK',
          name: 'Vakaga Prefecture'
        }
      ]
    },
    {
      code: 'TD',
      name: 'Chad',
      states: [
        {
          code: 'BG',
          name: 'Bahr el Gazel'
        },
        {
          code: 'BA',
          name: 'Batha'
        },
        {
          code: 'BO',
          name: 'Borkou'
        },
        {
          code: 'CB',
          name: 'Chari-Baguirmi'
        },
        {
          code: 'EE',
          name: 'Ennedi-Est'
        },
        {
          code: 'EO',
          name: 'Ennedi-Ouest'
        },
        {
          code: 'GR',
          name: 'Guéra'
        },
        {
          code: 'HL',
          name: 'Hadjer-Lamis'
        },
        {
          code: 'KA',
          name: 'Kanem'
        },
        {
          code: 'LC',
          name: 'Lac'
        },
        {
          code: 'LO',
          name: 'Logone Occidental'
        },
        {
          code: 'LR',
          name: 'Logone Oriental'
        },
        {
          code: 'MA',
          name: 'Mandoul'
        },
        {
          code: 'ME',
          name: 'Mayo-Kebbi Est'
        },
        {
          code: 'MO',
          name: 'Mayo-Kebbi Ouest'
        },
        {
          code: 'MC',
          name: 'Moyen-Chari'
        },
        {
          code: 'ND',
          name: "N'Djamena"
        },
        {
          code: 'OD',
          name: 'Ouaddaï'
        },
        {
          code: 'SA',
          name: 'Salamat'
        },
        {
          code: 'SI',
          name: 'Sila'
        },
        {
          code: 'TA',
          name: 'Tandjilé'
        },
        {
          code: 'TI',
          name: 'Tibesti'
        },
        {
          code: 'WF',
          name: 'Wadi Fira'
        }
      ]
    },
    {
      code: 'CL',
      name: 'Chile',
      states: [
        {
          code: 'AI',
          name: 'Aisén del General Carlos Ibañez del Campo'
        },
        {
          code: 'AN',
          name: 'Antofagasta'
        },
        {
          code: 'AP',
          name: 'Arica y Parinacota'
        },
        {
          code: 'AT',
          name: 'Atacama'
        },
        {
          code: 'BI',
          name: 'Biobío'
        },
        {
          code: 'CO',
          name: 'Coquimbo'
        },
        {
          code: 'AR',
          name: 'La Araucanía'
        },
        {
          code: 'LI',
          name: "Libertador General Bernardo O'Higgins"
        },
        {
          code: 'LL',
          name: 'Los Lagos'
        },
        {
          code: 'LR',
          name: 'Los Ríos'
        },
        {
          code: 'MA',
          name: 'Magallanes y de la Antártica Chilena'
        },
        {
          code: 'ML',
          name: 'Maule'
        },
        {
          code: 'NB',
          name: 'Ñuble'
        },
        {
          code: 'RM',
          name: 'Región Metropolitana de Santiago'
        },
        {
          code: 'TA',
          name: 'Tarapacá'
        },
        {
          code: 'VS',
          name: 'Valparaíso'
        }
      ]
    },
    {
      code: 'CN',
      name: 'China',
      states: [
        {
          code: 'AH',
          name: 'Anhui'
        },
        {
          code: 'BJ',
          name: 'Beijing'
        },
        {
          code: 'CQ',
          name: 'Chongqing'
        },
        {
          code: 'FJ',
          name: 'Fujian'
        },
        {
          code: 'GS',
          name: 'Gansu'
        },
        {
          code: 'GD',
          name: 'Guangdong'
        },
        {
          code: 'GX',
          name: 'Guangxi Zhuang'
        },
        {
          code: 'GZ',
          name: 'Guizhou'
        },
        {
          code: 'HI',
          name: 'Hainan'
        },
        {
          code: 'HE',
          name: 'Hebei'
        },
        {
          code: 'HL',
          name: 'Heilongjiang'
        },
        {
          code: 'HA',
          name: 'Henan'
        },
        {
          code: 'HK',
          name: 'Hong Kong SAR'
        },
        {
          code: 'HB',
          name: 'Hubei'
        },
        {
          code: 'HN',
          name: 'Hunan'
        },
        {
          code: 'NM',
          name: 'Inner Mongolia'
        },
        {
          code: 'JS',
          name: 'Jiangsu'
        },
        {
          code: 'JX',
          name: 'Jiangxi'
        },
        {
          code: 'JL',
          name: 'Jilin'
        },
        {
          code: 'LN',
          name: 'Liaoning'
        },
        {
          code: 'MO',
          name: 'Macau SAR'
        },
        {
          code: 'NX',
          name: 'Ningxia Huizu'
        },
        {
          code: 'QH',
          name: 'Qinghai'
        },
        {
          code: 'SN',
          name: 'Shaanxi'
        },
        {
          code: 'SD',
          name: 'Shandong'
        },
        {
          code: 'SH',
          name: 'Shanghai'
        },
        {
          code: 'SX',
          name: 'Shanxi'
        },
        {
          code: 'SC',
          name: 'Sichuan'
        },
        {
          code: 'TW',
          name: 'Taiwan'
        },
        {
          code: 'TJ',
          name: 'Tianjin'
        },
        {
          code: 'XJ',
          name: 'Xinjiang'
        },
        {
          code: 'XZ',
          name: 'Xizang'
        },
        {
          code: 'YN',
          name: 'Yunnan'
        },
        {
          code: 'ZJ',
          name: 'Zhejiang'
        }
      ]
    },
    {
      code: 'CX',
      name: 'Christmas Island',
      states: []
    },
    {
      code: 'CC',
      name: 'Cocos (Keeling) Islands',
      states: []
    },
    {
      code: 'CO',
      name: 'Colombia',
      states: [
        {
          code: 'AMA',
          name: 'Amazonas'
        },
        {
          code: 'ANT',
          name: 'Antioquia'
        },
        {
          code: 'ARA',
          name: 'Arauca'
        },
        {
          code: 'SAP',
          name: 'Archipiélago de San Andrés, Providencia y Santa Catalina'
        },
        {
          code: 'ATL',
          name: 'Atlántico'
        },
        {
          code: 'DC',
          name: 'Bogotá D.C.'
        },
        {
          code: 'BOL',
          name: 'Bolívar'
        },
        {
          code: 'BOY',
          name: 'Boyacá'
        },
        {
          code: 'CAL',
          name: 'Caldas'
        },
        {
          code: 'CAQ',
          name: 'Caquetá'
        },
        {
          code: 'CAS',
          name: 'Casanare'
        },
        {
          code: 'CAU',
          name: 'Cauca'
        },
        {
          code: 'CES',
          name: 'Cesar'
        },
        {
          code: 'CHO',
          name: 'Chocó'
        },
        {
          code: 'COR',
          name: 'Córdoba'
        },
        {
          code: 'CUN',
          name: 'Cundinamarca'
        },
        {
          code: 'GUA',
          name: 'Guainía'
        },
        {
          code: 'GUV',
          name: 'Guaviare'
        },
        {
          code: 'HUI',
          name: 'Huila'
        },
        {
          code: 'LAG',
          name: 'La Guajira'
        },
        {
          code: 'MAG',
          name: 'Magdalena'
        },
        {
          code: 'MET',
          name: 'Meta'
        },
        {
          code: 'NAR',
          name: 'Nariño'
        },
        {
          code: 'NSA',
          name: 'Norte de Santander'
        },
        {
          code: 'PUT',
          name: 'Putumayo'
        },
        {
          code: 'QUI',
          name: 'Quindío'
        },
        {
          code: 'RIS',
          name: 'Risaralda'
        },
        {
          code: 'SAN',
          name: 'Santander'
        },
        {
          code: 'SUC',
          name: 'Sucre'
        },
        {
          code: 'TOL',
          name: 'Tolima'
        },
        {
          code: 'VAC',
          name: 'Valle del Cauca'
        },
        {
          code: 'VAU',
          name: 'Vaupés'
        },
        {
          code: 'VID',
          name: 'Vichada'
        }
      ]
    },
    {
      code: 'KM',
      name: 'Comoros',
      states: [
        {
          code: 'A',
          name: 'Anjouan'
        },
        {
          code: 'G',
          name: 'Grande Comore'
        },
        {
          code: 'M',
          name: 'Mohéli'
        }
      ]
    },
    {
      code: 'CG',
      name: 'Congo',
      states: [
        {
          code: '11',
          name: 'Bouenza Department'
        },
        {
          code: 'BZV',
          name: 'Brazzaville'
        },
        {
          code: '8',
          name: 'Cuvette Department'
        },
        {
          code: '15',
          name: 'Cuvette-Ouest Department'
        },
        {
          code: '5',
          name: 'Kouilou Department'
        },
        {
          code: '2',
          name: 'Lékoumou Department'
        },
        {
          code: '7',
          name: 'Likouala Department'
        },
        {
          code: '9',
          name: 'Niari Department'
        },
        {
          code: '14',
          name: 'Plateaux Department'
        },
        {
          code: '16',
          name: 'Pointe-Noire'
        },
        {
          code: '12',
          name: 'Pool Department'
        },
        {
          code: '13',
          name: 'Sangha Department'
        }
      ]
    },
    {
      code: 'CK',
      name: 'Cook Islands',
      states: []
    },
    {
      code: 'CR',
      name: 'Costa Rica',
      states: [
        {
          code: 'A',
          name: 'Alajuela Province'
        },
        {
          code: 'G',
          name: 'Guanacaste Province'
        },
        {
          code: 'H',
          name: 'Heredia Province'
        },
        {
          code: 'L',
          name: 'Limón Province'
        },
        {
          code: 'C',
          name: 'Provincia de Cartago'
        },
        {
          code: 'P',
          name: 'Puntarenas Province'
        },
        {
          code: 'SJ',
          name: 'San José Province'
        }
      ]
    },
    {
      code: 'CI',
      name: "Cote D'Ivoire (Ivory Coast)",
      states: [
        {
          code: 'AB',
          name: 'Abidjan'
        },
        {
          code: '16',
          name: 'Agnéby'
        },
        {
          code: '17',
          name: 'Bafing Region'
        },
        {
          code: 'BS',
          name: 'Bas-Sassandra District'
        },
        {
          code: '09',
          name: 'Bas-Sassandra Region'
        },
        {
          code: 'CM',
          name: 'Comoé District'
        },
        {
          code: 'DN',
          name: 'Denguélé District'
        },
        {
          code: '10',
          name: 'Denguélé Region'
        },
        {
          code: '06',
          name: 'Dix-Huit Montagnes'
        },
        {
          code: '18',
          name: 'Fromager'
        },
        {
          code: 'GD',
          name: 'Gôh-Djiboua District'
        },
        {
          code: '02',
          name: 'Haut-Sassandra'
        },
        {
          code: 'LC',
          name: 'Lacs District'
        },
        {
          code: '07',
          name: 'Lacs Region'
        },
        {
          code: 'LG',
          name: 'Lagunes District'
        },
        {
          code: '01',
          name: 'Lagunes region'
        },
        {
          code: '12',
          name: 'Marahoué Region'
        },
        {
          code: 'MG',
          name: 'Montagnes District'
        },
        {
          code: '19',
          name: 'Moyen-Cavally'
        },
        {
          code: '05',
          name: 'Moyen-Comoé'
        },
        {
          code: '11',
          name: "N'zi-Comoé"
        },
        {
          code: 'SM',
          name: 'Sassandra-Marahoué District'
        },
        {
          code: '03',
          name: 'Savanes Region'
        },
        {
          code: '15',
          name: 'Sud-Bandama'
        },
        {
          code: '13',
          name: 'Sud-Comoé'
        },
        {
          code: 'VB',
          name: 'Vallée du Bandama District'
        },
        {
          code: '04',
          name: 'Vallée du Bandama Region'
        },
        {
          code: 'WR',
          name: 'Woroba District'
        },
        {
          code: '14',
          name: 'Worodougou'
        },
        {
          code: 'YM',
          name: 'Yamoussoukro'
        },
        {
          code: 'ZZ',
          name: 'Zanzan Region'
        }
      ]
    },
    {
      code: 'HR',
      name: 'Croatia',
      states: [
        {
          code: '07',
          name: 'Bjelovar-Bilogora'
        },
        {
          code: '12',
          name: 'Brod-Posavina'
        },
        {
          code: '19',
          name: 'Dubrovnik-Neretva'
        },
        {
          code: '18',
          name: 'Istria'
        },
        {
          code: '04',
          name: 'Karlovac'
        },
        {
          code: '06',
          name: 'Koprivnica-Križevci'
        },
        {
          code: '02',
          name: 'Krapina-Zagorje'
        },
        {
          code: '09',
          name: 'Lika-Senj'
        },
        {
          code: '20',
          name: 'Međimurje'
        },
        {
          code: '14',
          name: 'Osijek-Baranja'
        },
        {
          code: '11',
          name: 'Požega-Slavonia'
        },
        {
          code: '08',
          name: 'Primorje-Gorski Kotar'
        },
        {
          code: '15',
          name: 'Šibenik-Knin'
        },
        {
          code: '03',
          name: 'Sisak-Moslavina'
        },
        {
          code: '17',
          name: 'Split-Dalmatia'
        },
        {
          code: '05',
          name: 'Varaždin'
        },
        {
          code: '10',
          name: 'Virovitica-Podravina'
        },
        {
          code: '16',
          name: 'Vukovar-Syrmia'
        },
        {
          code: '13',
          name: 'Zadar'
        },
        {
          code: '01',
          name: 'Zagreb'
        },
        {
          code: '21',
          name: 'Zagreb'
        }
      ]
    },
    {
      code: 'CU',
      name: 'Cuba',
      states: [
        {
          code: '15',
          name: 'Artemisa Province'
        },
        {
          code: '09',
          name: 'Camagüey Province'
        },
        {
          code: '08',
          name: 'Ciego de Ávila Province'
        },
        {
          code: '06',
          name: 'Cienfuegos Province'
        },
        {
          code: '12',
          name: 'Granma Province'
        },
        {
          code: '14',
          name: 'Guantánamo Province'
        },
        {
          code: '03',
          name: 'Havana Province'
        },
        {
          code: '11',
          name: 'Holguín Province'
        },
        {
          code: '99',
          name: 'Isla de la Juventud'
        },
        {
          code: '10',
          name: 'Las Tunas Province'
        },
        {
          code: '04',
          name: 'Matanzas Province'
        },
        {
          code: '16',
          name: 'Mayabeque Province'
        },
        {
          code: '01',
          name: 'Pinar del Río Province'
        },
        {
          code: '07',
          name: 'Sancti Spíritus Province'
        },
        {
          code: '13',
          name: 'Santiago de Cuba Province'
        },
        {
          code: '05',
          name: 'Villa Clara Province'
        }
      ]
    },
    {
      code: 'CW',
      name: 'Curaçao',
      states: []
    },
    {
      code: 'CY',
      name: 'Cyprus',
      states: [
        {
          code: '04',
          name: 'Famagusta District (Mağusa)'
        },
        {
          code: '06',
          name: 'Kyrenia District (Keryneia)'
        },
        {
          code: '03',
          name: 'Larnaca District (Larnaka)'
        },
        {
          code: '02',
          name: 'Limassol District (Leymasun)'
        },
        {
          code: '01',
          name: 'Nicosia District (Lefkoşa)'
        },
        {
          code: '05',
          name: 'Paphos District (Pafos)'
        }
      ]
    },
    {
      code: 'CZ',
      name: 'Czech Republic',
      states: [
        {
          code: '201',
          name: 'Benešov'
        },
        {
          code: '202',
          name: 'Beroun'
        },
        {
          code: '641',
          name: 'Blansko'
        },
        {
          code: '644',
          name: 'Břeclav'
        },
        {
          code: '642',
          name: 'Brno-město'
        },
        {
          code: '643',
          name: 'Brno-venkov'
        },
        {
          code: '801',
          name: 'Bruntál'
        },
        {
          code: '511',
          name: 'Česká Lípa'
        },
        {
          code: '311',
          name: 'České Budějovice'
        },
        {
          code: '312',
          name: 'Český Krumlov'
        },
        {
          code: '411',
          name: 'Cheb'
        },
        {
          code: '422',
          name: 'Chomutov'
        },
        {
          code: '531',
          name: 'Chrudim'
        },
        {
          code: '421',
          name: 'Děčín'
        },
        {
          code: '321',
          name: 'Domažlice'
        },
        {
          code: '802',
          name: 'Frýdek-Místek'
        },
        {
          code: '631',
          name: 'Havlíčkův Brod'
        },
        {
          code: '645',
          name: 'Hodonín'
        },
        {
          code: '521',
          name: 'Hradec Králové'
        },
        {
          code: '512',
          name: 'Jablonec nad Nisou'
        },
        {
          code: '711',
          name: 'Jeseník'
        },
        {
          code: '522',
          name: 'Jičín'
        },
        {
          code: '632',
          name: 'Jihlava'
        },
        {
          code: '31',
          name: 'Jihočeský kraj'
        },
        {
          code: '64',
          name: 'Jihomoravský kraj'
        },
        {
          code: '313',
          name: 'Jindřichův Hradec'
        },
        {
          code: '41',
          name: 'Karlovarský kraj'
        },
        {
          code: '412',
          name: 'Karlovy Vary'
        },
        {
          code: '803',
          name: 'Karviná'
        },
        {
          code: '203',
          name: 'Kladno'
        },
        {
          code: '322',
          name: 'Klatovy'
        },
        {
          code: '204',
          name: 'Kolín'
        },
        {
          code: '63',
          name: 'Kraj Vysočina'
        },
        {
          code: '52',
          name: 'Královéhradecký kraj'
        },
        {
          code: '721',
          name: 'Kroměříž'
        },
        {
          code: '205',
          name: 'Kutná Hora'
        },
        {
          code: '513',
          name: 'Liberec'
        },
        {
          code: '51',
          name: 'Liberecký kraj'
        },
        {
          code: '423',
          name: 'Litoměřice'
        },
        {
          code: '424',
          name: 'Louny'
        },
        {
          code: '206',
          name: 'Mělník'
        },
        {
          code: '207',
          name: 'Mladá Boleslav'
        },
        {
          code: '80',
          name: 'Moravskoslezský kraj'
        },
        {
          code: '425',
          name: 'Most'
        },
        {
          code: '523',
          name: 'Náchod'
        },
        {
          code: '804',
          name: 'Nový Jičín'
        },
        {
          code: '208',
          name: 'Nymburk'
        },
        {
          code: '712',
          name: 'Olomouc'
        },
        {
          code: '71',
          name: 'Olomoucký kraj'
        },
        {
          code: '805',
          name: 'Opava'
        },
        {
          code: '806',
          name: 'Ostrava-město'
        },
        {
          code: '532',
          name: 'Pardubice'
        },
        {
          code: '53',
          name: 'Pardubický kraj'
        },
        {
          code: '633',
          name: 'Pelhřimov'
        },
        {
          code: '314',
          name: 'Písek'
        },
        {
          code: '324',
          name: 'Plzeň-jih'
        },
        {
          code: '323',
          name: 'Plzeň-město'
        },
        {
          code: '325',
          name: 'Plzeň-sever'
        },
        {
          code: '32',
          name: 'Plzeňský kraj'
        },
        {
          code: '315',
          name: 'Prachatice'
        },
        {
          code: '209',
          name: 'Praha-východ'
        },
        {
          code: '20A',
          name: 'Praha-západ'
        },
        {
          code: '10',
          name: 'Praha, Hlavní město'
        },
        {
          code: '714',
          name: 'Přerov'
        },
        {
          code: '20B',
          name: 'Příbram'
        },
        {
          code: '713',
          name: 'Prostějov'
        },
        {
          code: '20C',
          name: 'Rakovník'
        },
        {
          code: '326',
          name: 'Rokycany'
        },
        {
          code: '524',
          name: 'Rychnov nad Kněžnou'
        },
        {
          code: '514',
          name: 'Semily'
        },
        {
          code: '413',
          name: 'Sokolov'
        },
        {
          code: '316',
          name: 'Strakonice'
        },
        {
          code: '20',
          name: 'Středočeský kraj'
        },
        {
          code: '715',
          name: 'Šumperk'
        },
        {
          code: '533',
          name: 'Svitavy'
        },
        {
          code: '317',
          name: 'Tábor'
        },
        {
          code: '327',
          name: 'Tachov'
        },
        {
          code: '426',
          name: 'Teplice'
        },
        {
          code: '634',
          name: 'Třebíč'
        },
        {
          code: '525',
          name: 'Trutnov'
        },
        {
          code: '722',
          name: 'Uherské Hradiště'
        },
        {
          code: '42',
          name: 'Ústecký kraj'
        },
        {
          code: '427',
          name: 'Ústí nad Labem'
        },
        {
          code: '534',
          name: 'Ústí nad Orlicí'
        },
        {
          code: '723',
          name: 'Vsetín'
        },
        {
          code: '646',
          name: 'Vyškov'
        },
        {
          code: '635',
          name: 'Žďár nad Sázavou'
        },
        {
          code: '724',
          name: 'Zlín'
        },
        {
          code: '72',
          name: 'Zlínský kraj'
        },
        {
          code: '647',
          name: 'Znojmo'
        }
      ]
    },
    {
      code: 'CD',
      name: 'Democratic Republic of the Congo',
      states: [
        {
          code: 'BU',
          name: 'Bas-Uélé'
        },
        {
          code: 'EQ',
          name: 'Équateur'
        },
        {
          code: 'HK',
          name: 'Haut-Katanga'
        },
        {
          code: 'HL',
          name: 'Haut-Lomami'
        },
        {
          code: 'HU',
          name: 'Haut-Uélé'
        },
        {
          code: 'IT',
          name: 'Ituri'
        },
        {
          code: 'KS',
          name: 'Kasaï'
        },
        {
          code: 'KC',
          name: 'Kasaï Central'
        },
        {
          code: 'KE',
          name: 'Kasaï Oriental'
        },
        {
          code: 'KN',
          name: 'Kinshasa'
        },
        {
          code: 'BC',
          name: 'Kongo Central'
        },
        {
          code: 'KG',
          name: 'Kwango'
        },
        {
          code: 'KL',
          name: 'Kwilu'
        },
        {
          code: 'LO',
          name: 'Lomami'
        },
        {
          code: 'LU',
          name: 'Lualaba'
        },
        {
          code: 'MN',
          name: 'Mai-Ndombe'
        },
        {
          code: 'MA',
          name: 'Maniema'
        },
        {
          code: 'MO',
          name: 'Mongala'
        },
        {
          code: 'NK',
          name: 'Nord-Kivu'
        },
        {
          code: 'NU',
          name: 'Nord-Ubangi'
        },
        {
          code: 'SA',
          name: 'Sankuru'
        },
        {
          code: 'SK',
          name: 'Sud-Kivu'
        },
        {
          code: 'SU',
          name: 'Sud-Ubangi'
        },
        {
          code: 'TA',
          name: 'Tanganyika'
        },
        {
          code: 'TO',
          name: 'Tshopo'
        },
        {
          code: 'TU',
          name: 'Tshuapa'
        }
      ]
    },
    {
      code: 'DK',
      name: 'Denmark',
      states: [
        {
          code: '84',
          name: 'Capital Region of Denmark'
        },
        {
          code: '82',
          name: 'Central Denmark Region'
        },
        {
          code: '81',
          name: 'North Denmark Region'
        },
        {
          code: '83',
          name: 'Region of Southern Denmark'
        },
        {
          code: '85',
          name: 'Region Zealand'
        }
      ]
    },
    {
      code: 'DJ',
      name: 'Djibouti',
      states: [
        {
          code: 'AS',
          name: 'Ali Sabieh Region'
        },
        {
          code: 'AR',
          name: 'Arta Region'
        },
        {
          code: 'DI',
          name: 'Dikhil Region'
        },
        {
          code: 'DJ',
          name: 'Djibouti'
        },
        {
          code: 'OB',
          name: 'Obock Region'
        },
        {
          code: 'TA',
          name: 'Tadjourah Region'
        }
      ]
    },
    {
      code: 'DM',
      name: 'Dominica',
      states: [
        {
          code: '02',
          name: 'Saint Andrew Parish'
        },
        {
          code: '03',
          name: 'Saint David Parish'
        },
        {
          code: '04',
          name: 'Saint George Parish'
        },
        {
          code: '05',
          name: 'Saint John Parish'
        },
        {
          code: '06',
          name: 'Saint Joseph Parish'
        },
        {
          code: '07',
          name: 'Saint Luke Parish'
        },
        {
          code: '08',
          name: 'Saint Mark Parish'
        },
        {
          code: '09',
          name: 'Saint Patrick Parish'
        },
        {
          code: '10',
          name: 'Saint Paul Parish'
        },
        {
          code: '11',
          name: 'Saint Peter Parish'
        }
      ]
    },
    {
      code: 'DO',
      name: 'Dominican Republic',
      states: [
        {
          code: '02',
          name: 'Azua Province'
        },
        {
          code: '03',
          name: 'Baoruco Province'
        },
        {
          code: '04',
          name: 'Barahona Province'
        },
        {
          code: '05',
          name: 'Dajabón Province'
        },
        {
          code: '01',
          name: 'Distrito Nacional'
        },
        {
          code: '06',
          name: 'Duarte Province'
        },
        {
          code: '08',
          name: 'El Seibo Province'
        },
        {
          code: '09',
          name: 'Espaillat Province'
        },
        {
          code: '30',
          name: 'Hato Mayor Province'
        },
        {
          code: '19',
          name: 'Hermanas Mirabal Province'
        },
        {
          code: '10',
          name: 'Independencia'
        },
        {
          code: '11',
          name: 'La Altagracia Province'
        },
        {
          code: '12',
          name: 'La Romana Province'
        },
        {
          code: '13',
          name: 'La Vega Province'
        },
        {
          code: '14',
          name: 'María Trinidad Sánchez Province'
        },
        {
          code: '28',
          name: 'Monseñor Nouel Province'
        },
        {
          code: '15',
          name: 'Monte Cristi Province'
        },
        {
          code: '29',
          name: 'Monte Plata Province'
        },
        {
          code: '16',
          name: 'Pedernales Province'
        },
        {
          code: '17',
          name: 'Peravia Province'
        },
        {
          code: '18',
          name: 'Puerto Plata Province'
        },
        {
          code: '20',
          name: 'Samaná Province'
        },
        {
          code: '21',
          name: 'San Cristóbal Province'
        },
        {
          code: '31',
          name: 'San José de Ocoa Province'
        },
        {
          code: '22',
          name: 'San Juan Province'
        },
        {
          code: '23',
          name: 'San Pedro de Macorís'
        },
        {
          code: '24',
          name: 'Sánchez Ramírez Province'
        },
        {
          code: '25',
          name: 'Santiago Province'
        },
        {
          code: '26',
          name: 'Santiago Rodríguez Province'
        },
        {
          code: '32',
          name: 'Santo Domingo Province'
        },
        {
          code: '27',
          name: 'Valverde Province'
        }
      ]
    },
    {
      code: 'EC',
      name: 'Ecuador',
      states: [
        {
          code: 'A',
          name: 'Azuay'
        },
        {
          code: 'B',
          name: 'Bolívar'
        },
        {
          code: 'F',
          name: 'Cañar'
        },
        {
          code: 'C',
          name: 'Carchi'
        },
        {
          code: 'H',
          name: 'Chimborazo'
        },
        {
          code: 'X',
          name: 'Cotopaxi'
        },
        {
          code: 'O',
          name: 'El Oro'
        },
        {
          code: 'E',
          name: 'Esmeraldas'
        },
        {
          code: 'W',
          name: 'Galápagos'
        },
        {
          code: 'G',
          name: 'Guayas'
        },
        {
          code: 'I',
          name: 'Imbabura'
        },
        {
          code: 'L',
          name: 'Loja'
        },
        {
          code: 'R',
          name: 'Los Ríos'
        },
        {
          code: 'M',
          name: 'Manabí'
        },
        {
          code: 'S',
          name: 'Morona-Santiago'
        },
        {
          code: 'N',
          name: 'Napo'
        },
        {
          code: 'D',
          name: 'Orellana'
        },
        {
          code: 'Y',
          name: 'Pastaza'
        },
        {
          code: 'P',
          name: 'Pichincha'
        },
        {
          code: 'SE',
          name: 'Santa Elena'
        },
        {
          code: 'SD',
          name: 'Santo Domingo de los Tsáchilas'
        },
        {
          code: 'U',
          name: 'Sucumbíos'
        },
        {
          code: 'T',
          name: 'Tungurahua'
        },
        {
          code: 'Z',
          name: 'Zamora Chinchipe'
        }
      ]
    },
    {
      code: 'EG',
      name: 'Egypt',
      states: [
        {
          code: 'ALX',
          name: 'Alexandria'
        },
        {
          code: 'ASN',
          name: 'Aswan'
        },
        {
          code: 'AST',
          name: 'Asyut'
        },
        {
          code: 'BH',
          name: 'Beheira'
        },
        {
          code: 'BNS',
          name: 'Beni Suef'
        },
        {
          code: 'C',
          name: 'Cairo'
        },
        {
          code: 'DK',
          name: 'Dakahlia'
        },
        {
          code: 'DT',
          name: 'Damietta'
        },
        {
          code: 'FYM',
          name: 'Faiyum'
        },
        {
          code: 'GH',
          name: 'Gharbia'
        },
        {
          code: 'GZ',
          name: 'Giza'
        },
        {
          code: 'IS',
          name: 'Ismailia'
        },
        {
          code: 'KFS',
          name: 'Kafr el-Sheikh'
        },
        {
          code: 'LX',
          name: 'Luxor'
        },
        {
          code: 'MT',
          name: 'Matrouh'
        },
        {
          code: 'MN',
          name: 'Minya'
        },
        {
          code: 'MNF',
          name: 'Monufia'
        },
        {
          code: 'WAD',
          name: 'New Valley'
        },
        {
          code: 'SIN',
          name: 'North Sinai'
        },
        {
          code: 'PTS',
          name: 'Port Said'
        },
        {
          code: 'KB',
          name: 'Qalyubia'
        },
        {
          code: 'KN',
          name: 'Qena'
        },
        {
          code: 'BA',
          name: 'Red Sea'
        },
        {
          code: 'SHR',
          name: 'Sharqia'
        },
        {
          code: 'SHG',
          name: 'Sohag'
        },
        {
          code: 'JS',
          name: 'South Sinai'
        },
        {
          code: 'SUZ',
          name: 'Suez'
        }
      ]
    },
    {
      code: 'SV',
      name: 'El Salvador',
      states: [
        {
          code: 'AH',
          name: 'Ahuachapán Department'
        },
        {
          code: 'CA',
          name: 'Cabañas Department'
        },
        {
          code: 'CH',
          name: 'Chalatenango Department'
        },
        {
          code: 'CU',
          name: 'Cuscatlán Department'
        },
        {
          code: 'LI',
          name: 'La Libertad Department'
        },
        {
          code: 'PA',
          name: 'La Paz Department'
        },
        {
          code: 'UN',
          name: 'La Unión Department'
        },
        {
          code: 'MO',
          name: 'Morazán Department'
        },
        {
          code: 'SM',
          name: 'San Miguel Department'
        },
        {
          code: 'SS',
          name: 'San Salvador Department'
        },
        {
          code: 'SV',
          name: 'San Vicente Department'
        },
        {
          code: 'SA',
          name: 'Santa Ana Department'
        },
        {
          code: 'SO',
          name: 'Sonsonate Department'
        },
        {
          code: 'US',
          name: 'Usulután Department'
        }
      ]
    },
    {
      code: 'GQ',
      name: 'Equatorial Guinea',
      states: [
        {
          code: 'AN',
          name: 'Annobón Province'
        },
        {
          code: 'BN',
          name: 'Bioko Norte Province'
        },
        {
          code: 'BS',
          name: 'Bioko Sur Province'
        },
        {
          code: 'CS',
          name: 'Centro Sur Province'
        },
        {
          code: 'I',
          name: 'Insular Region'
        },
        {
          code: 'KN',
          name: 'Kié-Ntem Province'
        },
        {
          code: 'LI',
          name: 'Litoral Province'
        },
        {
          code: 'C',
          name: 'Río Muni'
        },
        {
          code: 'WN',
          name: 'Wele-Nzas Province'
        }
      ]
    },
    {
      code: 'ER',
      name: 'Eritrea',
      states: [
        {
          code: 'AN',
          name: 'Anseba Region'
        },
        {
          code: 'DU',
          name: 'Debub Region'
        },
        {
          code: 'GB',
          name: 'Gash-Barka Region'
        },
        {
          code: 'MA',
          name: 'Maekel Region'
        },
        {
          code: 'SK',
          name: 'Northern Red Sea Region'
        },
        {
          code: 'DK',
          name: 'Southern Red Sea Region'
        }
      ]
    },
    {
      code: 'EE',
      name: 'Estonia',
      states: [
        {
          code: '37',
          name: 'Harju County'
        },
        {
          code: '39',
          name: 'Hiiu County'
        },
        {
          code: '44',
          name: 'Ida-Viru County'
        },
        {
          code: '51',
          name: 'Järva County'
        },
        {
          code: '49',
          name: 'Jõgeva County'
        },
        {
          code: '57',
          name: 'Lääne County'
        },
        {
          code: '59',
          name: 'Lääne-Viru County'
        },
        {
          code: '67',
          name: 'Pärnu County'
        },
        {
          code: '65',
          name: 'Põlva County'
        },
        {
          code: '70',
          name: 'Rapla County'
        },
        {
          code: '74',
          name: 'Saare County'
        },
        {
          code: '78',
          name: 'Tartu County'
        },
        {
          code: '82',
          name: 'Valga County'
        },
        {
          code: '84',
          name: 'Viljandi County'
        },
        {
          code: '86',
          name: 'Võru County'
        }
      ]
    },
    {
      code: 'SZ',
      name: 'Eswatini',
      states: [
        {
          code: 'HH',
          name: 'Hhohho District'
        },
        {
          code: 'LU',
          name: 'Lubombo District'
        },
        {
          code: 'MA',
          name: 'Manzini District'
        },
        {
          code: 'SH',
          name: 'Shiselweni District'
        }
      ]
    },
    {
      code: 'ET',
      name: 'Ethiopia',
      states: [
        {
          code: 'AA',
          name: 'Addis Ababa'
        },
        {
          code: 'AF',
          name: 'Afar Region'
        },
        {
          code: 'AM',
          name: 'Amhara Region'
        },
        {
          code: 'BE',
          name: 'Benishangul-Gumuz Region'
        },
        {
          code: 'DD',
          name: 'Dire Dawa'
        },
        {
          code: 'GA',
          name: 'Gambela Region'
        },
        {
          code: 'HA',
          name: 'Harari Region'
        },
        {
          code: 'OR',
          name: 'Oromia Region'
        },
        {
          code: 'SO',
          name: 'Somali Region'
        },
        {
          code: 'SN',
          name: "Southern Nations, Nationalities, and Peoples' Region"
        },
        {
          code: 'TI',
          name: 'Tigray Region'
        }
      ]
    },
    {
      code: 'FK',
      name: 'Falkland Islands',
      states: []
    },
    {
      code: 'FO',
      name: 'Faroe Islands',
      states: [
        {
          code: 'EY',
          name: 'Eysturoy'
        },
        {
          code: 'NO',
          name: 'Northern Isles'
        },
        {
          code: 'SA',
          name: 'Sandoy'
        },
        {
          code: 'ST',
          name: 'Streymoy'
        },
        {
          code: 'SU',
          name: 'Suðuroy'
        },
        {
          code: 'VA',
          name: 'Vágar'
        }
      ]
    },
    {
      code: 'FJ',
      name: 'Fiji Islands',
      states: [
        {
          code: '01',
          name: 'Ba'
        },
        {
          code: '02',
          name: 'Bua'
        },
        {
          code: '03',
          name: 'Cakaudrove'
        },
        {
          code: 'C',
          name: 'Central Division'
        },
        {
          code: 'E',
          name: 'Eastern Division'
        },
        {
          code: '04',
          name: 'Kadavu'
        },
        {
          code: '05',
          name: 'Lau'
        },
        {
          code: '06',
          name: 'Lomaiviti'
        },
        {
          code: '07',
          name: 'Macuata'
        },
        {
          code: '08',
          name: 'Nadroga-Navosa'
        },
        {
          code: '09',
          name: 'Naitasiri'
        },
        {
          code: '10',
          name: 'Namosi'
        },
        {
          code: 'N',
          name: 'Northern Division'
        },
        {
          code: '11',
          name: 'Ra'
        },
        {
          code: '12',
          name: 'Rewa'
        },
        {
          code: 'R',
          name: 'Rotuma'
        },
        {
          code: '13',
          name: 'Serua'
        },
        {
          code: '14',
          name: 'Tailevu'
        },
        {
          code: 'W',
          name: 'Western Division'
        }
      ]
    },
    {
      code: 'FI',
      name: 'Finland',
      states: [
        {
          code: '01',
          name: 'Åland Islands'
        },
        {
          code: '08',
          name: 'Central Finland'
        },
        {
          code: '07',
          name: 'Central Ostrobothnia'
        },
        {
          code: '19',
          name: 'Finland Proper'
        },
        {
          code: '05',
          name: 'Kainuu'
        },
        {
          code: '09',
          name: 'Kymenlaakso'
        },
        {
          code: '10',
          name: 'Lapland'
        },
        {
          code: '13',
          name: 'North Karelia'
        },
        {
          code: '14',
          name: 'Northern Ostrobothnia'
        },
        {
          code: '15',
          name: 'Northern Savonia'
        },
        {
          code: '12',
          name: 'Ostrobothnia'
        },
        {
          code: '16',
          name: 'Päijänne Tavastia'
        },
        {
          code: '11',
          name: 'Pirkanmaa'
        },
        {
          code: '17',
          name: 'Satakunta'
        },
        {
          code: '02',
          name: 'South Karelia'
        },
        {
          code: '03',
          name: 'Southern Ostrobothnia'
        },
        {
          code: '04',
          name: 'Southern Savonia'
        },
        {
          code: '06',
          name: 'Tavastia Proper'
        },
        {
          code: '18',
          name: 'Uusimaa'
        }
      ]
    },
    {
      code: 'FR',
      name: 'France',
      states: [
        {
          code: '01',
          name: 'Ain'
        },
        {
          code: '02',
          name: 'Aisne'
        },
        {
          code: '03',
          name: 'Allier'
        },
        {
          code: '04',
          name: 'Alpes-de-Haute-Provence'
        },
        {
          code: '06',
          name: 'Alpes-Maritimes'
        },
        {
          code: '6AE',
          name: 'Alsace'
        },
        {
          code: '07',
          name: 'Ardèche'
        },
        {
          code: '08',
          name: 'Ardennes'
        },
        {
          code: '09',
          name: 'Ariège'
        },
        {
          code: '10',
          name: 'Aube'
        },
        {
          code: '11',
          name: 'Aude'
        },
        {
          code: 'ARA',
          name: 'Auvergne-Rhône-Alpes'
        },
        {
          code: '12',
          name: 'Aveyron'
        },
        {
          code: '67',
          name: 'Bas-Rhin'
        },
        {
          code: '13',
          name: 'Bouches-du-Rhône'
        },
        {
          code: 'BFC',
          name: 'Bourgogne-Franche-Comté'
        },
        {
          code: 'BRE',
          name: 'Bretagne'
        },
        {
          code: '14',
          name: 'Calvados'
        },
        {
          code: '15',
          name: 'Cantal'
        },
        {
          code: 'CVL',
          name: 'Centre-Val de Loire'
        },
        {
          code: '16',
          name: 'Charente'
        },
        {
          code: '17',
          name: 'Charente-Maritime'
        },
        {
          code: '18',
          name: 'Cher'
        },
        {
          code: 'CP',
          name: 'Clipperton'
        },
        {
          code: '19',
          name: 'Corrèze'
        },
        {
          code: '20R',
          name: 'Corse'
        },
        {
          code: '2A',
          name: 'Corse-du-Sud'
        },
        {
          code: '21',
          name: "Côte-d'Or"
        },
        {
          code: '22',
          name: "Côtes-d'Armor"
        },
        {
          code: '23',
          name: 'Creuse'
        },
        {
          code: '79',
          name: 'Deux-Sèvres'
        },
        {
          code: '24',
          name: 'Dordogne'
        },
        {
          code: '25',
          name: 'Doubs'
        },
        {
          code: '26',
          name: 'Drôme'
        },
        {
          code: '91',
          name: 'Essonne'
        },
        {
          code: '27',
          name: 'Eure'
        },
        {
          code: '28',
          name: 'Eure-et-Loir'
        },
        {
          code: '29',
          name: 'Finistère'
        },
        {
          code: '973',
          name: 'French Guiana'
        },
        {
          code: 'PF',
          name: 'French Polynesia'
        },
        {
          code: 'TF',
          name: 'French Southern and Antarctic Lands'
        },
        {
          code: '30',
          name: 'Gard'
        },
        {
          code: '32',
          name: 'Gers'
        },
        {
          code: '33',
          name: 'Gironde'
        },
        {
          code: 'GES',
          name: 'Grand-Est'
        },
        {
          code: '971',
          name: 'Guadeloupe'
        },
        {
          code: '68',
          name: 'Haut-Rhin'
        },
        {
          code: '2B',
          name: 'Haute-Corse'
        },
        {
          code: '31',
          name: 'Haute-Garonne'
        },
        {
          code: '43',
          name: 'Haute-Loire'
        },
        {
          code: '52',
          name: 'Haute-Marne'
        },
        {
          code: '70',
          name: 'Haute-Saône'
        },
        {
          code: '74',
          name: 'Haute-Savoie'
        },
        {
          code: '87',
          name: 'Haute-Vienne'
        },
        {
          code: '05',
          name: 'Hautes-Alpes'
        },
        {
          code: '65',
          name: 'Hautes-Pyrénées'
        },
        {
          code: 'HDF',
          name: 'Hauts-de-France'
        },
        {
          code: '92',
          name: 'Hauts-de-Seine'
        },
        {
          code: '34',
          name: 'Hérault'
        },
        {
          code: 'IDF',
          name: 'Île-de-France'
        },
        {
          code: '35',
          name: 'Ille-et-Vilaine'
        },
        {
          code: '36',
          name: 'Indre'
        },
        {
          code: '37',
          name: 'Indre-et-Loire'
        },
        {
          code: '38',
          name: 'Isère'
        },
        {
          code: '39',
          name: 'Jura'
        },
        {
          code: '974',
          name: 'La Réunion'
        },
        {
          code: '40',
          name: 'Landes'
        },
        {
          code: '41',
          name: 'Loir-et-Cher'
        },
        {
          code: '42',
          name: 'Loire'
        },
        {
          code: '44',
          name: 'Loire-Atlantique'
        },
        {
          code: '45',
          name: 'Loiret'
        },
        {
          code: '46',
          name: 'Lot'
        },
        {
          code: '47',
          name: 'Lot-et-Garonne'
        },
        {
          code: '48',
          name: 'Lozère'
        },
        {
          code: '49',
          name: 'Maine-et-Loire'
        },
        {
          code: '50',
          name: 'Manche'
        },
        {
          code: '51',
          name: 'Marne'
        },
        {
          code: '972',
          name: 'Martinique'
        },
        {
          code: '53',
          name: 'Mayenne'
        },
        {
          code: '976',
          name: 'Mayotte'
        },
        {
          code: '69M',
          name: 'Métropole de Lyon'
        },
        {
          code: '54',
          name: 'Meurthe-et-Moselle'
        },
        {
          code: '55',
          name: 'Meuse'
        },
        {
          code: '56',
          name: 'Morbihan'
        },
        {
          code: '57',
          name: 'Moselle'
        },
        {
          code: '58',
          name: 'Nièvre'
        },
        {
          code: '59',
          name: 'Nord'
        },
        {
          code: 'NOR',
          name: 'Normandie'
        },
        {
          code: 'NAQ',
          name: 'Nouvelle-Aquitaine'
        },
        {
          code: 'OCC',
          name: 'Occitanie'
        },
        {
          code: '60',
          name: 'Oise'
        },
        {
          code: '61',
          name: 'Orne'
        },
        {
          code: '75C',
          name: 'Paris'
        },
        {
          code: '62',
          name: 'Pas-de-Calais'
        },
        {
          code: 'PDL',
          name: 'Pays-de-la-Loire'
        },
        {
          code: 'PAC',
          name: 'Provence-Alpes-Côte-d\u2019Azur'
        },
        {
          code: '63',
          name: 'Puy-de-Dôme'
        },
        {
          code: '64',
          name: 'Pyrénées-Atlantiques'
        },
        {
          code: '66',
          name: 'Pyrénées-Orientales'
        },
        {
          code: '69',
          name: 'Rhône'
        },
        {
          code: 'PM',
          name: 'Saint Pierre and Miquelon'
        },
        {
          code: 'BL',
          name: 'Saint-Barthélemy'
        },
        {
          code: 'MF',
          name: 'Saint-Martin'
        },
        {
          code: '71',
          name: 'Saône-et-Loire'
        },
        {
          code: '72',
          name: 'Sarthe'
        },
        {
          code: '73',
          name: 'Savoie'
        },
        {
          code: '77',
          name: 'Seine-et-Marne'
        },
        {
          code: '76',
          name: 'Seine-Maritime'
        },
        {
          code: '93',
          name: 'Seine-Saint-Denis'
        },
        {
          code: '80',
          name: 'Somme'
        },
        {
          code: '81',
          name: 'Tarn'
        },
        {
          code: '82',
          name: 'Tarn-et-Garonne'
        },
        {
          code: '90',
          name: 'Territoire de Belfort'
        },
        {
          code: '95',
          name: "Val-d'Oise"
        },
        {
          code: '94',
          name: 'Val-de-Marne'
        },
        {
          code: '83',
          name: 'Var'
        },
        {
          code: '84',
          name: 'Vaucluse'
        },
        {
          code: '85',
          name: 'Vendée'
        },
        {
          code: '86',
          name: 'Vienne'
        },
        {
          code: '88',
          name: 'Vosges'
        },
        {
          code: 'WF',
          name: 'Wallis and Futuna'
        },
        {
          code: '89',
          name: 'Yonne'
        },
        {
          code: '78',
          name: 'Yvelines'
        }
      ]
    },
    {
      code: 'GF',
      name: 'French Guiana',
      states: []
    },
    {
      code: 'PF',
      name: 'French Polynesia',
      states: []
    },
    {
      code: 'TF',
      name: 'French Southern Territories',
      states: []
    },
    {
      code: 'GA',
      name: 'Gabon',
      states: [
        {
          code: '1',
          name: 'Estuaire Province'
        },
        {
          code: '2',
          name: 'Haut-Ogooué Province'
        },
        {
          code: '3',
          name: 'Moyen-Ogooué Province'
        },
        {
          code: '4',
          name: 'Ngounié Province'
        },
        {
          code: '5',
          name: 'Nyanga Province'
        },
        {
          code: '6',
          name: 'Ogooué-Ivindo Province'
        },
        {
          code: '7',
          name: 'Ogooué-Lolo Province'
        },
        {
          code: '8',
          name: 'Ogooué-Maritime Province'
        },
        {
          code: '9',
          name: 'Woleu-Ntem Province'
        }
      ]
    },
    {
      code: 'GM',
      name: 'Gambia The',
      states: [
        {
          code: 'B',
          name: 'Banjul'
        },
        {
          code: 'M',
          name: 'Central River Division'
        },
        {
          code: 'L',
          name: 'Lower River Division'
        },
        {
          code: 'N',
          name: 'North Bank Division'
        },
        {
          code: 'U',
          name: 'Upper River Division'
        },
        {
          code: 'W',
          name: 'West Coast Division'
        }
      ]
    },
    {
      code: 'GE',
      name: 'Georgia',
      states: [
        {
          code: 'AB',
          name: 'Abkhazia'
        },
        {
          code: 'AJ',
          name: 'Adjara'
        },
        {
          code: 'GU',
          name: 'Guria'
        },
        {
          code: 'IM',
          name: 'Imereti'
        },
        {
          code: 'KA',
          name: 'Kakheti'
        },
        {
          code: '29',
          name: 'Khelvachauri Municipality'
        },
        {
          code: 'KK',
          name: 'Kvemo Kartli'
        },
        {
          code: 'MM',
          name: 'Mtskheta-Mtianeti'
        },
        {
          code: 'RL',
          name: 'Racha-Lechkhumi and Kvemo Svaneti'
        },
        {
          code: 'SZ',
          name: 'Samegrelo-Zemo Svaneti'
        },
        {
          code: 'SJ',
          name: 'Samtskhe-Javakheti'
        },
        {
          code: '50',
          name: 'Senaki Municipality'
        },
        {
          code: 'SK',
          name: 'Shida Kartli'
        },
        {
          code: 'TB',
          name: 'Tbilisi'
        }
      ]
    },
    {
      code: 'DE',
      name: 'Germany',
      states: [
        {
          code: 'BW',
          name: 'Baden-Württemberg'
        },
        {
          code: 'BY',
          name: 'Bavaria'
        },
        {
          code: 'BE',
          name: 'Berlin'
        },
        {
          code: 'BB',
          name: 'Brandenburg'
        },
        {
          code: 'HB',
          name: 'Bremen'
        },
        {
          code: 'HH',
          name: 'Hamburg'
        },
        {
          code: 'HE',
          name: 'Hesse'
        },
        {
          code: 'NI',
          name: 'Lower Saxony'
        },
        {
          code: 'MV',
          name: 'Mecklenburg-Vorpommern'
        },
        {
          code: 'NW',
          name: 'North Rhine-Westphalia'
        },
        {
          code: 'RP',
          name: 'Rhineland-Palatinate'
        },
        {
          code: 'SL',
          name: 'Saarland'
        },
        {
          code: 'SN',
          name: 'Saxony'
        },
        {
          code: 'ST',
          name: 'Saxony-Anhalt'
        },
        {
          code: 'SH',
          name: 'Schleswig-Holstein'
        },
        {
          code: 'TH',
          name: 'Thuringia'
        }
      ]
    },
    {
      code: 'GH',
      name: 'Ghana',
      states: [
        {
          code: 'AF',
          name: 'Ahafo'
        },
        {
          code: 'AH',
          name: 'Ashanti'
        },
        {
          code: 'BO',
          name: 'Bono'
        },
        {
          code: 'BE',
          name: 'Bono East'
        },
        {
          code: 'CP',
          name: 'Central'
        },
        {
          code: 'EP',
          name: 'Eastern'
        },
        {
          code: 'AA',
          name: 'Greater Accra'
        },
        {
          code: 'NE',
          name: 'North East'
        },
        {
          code: 'NP',
          name: 'Northern'
        },
        {
          code: 'OT',
          name: 'Oti'
        },
        {
          code: 'SV',
          name: 'Savannah'
        },
        {
          code: 'UE',
          name: 'Upper East'
        },
        {
          code: 'UW',
          name: 'Upper West'
        },
        {
          code: 'TV',
          name: 'Volta'
        },
        {
          code: 'WP',
          name: 'Western'
        },
        {
          code: 'WN',
          name: 'Western North'
        }
      ]
    },
    {
      code: 'GI',
      name: 'Gibraltar',
      states: []
    },
    {
      code: 'GR',
      name: 'Greece',
      states: [
        {
          code: '13',
          name: 'Achaea Regional Unit'
        },
        {
          code: '01',
          name: 'Aetolia-Acarnania Regional Unit'
        },
        {
          code: '12',
          name: 'Arcadia Prefecture'
        },
        {
          code: '11',
          name: 'Argolis Regional Unit'
        },
        {
          code: 'I',
          name: 'Attica Region'
        },
        {
          code: '03',
          name: 'Boeotia Regional Unit'
        },
        {
          code: 'H',
          name: 'Central Greece Region'
        },
        {
          code: 'B',
          name: 'Central Macedonia'
        },
        {
          code: '94',
          name: 'Chania Regional Unit'
        },
        {
          code: '22',
          name: 'Corfu Prefecture'
        },
        {
          code: '15',
          name: 'Corinthia Regional Unit'
        },
        {
          code: 'M',
          name: 'Crete Region'
        },
        {
          code: '52',
          name: 'Drama Regional Unit'
        },
        {
          code: 'A2',
          name: 'East Attica Regional Unit'
        },
        {
          code: 'A',
          name: 'East Macedonia and Thrace'
        },
        {
          code: 'D',
          name: 'Epirus Region'
        },
        {
          code: '04',
          name: 'Euboea'
        },
        {
          code: '51',
          name: 'Grevena Prefecture'
        },
        {
          code: '53',
          name: 'Imathia Regional Unit'
        },
        {
          code: '33',
          name: 'Ioannina Regional Unit'
        },
        {
          code: 'F',
          name: 'Ionian Islands Region'
        },
        {
          code: '41',
          name: 'Karditsa Regional Unit'
        },
        {
          code: '56',
          name: 'Kastoria Regional Unit'
        },
        {
          code: '23',
          name: 'Kefalonia Prefecture'
        },
        {
          code: '57',
          name: 'Kilkis Regional Unit'
        },
        {
          code: '58',
          name: 'Kozani Prefecture'
        },
        {
          code: '16',
          name: 'Laconia'
        },
        {
          code: '42',
          name: 'Larissa Prefecture'
        },
        {
          code: '24',
          name: 'Lefkada Regional Unit'
        },
        {
          code: '59',
          name: 'Pella Regional Unit'
        },
        {
          code: 'J',
          name: 'Peloponnese Region'
        },
        {
          code: '06',
          name: 'Phthiotis Prefecture'
        },
        {
          code: '34',
          name: 'Preveza Prefecture'
        },
        {
          code: '62',
          name: 'Serres Prefecture'
        },
        {
          code: 'L',
          name: 'South Aegean'
        },
        {
          code: '54',
          name: 'Thessaloniki Regional Unit'
        },
        {
          code: 'G',
          name: 'West Greece Region'
        },
        {
          code: 'C',
          name: 'West Macedonia Region'
        }
      ]
    },
    {
      code: 'GL',
      name: 'Greenland',
      states: []
    },
    {
      code: 'GD',
      name: 'Grenada',
      states: [
        {
          code: '10',
          name: 'Carriacou and Petite Martinique'
        },
        {
          code: '01',
          name: 'Saint Andrew Parish'
        },
        {
          code: '02',
          name: 'Saint David Parish'
        },
        {
          code: '03',
          name: 'Saint George Parish'
        },
        {
          code: '04',
          name: 'Saint John Parish'
        },
        {
          code: '05',
          name: 'Saint Mark Parish'
        },
        {
          code: '06',
          name: 'Saint Patrick Parish'
        }
      ]
    },
    {
      code: 'GP',
      name: 'Guadeloupe',
      states: []
    },
    {
      code: 'GU',
      name: 'Guam',
      states: []
    },
    {
      code: 'GT',
      name: 'Guatemala',
      states: [
        {
          code: 'AV',
          name: 'Alta Verapaz Department'
        },
        {
          code: 'BV',
          name: 'Baja Verapaz Department'
        },
        {
          code: 'CM',
          name: 'Chimaltenango Department'
        },
        {
          code: 'CQ',
          name: 'Chiquimula Department'
        },
        {
          code: 'PR',
          name: 'El Progreso Department'
        },
        {
          code: 'ES',
          name: 'Escuintla Department'
        },
        {
          code: 'GU',
          name: 'Guatemala Department'
        },
        {
          code: 'HU',
          name: 'Huehuetenango Department'
        },
        {
          code: 'IZ',
          name: 'Izabal Department'
        },
        {
          code: 'JA',
          name: 'Jalapa Department'
        },
        {
          code: 'JU',
          name: 'Jutiapa Department'
        },
        {
          code: 'PE',
          name: 'Petén Department'
        },
        {
          code: 'QZ',
          name: 'Quetzaltenango Department'
        },
        {
          code: 'QC',
          name: 'Quiché Department'
        },
        {
          code: 'RE',
          name: 'Retalhuleu Department'
        },
        {
          code: 'SA',
          name: 'Sacatepéquez Department'
        },
        {
          code: 'SM',
          name: 'San Marcos Department'
        },
        {
          code: 'SR',
          name: 'Santa Rosa Department'
        },
        {
          code: 'SO',
          name: 'Sololá Department'
        },
        {
          code: 'SU',
          name: 'Suchitepéquez Department'
        },
        {
          code: 'TO',
          name: 'Totonicapán Department'
        }
      ]
    },
    {
      code: 'GG',
      name: 'Guernsey and Alderney',
      states: []
    },
    {
      code: 'GN',
      name: 'Guinea',
      states: [
        {
          code: 'BE',
          name: 'Beyla Prefecture'
        },
        {
          code: 'BF',
          name: 'Boffa Prefecture'
        },
        {
          code: 'BK',
          name: 'Boké Prefecture'
        },
        {
          code: 'B',
          name: 'Boké Region'
        },
        {
          code: 'C',
          name: 'Conakry'
        },
        {
          code: 'CO',
          name: 'Coyah Prefecture'
        },
        {
          code: 'DB',
          name: 'Dabola Prefecture'
        },
        {
          code: 'DL',
          name: 'Dalaba Prefecture'
        },
        {
          code: 'DI',
          name: 'Dinguiraye Prefecture'
        },
        {
          code: 'DU',
          name: 'Dubréka Prefecture'
        },
        {
          code: 'FA',
          name: 'Faranah Prefecture'
        },
        {
          code: 'FO',
          name: 'Forécariah Prefecture'
        },
        {
          code: 'FR',
          name: 'Fria Prefecture'
        },
        {
          code: 'GA',
          name: 'Gaoual Prefecture'
        },
        {
          code: 'GU',
          name: 'Guéckédou Prefecture'
        },
        {
          code: 'KA',
          name: 'Kankan Prefecture'
        },
        {
          code: 'K',
          name: 'Kankan Region'
        },
        {
          code: 'KE',
          name: 'Kérouané Prefecture'
        },
        {
          code: 'KD',
          name: 'Kindia Prefecture'
        },
        {
          code: 'D',
          name: 'Kindia Region'
        },
        {
          code: 'KS',
          name: 'Kissidougou Prefecture'
        },
        {
          code: 'KB',
          name: 'Koubia Prefecture'
        },
        {
          code: 'KN',
          name: 'Koundara Prefecture'
        },
        {
          code: 'KO',
          name: 'Kouroussa Prefecture'
        },
        {
          code: 'LA',
          name: 'Labé Prefecture'
        },
        {
          code: 'L',
          name: 'Labé Region'
        },
        {
          code: 'LE',
          name: 'Lélouma Prefecture'
        },
        {
          code: 'LO',
          name: 'Lola Prefecture'
        },
        {
          code: 'MC',
          name: 'Macenta Prefecture'
        },
        {
          code: 'ML',
          name: 'Mali Prefecture'
        },
        {
          code: 'MM',
          name: 'Mamou Prefecture'
        },
        {
          code: 'M',
          name: 'Mamou Region'
        },
        {
          code: 'MD',
          name: 'Mandiana Prefecture'
        },
        {
          code: 'NZ',
          name: 'Nzérékoré Prefecture'
        },
        {
          code: 'N',
          name: 'Nzérékoré Region'
        },
        {
          code: 'PI',
          name: 'Pita Prefecture'
        },
        {
          code: 'SI',
          name: 'Siguiri Prefecture'
        },
        {
          code: 'TE',
          name: 'Télimélé Prefecture'
        },
        {
          code: 'TO',
          name: 'Tougué Prefecture'
        },
        {
          code: 'YO',
          name: 'Yomou Prefecture'
        }
      ]
    },
    {
      code: 'GW',
      name: 'Guinea-Bissau',
      states: [
        {
          code: 'BA',
          name: 'Bafatá'
        },
        {
          code: 'BM',
          name: 'Biombo Region'
        },
        {
          code: 'BL',
          name: 'Bolama Region'
        },
        {
          code: 'CA',
          name: 'Cacheu Region'
        },
        {
          code: 'GA',
          name: 'Gabú Region'
        },
        {
          code: 'L',
          name: 'Leste Province'
        },
        {
          code: 'N',
          name: 'Norte Province'
        },
        {
          code: 'OI',
          name: 'Oio Region'
        },
        {
          code: 'QU',
          name: 'Quinara Region'
        },
        {
          code: 'S',
          name: 'Sul Province'
        },
        {
          code: 'TO',
          name: 'Tombali Region'
        }
      ]
    },
    {
      code: 'GY',
      name: 'Guyana',
      states: [
        {
          code: 'BA',
          name: 'Barima-Waini'
        },
        {
          code: 'CU',
          name: 'Cuyuni-Mazaruni'
        },
        {
          code: 'DE',
          name: 'Demerara-Mahaica'
        },
        {
          code: 'EB',
          name: 'East Berbice-Corentyne'
        },
        {
          code: 'ES',
          name: 'Essequibo Islands-West Demerara'
        },
        {
          code: 'MA',
          name: 'Mahaica-Berbice'
        },
        {
          code: 'PM',
          name: 'Pomeroon-Supenaam'
        },
        {
          code: 'PT',
          name: 'Potaro-Siparuni'
        },
        {
          code: 'UD',
          name: 'Upper Demerara-Berbice'
        },
        {
          code: 'UT',
          name: 'Upper Takutu-Upper Essequibo'
        }
      ]
    },
    {
      code: 'HT',
      name: 'Haiti',
      states: [
        {
          code: 'AR',
          name: 'Artibonite'
        },
        {
          code: 'CE',
          name: 'Centre'
        },
        {
          code: 'GA',
          name: "Grand'Anse"
        },
        {
          code: 'NI',
          name: 'Nippes'
        },
        {
          code: 'ND',
          name: 'Nord'
        },
        {
          code: 'NE',
          name: 'Nord-Est'
        },
        {
          code: 'NO',
          name: 'Nord-Ouest'
        },
        {
          code: 'OU',
          name: 'Ouest'
        },
        {
          code: 'SD',
          name: 'Sud'
        },
        {
          code: 'SE',
          name: 'Sud-Est'
        }
      ]
    },
    {
      code: 'HM',
      name: 'Heard Island and McDonald Islands',
      states: []
    },
    {
      code: 'HN',
      name: 'Honduras',
      states: [
        {
          code: 'AT',
          name: 'Atlántida Department'
        },
        {
          code: 'IB',
          name: 'Bay Islands Department'
        },
        {
          code: 'CH',
          name: 'Choluteca Department'
        },
        {
          code: 'CL',
          name: 'Colón Department'
        },
        {
          code: 'CM',
          name: 'Comayagua Department'
        },
        {
          code: 'CP',
          name: 'Copán Department'
        },
        {
          code: 'CR',
          name: 'Cortés Department'
        },
        {
          code: 'EP',
          name: 'El Paraíso Department'
        },
        {
          code: 'FM',
          name: 'Francisco Morazán Department'
        },
        {
          code: 'GD',
          name: 'Gracias a Dios Department'
        },
        {
          code: 'IN',
          name: 'Intibucá Department'
        },
        {
          code: 'LP',
          name: 'La Paz Department'
        },
        {
          code: 'LE',
          name: 'Lempira Department'
        },
        {
          code: 'OC',
          name: 'Ocotepeque Department'
        },
        {
          code: 'OL',
          name: 'Olancho Department'
        },
        {
          code: 'SB',
          name: 'Santa Bárbara Department'
        },
        {
          code: 'VA',
          name: 'Valle Department'
        },
        {
          code: 'YO',
          name: 'Yoro Department'
        }
      ]
    },
    {
      code: 'HK',
      name: 'Hong Kong S.A.R.',
      states: [
        {
          code: 'HCW',
          name: 'Central and Western'
        },
        {
          code: 'HEA',
          name: 'Eastern'
        },
        {
          code: 'NIS',
          name: 'Islands'
        },
        {
          code: 'KKC',
          name: 'Kowloon City'
        },
        {
          code: 'NKT',
          name: 'Kwai Tsing'
        },
        {
          code: 'KKT',
          name: 'Kwun Tong'
        },
        {
          code: 'NNO',
          name: 'North'
        },
        {
          code: 'NSK',
          name: 'Sai Kung'
        },
        {
          code: 'NST',
          name: 'Sha Tin'
        },
        {
          code: 'KSS',
          name: 'Sham Shui Po'
        },
        {
          code: 'HSO',
          name: 'Southern'
        },
        {
          code: 'NTP',
          name: 'Tai Po'
        },
        {
          code: 'NTW',
          name: 'Tsuen Wan'
        },
        {
          code: 'NTM',
          name: 'Tuen Mun'
        },
        {
          code: 'HWC',
          name: 'Wan Chai'
        },
        {
          code: 'KWT',
          name: 'Wong Tai Sin'
        },
        {
          code: 'KYT',
          name: 'Yau Tsim Mong'
        },
        {
          code: 'NYL',
          name: 'Yuen Long'
        }
      ]
    },
    {
      code: 'HU',
      name: 'Hungary',
      states: [
        {
          code: 'BK',
          name: 'Bács-Kiskun'
        },
        {
          code: 'BA',
          name: 'Baranya'
        },
        {
          code: 'BE',
          name: 'Békés'
        },
        {
          code: 'BC',
          name: 'Békéscsaba'
        },
        {
          code: 'BZ',
          name: 'Borsod-Abaúj-Zemplén'
        },
        {
          code: 'BU',
          name: 'Budapest'
        },
        {
          code: 'CS',
          name: 'Csongrád County'
        },
        {
          code: 'DE',
          name: 'Debrecen'
        },
        {
          code: 'DU',
          name: 'Dunaújváros'
        },
        {
          code: 'EG',
          name: 'Eger'
        },
        {
          code: 'ER',
          name: 'Érd'
        },
        {
          code: 'FE',
          name: 'Fejér County'
        },
        {
          code: 'GY',
          name: 'Győr'
        },
        {
          code: 'GS',
          name: 'Győr-Moson-Sopron County'
        },
        {
          code: 'HB',
          name: 'Hajdú-Bihar County'
        },
        {
          code: 'HE',
          name: 'Heves County'
        },
        {
          code: 'HV',
          name: 'Hódmezővásárhely'
        },
        {
          code: 'JN',
          name: 'Jász-Nagykun-Szolnok County'
        },
        {
          code: 'KV',
          name: 'Kaposvár'
        },
        {
          code: 'KM',
          name: 'Kecskemét'
        },
        {
          code: 'KE',
          name: 'Komárom-Esztergom'
        },
        {
          code: 'MI',
          name: 'Miskolc'
        },
        {
          code: 'NK',
          name: 'Nagykanizsa'
        },
        {
          code: 'NO',
          name: 'Nógrád County'
        },
        {
          code: 'NY',
          name: 'Nyíregyháza'
        },
        {
          code: 'PS',
          name: 'Pécs'
        },
        {
          code: 'PE',
          name: 'Pest County'
        },
        {
          code: 'ST',
          name: 'Salgótarján'
        },
        {
          code: 'SO',
          name: 'Somogy County'
        },
        {
          code: 'SN',
          name: 'Sopron'
        },
        {
          code: 'SZ',
          name: 'Szabolcs-Szatmár-Bereg County'
        },
        {
          code: 'SD',
          name: 'Szeged'
        },
        {
          code: 'SF',
          name: 'Székesfehérvár'
        },
        {
          code: 'SS',
          name: 'Szekszárd'
        },
        {
          code: 'SK',
          name: 'Szolnok'
        },
        {
          code: 'SH',
          name: 'Szombathely'
        },
        {
          code: 'TB',
          name: 'Tatabánya'
        },
        {
          code: 'TO',
          name: 'Tolna County'
        },
        {
          code: 'VA',
          name: 'Vas County'
        },
        {
          code: 'VM',
          name: 'Veszprém'
        },
        {
          code: 'VE',
          name: 'Veszprém County'
        },
        {
          code: 'ZA',
          name: 'Zala County'
        },
        {
          code: 'ZE',
          name: 'Zalaegerszeg'
        }
      ]
    },
    {
      code: 'IS',
      name: 'Iceland',
      states: [
        {
          code: '1',
          name: 'Capital Region'
        },
        {
          code: '7',
          name: 'Eastern Region'
        },
        {
          code: '6',
          name: 'Northeastern Region'
        },
        {
          code: '5',
          name: 'Northwestern Region'
        },
        {
          code: '2',
          name: 'Southern Peninsula Region'
        },
        {
          code: '8',
          name: 'Southern Region'
        },
        {
          code: '3',
          name: 'Western Region'
        },
        {
          code: '4',
          name: 'Westfjords'
        }
      ]
    },
    {
      code: 'IN',
      name: 'India',
      states: [
        {
          code: 'AN',
          name: 'Andaman and Nicobar Islands'
        },
        {
          code: 'AP',
          name: 'Andhra Pradesh'
        },
        {
          code: 'AR',
          name: 'Arunachal Pradesh'
        },
        {
          code: 'AS',
          name: 'Assam'
        },
        {
          code: 'BR',
          name: 'Bihar'
        },
        {
          code: 'CH',
          name: 'Chandigarh'
        },
        {
          code: 'CT',
          name: 'Chhattisgarh'
        },
        {
          code: 'DH',
          name: 'Dadra and Nagar Haveli and Daman and Diu'
        },
        {
          code: 'DL',
          name: 'Delhi'
        },
        {
          code: 'GA',
          name: 'Goa'
        },
        {
          code: 'GJ',
          name: 'Gujarat'
        },
        {
          code: 'HR',
          name: 'Haryana'
        },
        {
          code: 'HP',
          name: 'Himachal Pradesh'
        },
        {
          code: 'JK',
          name: 'Jammu and Kashmir'
        },
        {
          code: 'JH',
          name: 'Jharkhand'
        },
        {
          code: 'KA',
          name: 'Karnataka'
        },
        {
          code: 'KL',
          name: 'Kerala'
        },
        {
          code: 'LA',
          name: 'Ladakh'
        },
        {
          code: 'LD',
          name: 'Lakshadweep'
        },
        {
          code: 'MP',
          name: 'Madhya Pradesh'
        },
        {
          code: 'MH',
          name: 'Maharashtra'
        },
        {
          code: 'MN',
          name: 'Manipur'
        },
        {
          code: 'ML',
          name: 'Meghalaya'
        },
        {
          code: 'MZ',
          name: 'Mizoram'
        },
        {
          code: 'NL',
          name: 'Nagaland'
        },
        {
          code: 'OR',
          name: 'Odisha'
        },
        {
          code: 'PY',
          name: 'Puducherry'
        },
        {
          code: 'PB',
          name: 'Punjab'
        },
        {
          code: 'RJ',
          name: 'Rajasthan'
        },
        {
          code: 'SK',
          name: 'Sikkim'
        },
        {
          code: 'TN',
          name: 'Tamil Nadu'
        },
        {
          code: 'TG',
          name: 'Telangana'
        },
        {
          code: 'TR',
          name: 'Tripura'
        },
        {
          code: 'UP',
          name: 'Uttar Pradesh'
        },
        {
          code: 'UK',
          name: 'Uttarakhand'
        },
        {
          code: 'WB',
          name: 'West Bengal'
        }
      ]
    },
    {
      code: 'ID',
      name: 'Indonesia',
      states: [
        {
          code: 'AC',
          name: 'Aceh'
        },
        {
          code: 'BA',
          name: 'Bali'
        },
        {
          code: 'BT',
          name: 'Banten'
        },
        {
          code: 'BE',
          name: 'Bengkulu'
        },
        {
          code: 'YO',
          name: 'DI Yogyakarta'
        },
        {
          code: 'JK',
          name: 'DKI Jakarta'
        },
        {
          code: 'GO',
          name: 'Gorontalo'
        },
        {
          code: 'JA',
          name: 'Jambi'
        },
        {
          code: 'JB',
          name: 'Jawa Barat'
        },
        {
          code: 'JT',
          name: 'Jawa Tengah'
        },
        {
          code: 'JI',
          name: 'Jawa Timur'
        },
        {
          code: 'KB',
          name: 'Kalimantan Barat'
        },
        {
          code: 'KS',
          name: 'Kalimantan Selatan'
        },
        {
          code: 'KT',
          name: 'Kalimantan Tengah'
        },
        {
          code: 'KI',
          name: 'Kalimantan Timur'
        },
        {
          code: 'KU',
          name: 'Kalimantan Utara'
        },
        {
          code: 'BB',
          name: 'Kepulauan Bangka Belitung'
        },
        {
          code: 'KR',
          name: 'Kepulauan Riau'
        },
        {
          code: 'LA',
          name: 'Lampung'
        },
        {
          code: 'MA',
          name: 'Maluku'
        },
        {
          code: 'MU',
          name: 'Maluku Utara'
        },
        {
          code: 'NB',
          name: 'Nusa Tenggara Barat'
        },
        {
          code: 'NT',
          name: 'Nusa Tenggara Timur'
        },
        {
          code: 'PA',
          name: 'Papua'
        },
        {
          code: 'PB',
          name: 'Papua Barat'
        },
        {
          code: 'RI',
          name: 'Riau'
        },
        {
          code: 'SR',
          name: 'Sulawesi Barat'
        },
        {
          code: 'SN',
          name: 'Sulawesi Selatan'
        },
        {
          code: 'ST',
          name: 'Sulawesi Tengah'
        },
        {
          code: 'SG',
          name: 'Sulawesi Tenggara'
        },
        {
          code: 'SA',
          name: 'Sulawesi Utara'
        },
        {
          code: 'SB',
          name: 'Sumatera Barat'
        },
        {
          code: 'SS',
          name: 'Sumatera Selatan'
        },
        {
          code: 'SU',
          name: 'Sumatera Utara'
        }
      ]
    },
    {
      code: 'IR',
      name: 'Iran',
      states: [
        {
          code: '30',
          name: 'Alborz'
        },
        {
          code: '24',
          name: 'Ardabil'
        },
        {
          code: '18',
          name: 'Bushehr'
        },
        {
          code: '14',
          name: 'Chaharmahal and Bakhtiari'
        },
        {
          code: '03',
          name: 'East Azerbaijan'
        },
        {
          code: '07',
          name: 'Fars'
        },
        {
          code: '01',
          name: 'Gilan'
        },
        {
          code: '27',
          name: 'Golestan'
        },
        {
          code: '13',
          name: 'Hamadan'
        },
        {
          code: '22',
          name: 'Hormozgan'
        },
        {
          code: '16',
          name: 'Ilam'
        },
        {
          code: '10',
          name: 'Isfahan'
        },
        {
          code: '08',
          name: 'Kerman'
        },
        {
          code: '05',
          name: 'Kermanshah'
        },
        {
          code: '06',
          name: 'Khuzestan'
        },
        {
          code: '17',
          name: 'Kohgiluyeh and Boyer-Ahmad'
        },
        {
          code: '12',
          name: 'Kurdistan'
        },
        {
          code: '15',
          name: 'Lorestan'
        },
        {
          code: '00',
          name: 'Markazi'
        },
        {
          code: '02',
          name: 'Mazandaran'
        },
        {
          code: '28',
          name: 'North Khorasan'
        },
        {
          code: '26',
          name: 'Qazvin'
        },
        {
          code: '25',
          name: 'Qom'
        },
        {
          code: '09',
          name: 'Razavi Khorasan'
        },
        {
          code: '20',
          name: 'Semnan'
        },
        {
          code: '11',
          name: 'Sistan and Baluchestan'
        },
        {
          code: '29',
          name: 'South Khorasan'
        },
        {
          code: '23',
          name: 'Tehran'
        },
        {
          code: '04',
          name: 'West Azarbaijan'
        },
        {
          code: '21',
          name: 'Yazd'
        },
        {
          code: '19',
          name: 'Zanjan'
        }
      ]
    },
    {
      code: 'IQ',
      name: 'Iraq',
      states: [
        {
          code: 'AN',
          name: 'Al Anbar'
        },
        {
          code: 'MU',
          name: 'Al Muthanna'
        },
        {
          code: 'QA',
          name: 'Al-Qādisiyyah'
        },
        {
          code: 'BB',
          name: 'Babylon'
        },
        {
          code: 'BG',
          name: 'Baghdad'
        },
        {
          code: 'BA',
          name: 'Basra'
        },
        {
          code: 'DQ',
          name: 'Dhi Qar'
        },
        {
          code: 'DI',
          name: 'Diyala'
        },
        {
          code: 'DA',
          name: 'Dohuk'
        },
        {
          code: 'AR',
          name: 'Erbil'
        },
        {
          code: 'KA',
          name: 'Karbala'
        },
        {
          code: 'KI',
          name: 'Kirkuk'
        },
        {
          code: 'MA',
          name: 'Maysan'
        },
        {
          code: 'NA',
          name: 'Najaf'
        },
        {
          code: 'NI',
          name: 'Nineveh'
        },
        {
          code: 'SD',
          name: 'Saladin'
        },
        {
          code: 'SU',
          name: 'Sulaymaniyah'
        },
        {
          code: 'WA',
          name: 'Wasit'
        }
      ]
    },
    {
      code: 'IE',
      name: 'Ireland',
      states: [
        {
          code: 'CW',
          name: 'Carlow'
        },
        {
          code: 'CN',
          name: 'Cavan'
        },
        {
          code: 'CE',
          name: 'Clare'
        },
        {
          code: 'C',
          name: 'Connacht'
        },
        {
          code: 'CO',
          name: 'Cork'
        },
        {
          code: 'DL',
          name: 'Donegal'
        },
        {
          code: 'D',
          name: 'Dublin'
        },
        {
          code: 'G',
          name: 'Galway'
        },
        {
          code: 'KY',
          name: 'Kerry'
        },
        {
          code: 'KE',
          name: 'Kildare'
        },
        {
          code: 'KK',
          name: 'Kilkenny'
        },
        {
          code: 'LS',
          name: 'Laois'
        },
        {
          code: 'L',
          name: 'Leinster'
        },
        {
          code: 'LK',
          name: 'Limerick'
        },
        {
          code: 'LD',
          name: 'Longford'
        },
        {
          code: 'LH',
          name: 'Louth'
        },
        {
          code: 'MO',
          name: 'Mayo'
        },
        {
          code: 'MH',
          name: 'Meath'
        },
        {
          code: 'MN',
          name: 'Monaghan'
        },
        {
          code: 'M',
          name: 'Munster'
        },
        {
          code: 'OY',
          name: 'Offaly'
        },
        {
          code: 'RN',
          name: 'Roscommon'
        },
        {
          code: 'SO',
          name: 'Sligo'
        },
        {
          code: 'TA',
          name: 'Tipperary'
        },
        {
          code: 'U',
          name: 'Ulster'
        },
        {
          code: 'WD',
          name: 'Waterford'
        },
        {
          code: 'WH',
          name: 'Westmeath'
        },
        {
          code: 'WX',
          name: 'Wexford'
        },
        {
          code: 'WW',
          name: 'Wicklow'
        }
      ]
    },
    {
      code: 'IL',
      name: 'Israel',
      states: [
        {
          code: 'M',
          name: 'Central District'
        },
        {
          code: 'HA',
          name: 'Haifa District'
        },
        {
          code: 'JM',
          name: 'Jerusalem District'
        },
        {
          code: 'Z',
          name: 'Northern District'
        },
        {
          code: 'D',
          name: 'Southern District'
        },
        {
          code: 'TA',
          name: 'Tel Aviv District'
        }
      ]
    },
    {
      code: 'IT',
      name: 'Italy',
      states: [
        {
          code: '65',
          name: 'Abruzzo'
        },
        {
          code: 'AG',
          name: 'Agrigento'
        },
        {
          code: 'AL',
          name: 'Alessandria'
        },
        {
          code: 'AN',
          name: 'Ancona'
        },
        {
          code: '23',
          name: 'Aosta Valley'
        },
        {
          code: '75',
          name: 'Apulia'
        },
        {
          code: 'AP',
          name: 'Ascoli Piceno'
        },
        {
          code: 'AT',
          name: 'Asti'
        },
        {
          code: 'AV',
          name: 'Avellino'
        },
        {
          code: 'BT',
          name: 'Barletta-Andria-Trani'
        },
        {
          code: '77',
          name: 'Basilicata'
        },
        {
          code: 'BL',
          name: 'Belluno'
        },
        {
          code: 'BN',
          name: 'Benevento'
        },
        {
          code: 'BG',
          name: 'Bergamo'
        },
        {
          code: 'BI',
          name: 'Biella'
        },
        {
          code: 'BS',
          name: 'Brescia'
        },
        {
          code: 'BR',
          name: 'Brindisi'
        },
        {
          code: '78',
          name: 'Calabria'
        },
        {
          code: 'CL',
          name: 'Caltanissetta'
        },
        {
          code: '72',
          name: 'Campania'
        },
        {
          code: 'CB',
          name: 'Campobasso'
        },
        {
          code: 'CE',
          name: 'Caserta'
        },
        {
          code: 'CZ',
          name: 'Catanzaro'
        },
        {
          code: 'CH',
          name: 'Chieti'
        },
        {
          code: 'CO',
          name: 'Como'
        },
        {
          code: 'CS',
          name: 'Cosenza'
        },
        {
          code: 'CR',
          name: 'Cremona'
        },
        {
          code: 'KR',
          name: 'Crotone'
        },
        {
          code: 'CN',
          name: 'Cuneo'
        },
        {
          code: '45',
          name: 'Emilia-Romagna'
        },
        {
          code: 'EN',
          name: 'Enna'
        },
        {
          code: 'FM',
          name: 'Fermo'
        },
        {
          code: 'FE',
          name: 'Ferrara'
        },
        {
          code: 'FG',
          name: 'Foggia'
        },
        {
          code: 'FC',
          name: 'Forlì-Cesena'
        },
        {
          code: '36',
          name: 'Friuli\u2013Venezia Giulia'
        },
        {
          code: 'FR',
          name: 'Frosinone'
        },
        {
          code: 'GO',
          name: 'Gorizia'
        },
        {
          code: 'GR',
          name: 'Grosseto'
        },
        {
          code: 'IM',
          name: 'Imperia'
        },
        {
          code: 'IS',
          name: 'Isernia'
        },
        {
          code: 'AQ',
          name: "L'Aquila"
        },
        {
          code: 'SP',
          name: 'La Spezia'
        },
        {
          code: 'LT',
          name: 'Latina'
        },
        {
          code: '62',
          name: 'Lazio'
        },
        {
          code: 'LE',
          name: 'Lecce'
        },
        {
          code: 'LC',
          name: 'Lecco'
        },
        {
          code: '42',
          name: 'Liguria'
        },
        {
          code: 'LI',
          name: 'Livorno'
        },
        {
          code: 'LO',
          name: 'Lodi'
        },
        {
          code: '25',
          name: 'Lombardy'
        },
        {
          code: 'LU',
          name: 'Lucca'
        },
        {
          code: 'MC',
          name: 'Macerata'
        },
        {
          code: 'MN',
          name: 'Mantua'
        },
        {
          code: '57',
          name: 'Marche'
        },
        {
          code: 'MS',
          name: 'Massa and Carrara'
        },
        {
          code: 'MT',
          name: 'Matera'
        },
        {
          code: 'VS',
          name: 'Medio Campidano'
        },
        {
          code: 'MO',
          name: 'Modena'
        },
        {
          code: '67',
          name: 'Molise'
        },
        {
          code: 'MB',
          name: 'Monza and Brianza'
        },
        {
          code: 'NO',
          name: 'Novara'
        },
        {
          code: 'NU',
          name: 'Nuoro'
        },
        {
          code: 'OR',
          name: 'Oristano'
        },
        {
          code: 'PD',
          name: 'Padua'
        },
        {
          code: 'PA',
          name: 'Palermo'
        },
        {
          code: 'PR',
          name: 'Parma'
        },
        {
          code: 'PV',
          name: 'Pavia'
        },
        {
          code: 'PG',
          name: 'Perugia'
        },
        {
          code: 'PU',
          name: 'Pesaro and Urbino'
        },
        {
          code: 'PE',
          name: 'Pescara'
        },
        {
          code: 'PC',
          name: 'Piacenza'
        },
        {
          code: '21',
          name: 'Piedmont'
        },
        {
          code: 'PI',
          name: 'Pisa'
        },
        {
          code: 'PT',
          name: 'Pistoia'
        },
        {
          code: 'PN',
          name: 'Pordenone'
        },
        {
          code: 'PZ',
          name: 'Potenza'
        },
        {
          code: 'PO',
          name: 'Prato'
        },
        {
          code: 'RG',
          name: 'Ragusa'
        },
        {
          code: 'RA',
          name: 'Ravenna'
        },
        {
          code: 'RE',
          name: 'Reggio Emilia'
        },
        {
          code: 'RI',
          name: 'Rieti'
        },
        {
          code: 'RN',
          name: 'Rimini'
        },
        {
          code: 'RO',
          name: 'Rovigo'
        },
        {
          code: 'SA',
          name: 'Salerno'
        },
        {
          code: '88',
          name: 'Sardinia'
        },
        {
          code: 'SS',
          name: 'Sassari'
        },
        {
          code: 'SV',
          name: 'Savona'
        },
        {
          code: '82',
          name: 'Sicily'
        },
        {
          code: 'SI',
          name: 'Siena'
        },
        {
          code: 'SR',
          name: 'Siracusa'
        },
        {
          code: 'SO',
          name: 'Sondrio'
        },
        {
          code: 'SU',
          name: 'South Sardinia'
        },
        {
          code: 'TA',
          name: 'Taranto'
        },
        {
          code: 'TE',
          name: 'Teramo'
        },
        {
          code: 'TR',
          name: 'Terni'
        },
        {
          code: 'TP',
          name: 'Trapani'
        },
        {
          code: '32',
          name: 'Trentino-South Tyrol'
        },
        {
          code: 'TV',
          name: 'Treviso'
        },
        {
          code: 'TS',
          name: 'Trieste'
        },
        {
          code: '52',
          name: 'Tuscany'
        },
        {
          code: 'UD',
          name: 'Udine'
        },
        {
          code: '55',
          name: 'Umbria'
        },
        {
          code: 'VA',
          name: 'Varese'
        },
        {
          code: '34',
          name: 'Veneto'
        },
        {
          code: 'VB',
          name: 'Verbano-Cusio-Ossola'
        },
        {
          code: 'VC',
          name: 'Vercelli'
        },
        {
          code: 'VR',
          name: 'Verona'
        },
        {
          code: 'VV',
          name: 'Vibo Valentia'
        },
        {
          code: 'VI',
          name: 'Vicenza'
        },
        {
          code: 'VT',
          name: 'Viterbo'
        }
      ]
    },
    {
      code: 'JM',
      name: 'Jamaica',
      states: [
        {
          code: '13',
          name: 'Clarendon Parish'
        },
        {
          code: '09',
          name: 'Hanover Parish'
        },
        {
          code: '01',
          name: 'Kingston Parish'
        },
        {
          code: '12',
          name: 'Manchester Parish'
        },
        {
          code: '04',
          name: 'Portland Parish'
        },
        {
          code: '02',
          name: 'Saint Andrew'
        },
        {
          code: '06',
          name: 'Saint Ann Parish'
        },
        {
          code: '14',
          name: 'Saint Catherine Parish'
        },
        {
          code: '11',
          name: 'Saint Elizabeth Parish'
        },
        {
          code: '08',
          name: 'Saint James Parish'
        },
        {
          code: '05',
          name: 'Saint Mary Parish'
        },
        {
          code: '03',
          name: 'Saint Thomas Parish'
        },
        {
          code: '07',
          name: 'Trelawny Parish'
        },
        {
          code: '10',
          name: 'Westmoreland Parish'
        }
      ]
    },
    {
      code: 'JP',
      name: 'Japan',
      states: [
        {
          code: '23',
          name: 'Aichi Prefecture'
        },
        {
          code: '05',
          name: 'Akita Prefecture'
        },
        {
          code: '02',
          name: 'Aomori Prefecture'
        },
        {
          code: '12',
          name: 'Chiba Prefecture'
        },
        {
          code: '38',
          name: 'Ehime Prefecture'
        },
        {
          code: '18',
          name: 'Fukui Prefecture'
        },
        {
          code: '40',
          name: 'Fukuoka Prefecture'
        },
        {
          code: '07',
          name: 'Fukushima Prefecture'
        },
        {
          code: '21',
          name: 'Gifu Prefecture'
        },
        {
          code: '10',
          name: 'Gunma Prefecture'
        },
        {
          code: '34',
          name: 'Hiroshima Prefecture'
        },
        {
          code: '01',
          name: 'Hokkaidō Prefecture'
        },
        {
          code: '28',
          name: 'Hyōgo Prefecture'
        },
        {
          code: '08',
          name: 'Ibaraki Prefecture'
        },
        {
          code: '17',
          name: 'Ishikawa Prefecture'
        },
        {
          code: '03',
          name: 'Iwate Prefecture'
        },
        {
          code: '37',
          name: 'Kagawa Prefecture'
        },
        {
          code: '46',
          name: 'Kagoshima Prefecture'
        },
        {
          code: '14',
          name: 'Kanagawa Prefecture'
        },
        {
          code: '39',
          name: 'Kōchi Prefecture'
        },
        {
          code: '43',
          name: 'Kumamoto Prefecture'
        },
        {
          code: '26',
          name: 'Kyōto Prefecture'
        },
        {
          code: '24',
          name: 'Mie Prefecture'
        },
        {
          code: '04',
          name: 'Miyagi Prefecture'
        },
        {
          code: '45',
          name: 'Miyazaki Prefecture'
        },
        {
          code: '20',
          name: 'Nagano Prefecture'
        },
        {
          code: '42',
          name: 'Nagasaki Prefecture'
        },
        {
          code: '29',
          name: 'Nara Prefecture'
        },
        {
          code: '15',
          name: 'Niigata Prefecture'
        },
        {
          code: '44',
          name: 'Ōita Prefecture'
        },
        {
          code: '33',
          name: 'Okayama Prefecture'
        },
        {
          code: '47',
          name: 'Okinawa Prefecture'
        },
        {
          code: '27',
          name: 'Ōsaka Prefecture'
        },
        {
          code: '41',
          name: 'Saga Prefecture'
        },
        {
          code: '11',
          name: 'Saitama Prefecture'
        },
        {
          code: '25',
          name: 'Shiga Prefecture'
        },
        {
          code: '32',
          name: 'Shimane Prefecture'
        },
        {
          code: '22',
          name: 'Shizuoka Prefecture'
        },
        {
          code: '09',
          name: 'Tochigi Prefecture'
        },
        {
          code: '36',
          name: 'Tokushima Prefecture'
        },
        {
          code: '13',
          name: 'Tokyo'
        },
        {
          code: '31',
          name: 'Tottori Prefecture'
        },
        {
          code: '16',
          name: 'Toyama Prefecture'
        },
        {
          code: '30',
          name: 'Wakayama Prefecture'
        },
        {
          code: '06',
          name: 'Yamagata Prefecture'
        },
        {
          code: '35',
          name: 'Yamaguchi Prefecture'
        },
        {
          code: '19',
          name: 'Yamanashi Prefecture'
        }
      ]
    },
    {
      code: 'JE',
      name: 'Jersey',
      states: []
    },
    {
      code: 'JO',
      name: 'Jordan',
      states: [
        {
          code: 'AJ',
          name: 'Ajloun'
        },
        {
          code: 'AM',
          name: 'Amman'
        },
        {
          code: 'AQ',
          name: 'Aqaba'
        },
        {
          code: 'BA',
          name: 'Balqa'
        },
        {
          code: 'IR',
          name: 'Irbid'
        },
        {
          code: 'JA',
          name: 'Jerash'
        },
        {
          code: 'KA',
          name: 'Karak'
        },
        {
          code: 'MN',
          name: "Ma'an"
        },
        {
          code: 'MD',
          name: 'Madaba'
        },
        {
          code: 'MA',
          name: 'Mafraq'
        },
        {
          code: 'AT',
          name: 'Tafilah'
        },
        {
          code: 'AZ',
          name: 'Zarqa'
        }
      ]
    },
    {
      code: 'KZ',
      name: 'Kazakhstan',
      states: [
        {
          code: 'AKM',
          name: 'Akmola Region'
        },
        {
          code: 'AKT',
          name: 'Aktobe Region'
        },
        {
          code: 'ALA',
          name: 'Almaty'
        },
        {
          code: 'ALM',
          name: 'Almaty Region'
        },
        {
          code: 'ATY',
          name: 'Atyrau Region'
        },
        {
          code: 'BAY',
          name: 'Baikonur'
        },
        {
          code: 'VOS',
          name: 'East Kazakhstan Region'
        },
        {
          code: 'ZHA',
          name: 'Jambyl Region'
        },
        {
          code: 'KAR',
          name: 'Karaganda Region'
        },
        {
          code: 'KUS',
          name: 'Kostanay Region'
        },
        {
          code: 'KZY',
          name: 'Kyzylorda Region'
        },
        {
          code: 'MAN',
          name: 'Mangystau Region'
        },
        {
          code: 'SEV',
          name: 'North Kazakhstan Region'
        },
        {
          code: 'AST',
          name: 'Nur-Sultan'
        },
        {
          code: 'PAV',
          name: 'Pavlodar Region'
        },
        {
          code: 'YUZ',
          name: 'Turkestan Region'
        },
        {
          code: 'ZAP',
          name: 'West Kazakhstan Province'
        }
      ]
    },
    {
      code: 'KE',
      name: 'Kenya',
      states: [
        {
          code: '01',
          name: 'Baringo'
        },
        {
          code: '02',
          name: 'Bomet'
        },
        {
          code: '03',
          name: 'Bungoma'
        },
        {
          code: '04',
          name: 'Busia'
        },
        {
          code: '05',
          name: 'Elgeyo-Marakwet'
        },
        {
          code: '06',
          name: 'Embu'
        },
        {
          code: '07',
          name: 'Garissa'
        },
        {
          code: '08',
          name: 'Homa Bay'
        },
        {
          code: '09',
          name: 'Isiolo'
        },
        {
          code: '10',
          name: 'Kajiado'
        },
        {
          code: '11',
          name: 'Kakamega'
        },
        {
          code: '12',
          name: 'Kericho'
        },
        {
          code: '13',
          name: 'Kiambu'
        },
        {
          code: '14',
          name: 'Kilifi'
        },
        {
          code: '15',
          name: 'Kirinyaga'
        },
        {
          code: '16',
          name: 'Kisii'
        },
        {
          code: '17',
          name: 'Kisumu'
        },
        {
          code: '18',
          name: 'Kitui'
        },
        {
          code: '19',
          name: 'Kwale'
        },
        {
          code: '20',
          name: 'Laikipia'
        },
        {
          code: '21',
          name: 'Lamu'
        },
        {
          code: '22',
          name: 'Machakos'
        },
        {
          code: '23',
          name: 'Makueni'
        },
        {
          code: '24',
          name: 'Mandera'
        },
        {
          code: '25',
          name: 'Marsabit'
        },
        {
          code: '26',
          name: 'Meru'
        },
        {
          code: '27',
          name: 'Migori'
        },
        {
          code: '28',
          name: 'Mombasa'
        },
        {
          code: '29',
          name: "Murang'a"
        },
        {
          code: '30',
          name: 'Nairobi City'
        },
        {
          code: '31',
          name: 'Nakuru'
        },
        {
          code: '32',
          name: 'Nandi'
        },
        {
          code: '33',
          name: 'Narok'
        },
        {
          code: '34',
          name: 'Nyamira'
        },
        {
          code: '35',
          name: 'Nyandarua'
        },
        {
          code: '36',
          name: 'Nyeri'
        },
        {
          code: '37',
          name: 'Samburu'
        },
        {
          code: '38',
          name: 'Siaya'
        },
        {
          code: '39',
          name: 'Taita\u2013Taveta'
        },
        {
          code: '40',
          name: 'Tana River'
        },
        {
          code: '41',
          name: 'Tharaka-Nithi'
        },
        {
          code: '42',
          name: 'Trans Nzoia'
        },
        {
          code: '43',
          name: 'Turkana'
        },
        {
          code: '44',
          name: 'Uasin Gishu'
        },
        {
          code: '45',
          name: 'Vihiga'
        },
        {
          code: '46',
          name: 'Wajir'
        },
        {
          code: '47',
          name: 'West Pokot'
        }
      ]
    },
    {
      code: 'KI',
      name: 'Kiribati',
      states: [
        {
          code: 'G',
          name: 'Gilbert Islands'
        },
        {
          code: 'L',
          name: 'Line Islands'
        },
        {
          code: 'P',
          name: 'Phoenix Islands'
        }
      ]
    },
    {
      code: 'XK',
      name: 'Kosovo',
      states: [
        {
          code: 'XDG',
          name: 'Đakovica District (Gjakove)'
        },
        {
          code: 'XGJ',
          name: 'Gjilan District'
        },
        {
          code: 'XKM',
          name: 'Kosovska Mitrovica District'
        },
        {
          code: 'XPE',
          name: 'Peć District'
        },
        {
          code: 'XPI',
          name: 'Pristina (Priştine)'
        },
        {
          code: 'XPR',
          name: 'Prizren District'
        },
        {
          code: 'XUF',
          name: 'Uroševac District (Ferizaj)'
        }
      ]
    },
    {
      code: 'KW',
      name: 'Kuwait',
      states: [
        {
          code: 'AH',
          name: 'Al Ahmadi'
        },
        {
          code: 'FA',
          name: 'Al Farwaniyah'
        },
        {
          code: 'JA',
          name: 'Al Jahra'
        },
        {
          code: 'KU',
          name: 'Capital'
        },
        {
          code: 'HA',
          name: 'Hawalli'
        },
        {
          code: 'MU',
          name: 'Mubarak Al-Kabeer'
        }
      ]
    },
    {
      code: 'KG',
      name: 'Kyrgyzstan',
      states: [
        {
          code: 'B',
          name: 'Batken Region'
        },
        {
          code: 'GB',
          name: 'Bishkek'
        },
        {
          code: 'C',
          name: 'Chuy Region'
        },
        {
          code: 'Y',
          name: 'Issyk-Kul Region'
        },
        {
          code: 'J',
          name: 'Jalal-Abad Region'
        },
        {
          code: 'N',
          name: 'Naryn Region'
        },
        {
          code: 'GO',
          name: 'Osh'
        },
        {
          code: 'O',
          name: 'Osh Region'
        },
        {
          code: 'T',
          name: 'Talas Region'
        }
      ]
    },
    {
      code: 'LA',
      name: 'Laos',
      states: [
        {
          code: 'AT',
          name: 'Attapeu Province'
        },
        {
          code: 'BK',
          name: 'Bokeo Province'
        },
        {
          code: 'BL',
          name: 'Bolikhamsai Province'
        },
        {
          code: 'CH',
          name: 'Champasak Province'
        },
        {
          code: 'HO',
          name: 'Houaphanh Province'
        },
        {
          code: 'KH',
          name: 'Khammouane Province'
        },
        {
          code: 'LM',
          name: 'Luang Namtha Province'
        },
        {
          code: 'LP',
          name: 'Luang Prabang Province'
        },
        {
          code: 'OU',
          name: 'Oudomxay Province'
        },
        {
          code: 'PH',
          name: 'Phongsaly Province'
        },
        {
          code: 'XA',
          name: 'Sainyabuli Province'
        },
        {
          code: 'SL',
          name: 'Salavan Province'
        },
        {
          code: 'SV',
          name: 'Savannakhet Province'
        },
        {
          code: 'XE',
          name: 'Sekong Province'
        },
        {
          code: 'VT',
          name: 'Vientiane Prefecture'
        },
        {
          code: 'VI',
          name: 'Vientiane Province'
        },
        {
          code: 'XN',
          name: 'Xaisomboun'
        },
        {
          code: 'XS',
          name: 'Xaisomboun Province'
        },
        {
          code: 'XI',
          name: 'Xiangkhouang Province'
        }
      ]
    },
    {
      code: 'LV',
      name: 'Latvia',
      states: [
        {
          code: '001',
          name: 'Aglona Municipality'
        },
        {
          code: '002',
          name: 'Aizkraukle Municipality'
        },
        {
          code: '003',
          name: 'Aizpute Municipality'
        },
        {
          code: '004',
          name: 'Aknīste Municipality'
        },
        {
          code: '005',
          name: 'Aloja Municipality'
        },
        {
          code: '006',
          name: 'Alsunga Municipality'
        },
        {
          code: '007',
          name: 'Alūksne Municipality'
        },
        {
          code: '008',
          name: 'Amata Municipality'
        },
        {
          code: '009',
          name: 'Ape Municipality'
        },
        {
          code: '010',
          name: 'Auce Municipality'
        },
        {
          code: '012',
          name: 'Babīte Municipality'
        },
        {
          code: '013',
          name: 'Baldone Municipality'
        },
        {
          code: '014',
          name: 'Baltinava Municipality'
        },
        {
          code: '015',
          name: 'Balvi Municipality'
        },
        {
          code: '016',
          name: 'Bauska Municipality'
        },
        {
          code: '017',
          name: 'Beverīna Municipality'
        },
        {
          code: '018',
          name: 'Brocēni Municipality'
        },
        {
          code: '019',
          name: 'Burtnieki Municipality'
        },
        {
          code: '020',
          name: 'Carnikava Municipality'
        },
        {
          code: '022',
          name: 'Cēsis Municipality'
        },
        {
          code: '021',
          name: 'Cesvaine Municipality'
        },
        {
          code: '023',
          name: 'Cibla Municipality'
        },
        {
          code: '024',
          name: 'Dagda Municipality'
        },
        {
          code: 'DGV',
          name: 'Daugavpils'
        },
        {
          code: '025',
          name: 'Daugavpils Municipality'
        },
        {
          code: '026',
          name: 'Dobele Municipality'
        },
        {
          code: '027',
          name: 'Dundaga Municipality'
        },
        {
          code: '028',
          name: 'Durbe Municipality'
        },
        {
          code: '029',
          name: 'Engure Municipality'
        },
        {
          code: '030',
          name: 'Ērgļi Municipality'
        },
        {
          code: '031',
          name: 'Garkalne Municipality'
        },
        {
          code: '032',
          name: 'Grobiņa Municipality'
        },
        {
          code: '033',
          name: 'Gulbene Municipality'
        },
        {
          code: '034',
          name: 'Iecava Municipality'
        },
        {
          code: '035',
          name: 'Ikšķile Municipality'
        },
        {
          code: '036',
          name: 'Ilūkste Municipality'
        },
        {
          code: '037',
          name: 'Inčukalns Municipality'
        },
        {
          code: '038',
          name: 'Jaunjelgava Municipality'
        },
        {
          code: '039',
          name: 'Jaunpiebalga Municipality'
        },
        {
          code: '040',
          name: 'Jaunpils Municipality'
        },
        {
          code: 'JKB',
          name: 'Jēkabpils'
        },
        {
          code: '042',
          name: 'Jēkabpils Municipality'
        },
        {
          code: 'JEL',
          name: 'Jelgava'
        },
        {
          code: '041',
          name: 'Jelgava Municipality'
        },
        {
          code: 'JUR',
          name: 'Jūrmala'
        },
        {
          code: '043',
          name: 'Kandava Municipality'
        },
        {
          code: '044',
          name: 'Kārsava Municipality'
        },
        {
          code: '051',
          name: 'Ķegums Municipality'
        },
        {
          code: '052',
          name: 'Ķekava Municipality'
        },
        {
          code: '045',
          name: 'Kocēni Municipality'
        },
        {
          code: '046',
          name: 'Koknese Municipality'
        },
        {
          code: '047',
          name: 'Krāslava Municipality'
        },
        {
          code: '048',
          name: 'Krimulda Municipality'
        },
        {
          code: '049',
          name: 'Krustpils Municipality'
        },
        {
          code: '050',
          name: 'Kuldīga Municipality'
        },
        {
          code: '053',
          name: 'Lielvārde Municipality'
        },
        {
          code: 'LPX',
          name: 'Liepāja'
        },
        {
          code: '055',
          name: 'Līgatne Municipality'
        },
        {
          code: '054',
          name: 'Limbaži Municipality'
        },
        {
          code: '056',
          name: 'Līvāni Municipality'
        },
        {
          code: '057',
          name: 'Lubāna Municipality'
        },
        {
          code: '058',
          name: 'Ludza Municipality'
        },
        {
          code: '059',
          name: 'Madona Municipality'
        },
        {
          code: '061',
          name: 'Mālpils Municipality'
        },
        {
          code: '062',
          name: 'Mārupe Municipality'
        },
        {
          code: '060',
          name: 'Mazsalaca Municipality'
        },
        {
          code: '063',
          name: 'Mērsrags Municipality'
        },
        {
          code: '064',
          name: 'Naukšēni Municipality'
        },
        {
          code: '065',
          name: 'Nereta Municipality'
        },
        {
          code: '066',
          name: 'Nīca Municipality'
        },
        {
          code: '067',
          name: 'Ogre Municipality'
        },
        {
          code: '068',
          name: 'Olaine Municipality'
        },
        {
          code: '069',
          name: 'Ozolnieki Municipality'
        },
        {
          code: '070',
          name: 'Pārgauja Municipality'
        },
        {
          code: '071',
          name: 'Pāvilosta Municipality'
        },
        {
          code: '072',
          name: 'Pļaviņas Municipality'
        },
        {
          code: '073',
          name: 'Preiļi Municipality'
        },
        {
          code: '074',
          name: 'Priekule Municipality'
        },
        {
          code: '075',
          name: 'Priekuļi Municipality'
        },
        {
          code: '076',
          name: 'Rauna Municipality'
        },
        {
          code: 'REZ',
          name: 'Rēzekne'
        },
        {
          code: '077',
          name: 'Rēzekne Municipality'
        },
        {
          code: '078',
          name: 'Riebiņi Municipality'
        },
        {
          code: 'RIX',
          name: 'Riga'
        },
        {
          code: '079',
          name: 'Roja Municipality'
        },
        {
          code: '080',
          name: 'Ropaži Municipality'
        },
        {
          code: '081',
          name: 'Rucava Municipality'
        },
        {
          code: '082',
          name: 'Rugāji Municipality'
        },
        {
          code: '084',
          name: 'Rūjiena Municipality'
        },
        {
          code: '083',
          name: 'Rundāle Municipality'
        },
        {
          code: '085',
          name: 'Sala Municipality'
        },
        {
          code: '086',
          name: 'Salacgrīva Municipality'
        },
        {
          code: '087',
          name: 'Salaspils Municipality'
        },
        {
          code: '088',
          name: 'Saldus Municipality'
        },
        {
          code: '089',
          name: 'Saulkrasti Municipality'
        },
        {
          code: '090',
          name: 'Sēja Municipality'
        },
        {
          code: '091',
          name: 'Sigulda Municipality'
        },
        {
          code: '092',
          name: 'Skrīveri Municipality'
        },
        {
          code: '093',
          name: 'Skrunda Municipality'
        },
        {
          code: '094',
          name: 'Smiltene Municipality'
        },
        {
          code: '095',
          name: 'Stopiņi Municipality'
        },
        {
          code: '096',
          name: 'Strenči Municipality'
        },
        {
          code: '097',
          name: 'Talsi Municipality'
        },
        {
          code: '098',
          name: 'Tērvete Municipality'
        },
        {
          code: '099',
          name: 'Tukums Municipality'
        },
        {
          code: '100',
          name: 'Vaiņode Municipality'
        },
        {
          code: '101',
          name: 'Valka Municipality'
        },
        {
          code: 'VMR',
          name: 'Valmiera'
        },
        {
          code: '102',
          name: 'Varakļāni Municipality'
        },
        {
          code: '103',
          name: 'Vārkava Municipality'
        },
        {
          code: '104',
          name: 'Vecpiebalga Municipality'
        },
        {
          code: '105',
          name: 'Vecumnieki Municipality'
        },
        {
          code: 'VEN',
          name: 'Ventspils'
        },
        {
          code: '106',
          name: 'Ventspils Municipality'
        },
        {
          code: '107',
          name: 'Viesīte Municipality'
        },
        {
          code: '108',
          name: 'Viļaka Municipality'
        },
        {
          code: '109',
          name: 'Viļāni Municipality'
        },
        {
          code: '110',
          name: 'Zilupe Municipality'
        }
      ]
    },
    {
      code: 'LB',
      name: 'Lebanon',
      states: [
        {
          code: 'AK',
          name: 'Akkar'
        },
        {
          code: 'BH',
          name: 'Baalbek-Hermel'
        },
        {
          code: 'BA',
          name: 'Beirut'
        },
        {
          code: 'BI',
          name: 'Beqaa'
        },
        {
          code: 'JL',
          name: 'Mount Lebanon'
        },
        {
          code: 'NA',
          name: 'Nabatieh'
        },
        {
          code: 'AS',
          name: 'North'
        },
        {
          code: 'JA',
          name: 'South'
        }
      ]
    },
    {
      code: 'LS',
      name: 'Lesotho',
      states: [
        {
          code: 'D',
          name: 'Berea District'
        },
        {
          code: 'B',
          name: 'Butha-Buthe District'
        },
        {
          code: 'C',
          name: 'Leribe District'
        },
        {
          code: 'E',
          name: 'Mafeteng District'
        },
        {
          code: 'A',
          name: 'Maseru District'
        },
        {
          code: 'F',
          name: "Mohale's Hoek District"
        },
        {
          code: 'J',
          name: 'Mokhotlong District'
        },
        {
          code: 'H',
          name: "Qacha's Nek District"
        },
        {
          code: 'G',
          name: 'Quthing District'
        },
        {
          code: 'K',
          name: 'Thaba-Tseka District'
        }
      ]
    },
    {
      code: 'LR',
      name: 'Liberia',
      states: [
        {
          code: 'BM',
          name: 'Bomi County'
        },
        {
          code: 'BG',
          name: 'Bong County'
        },
        {
          code: 'GP',
          name: 'Gbarpolu County'
        },
        {
          code: 'GB',
          name: 'Grand Bassa County'
        },
        {
          code: 'CM',
          name: 'Grand Cape Mount County'
        },
        {
          code: 'GG',
          name: 'Grand Gedeh County'
        },
        {
          code: 'GK',
          name: 'Grand Kru County'
        },
        {
          code: 'LO',
          name: 'Lofa County'
        },
        {
          code: 'MG',
          name: 'Margibi County'
        },
        {
          code: 'MY',
          name: 'Maryland County'
        },
        {
          code: 'MO',
          name: 'Montserrado County'
        },
        {
          code: 'NI',
          name: 'Nimba'
        },
        {
          code: 'RI',
          name: 'River Cess County'
        },
        {
          code: 'RG',
          name: 'River Gee County'
        },
        {
          code: 'SI',
          name: 'Sinoe County'
        }
      ]
    },
    {
      code: 'LY',
      name: 'Libya',
      states: [
        {
          code: 'WA',
          name: 'Al Wahat District'
        },
        {
          code: 'BA',
          name: 'Benghazi'
        },
        {
          code: 'DR',
          name: 'Derna District'
        },
        {
          code: 'GT',
          name: 'Ghat District'
        },
        {
          code: 'JA',
          name: 'Jabal al Akhdar'
        },
        {
          code: 'JG',
          name: 'Jabal al Gharbi District'
        },
        {
          code: 'JI',
          name: 'Jafara'
        },
        {
          code: 'JU',
          name: 'Jufra'
        },
        {
          code: 'KF',
          name: 'Kufra District'
        },
        {
          code: 'MJ',
          name: 'Marj District'
        },
        {
          code: 'MI',
          name: 'Misrata District'
        },
        {
          code: 'MB',
          name: 'Murqub'
        },
        {
          code: 'MQ',
          name: 'Murzuq District'
        },
        {
          code: 'NL',
          name: 'Nalut District'
        },
        {
          code: 'NQ',
          name: 'Nuqat al Khams'
        },
        {
          code: 'SB',
          name: 'Sabha District'
        },
        {
          code: 'SR',
          name: 'Sirte District'
        },
        {
          code: 'TB',
          name: 'Tripoli District'
        },
        {
          code: 'WD',
          name: 'Wadi al Hayaa District'
        },
        {
          code: 'WS',
          name: 'Wadi al Shatii District'
        },
        {
          code: 'ZA',
          name: 'Zawiya District'
        }
      ]
    },
    {
      code: 'LI',
      name: 'Liechtenstein',
      states: [
        {
          code: '01',
          name: 'Balzers'
        },
        {
          code: '02',
          name: 'Eschen'
        },
        {
          code: '03',
          name: 'Gamprin'
        },
        {
          code: '04',
          name: 'Mauren'
        },
        {
          code: '05',
          name: 'Planken'
        },
        {
          code: '06',
          name: 'Ruggell'
        },
        {
          code: '07',
          name: 'Schaan'
        },
        {
          code: '08',
          name: 'Schellenberg'
        },
        {
          code: '09',
          name: 'Triesen'
        },
        {
          code: '10',
          name: 'Triesenberg'
        },
        {
          code: '11',
          name: 'Vaduz'
        }
      ]
    },
    {
      code: 'LT',
      name: 'Lithuania',
      states: [
        {
          code: '01',
          name: 'Akmenė District Municipality'
        },
        {
          code: '02',
          name: 'Alytus City Municipality'
        },
        {
          code: 'AL',
          name: 'Alytus County'
        },
        {
          code: '03',
          name: 'Alytus District Municipality'
        },
        {
          code: '05',
          name: 'Birštonas Municipality'
        },
        {
          code: '06',
          name: 'Biržai District Municipality'
        },
        {
          code: '07',
          name: 'Druskininkai municipality'
        },
        {
          code: '08',
          name: 'Elektrėnai municipality'
        },
        {
          code: '09',
          name: 'Ignalina District Municipality'
        },
        {
          code: '10',
          name: 'Jonava District Municipality'
        },
        {
          code: '11',
          name: 'Joniškis District Municipality'
        },
        {
          code: '12',
          name: 'Jurbarkas District Municipality'
        },
        {
          code: '13',
          name: 'Kaišiadorys District Municipality'
        },
        {
          code: '14',
          name: 'Kalvarija municipality'
        },
        {
          code: '15',
          name: 'Kaunas City Municipality'
        },
        {
          code: 'KU',
          name: 'Kaunas County'
        },
        {
          code: '16',
          name: 'Kaunas District Municipality'
        },
        {
          code: '17',
          name: 'Kazlų Rūda municipality'
        },
        {
          code: '18',
          name: 'Kėdainiai District Municipality'
        },
        {
          code: '19',
          name: 'Kelmė District Municipality'
        },
        {
          code: '20',
          name: 'Klaipeda City Municipality'
        },
        {
          code: 'KL',
          name: 'Klaipėda County'
        },
        {
          code: '21',
          name: 'Klaipėda District Municipality'
        },
        {
          code: '22',
          name: 'Kretinga District Municipality'
        },
        {
          code: '23',
          name: 'Kupiškis District Municipality'
        },
        {
          code: '24',
          name: 'Lazdijai District Municipality'
        },
        {
          code: 'MR',
          name: 'Marijampolė County'
        },
        {
          code: '25',
          name: 'Marijampolė Municipality'
        },
        {
          code: '26',
          name: 'Mažeikiai District Municipality'
        },
        {
          code: '27',
          name: 'Molėtai District Municipality'
        },
        {
          code: '28',
          name: 'Neringa Municipality'
        },
        {
          code: '29',
          name: 'Pagėgiai municipality'
        },
        {
          code: '30',
          name: 'Pakruojis District Municipality'
        },
        {
          code: '31',
          name: 'Palanga City Municipality'
        },
        {
          code: '32',
          name: 'Panevėžys City Municipality'
        },
        {
          code: 'PN',
          name: 'Panevėžys County'
        },
        {
          code: '33',
          name: 'Panevėžys District Municipality'
        },
        {
          code: '34',
          name: 'Pasvalys District Municipality'
        },
        {
          code: '35',
          name: 'Plungė District Municipality'
        },
        {
          code: '36',
          name: 'Prienai District Municipality'
        },
        {
          code: '37',
          name: 'Radviliškis District Municipality'
        },
        {
          code: '38',
          name: 'Raseiniai District Municipality'
        },
        {
          code: '39',
          name: 'Rietavas municipality'
        },
        {
          code: '40',
          name: 'Rokiškis District Municipality'
        },
        {
          code: '41',
          name: 'Šakiai District Municipality'
        },
        {
          code: '42',
          name: 'Šalčininkai District Municipality'
        },
        {
          code: '43',
          name: 'Šiauliai City Municipality'
        },
        {
          code: 'SA',
          name: 'Šiauliai County'
        },
        {
          code: '44',
          name: 'Šiauliai District Municipality'
        },
        {
          code: '45',
          name: 'Šilalė District Municipality'
        },
        {
          code: '46',
          name: 'Šilutė District Municipality'
        },
        {
          code: '47',
          name: 'Širvintos District Municipality'
        },
        {
          code: '48',
          name: 'Skuodas District Municipality'
        },
        {
          code: '49',
          name: 'Švenčionys District Municipality'
        },
        {
          code: 'TA',
          name: 'Tauragė County'
        },
        {
          code: '50',
          name: 'Tauragė District Municipality'
        },
        {
          code: 'TE',
          name: 'Telšiai County'
        },
        {
          code: '51',
          name: 'Telšiai District Municipality'
        },
        {
          code: '52',
          name: 'Trakai District Municipality'
        },
        {
          code: '53',
          name: 'Ukmergė District Municipality'
        },
        {
          code: 'UT',
          name: 'Utena County'
        },
        {
          code: '54',
          name: 'Utena District Municipality'
        },
        {
          code: '55',
          name: 'Varėna District Municipality'
        },
        {
          code: '56',
          name: 'Vilkaviškis District Municipality'
        },
        {
          code: '57',
          name: 'Vilnius City Municipality'
        },
        {
          code: 'VL',
          name: 'Vilnius County'
        },
        {
          code: '58',
          name: 'Vilnius District Municipality'
        },
        {
          code: '59',
          name: 'Visaginas Municipality'
        },
        {
          code: '60',
          name: 'Zarasai District Municipality'
        }
      ]
    },
    {
      code: 'LU',
      name: 'Luxembourg',
      states: [
        {
          code: 'CA',
          name: 'Canton of Capellen'
        },
        {
          code: 'CL',
          name: 'Canton of Clervaux'
        },
        {
          code: 'DI',
          name: 'Canton of Diekirch'
        },
        {
          code: 'EC',
          name: 'Canton of Echternach'
        },
        {
          code: 'ES',
          name: 'Canton of Esch-sur-Alzette'
        },
        {
          code: 'GR',
          name: 'Canton of Grevenmacher'
        },
        {
          code: 'LU',
          name: 'Canton of Luxembourg'
        },
        {
          code: 'ME',
          name: 'Canton of Mersch'
        },
        {
          code: 'RD',
          name: 'Canton of Redange'
        },
        {
          code: 'RM',
          name: 'Canton of Remich'
        },
        {
          code: 'VD',
          name: 'Canton of Vianden'
        },
        {
          code: 'WI',
          name: 'Canton of Wiltz'
        },
        {
          code: 'D',
          name: 'Diekirch District'
        },
        {
          code: 'G',
          name: 'Grevenmacher District'
        },
        {
          code: 'L',
          name: 'Luxembourg District'
        }
      ]
    },
    {
      code: 'MO',
      name: 'Macau S.A.R.',
      states: []
    },
    {
      code: 'MG',
      name: 'Madagascar',
      states: [
        {
          code: 'T',
          name: 'Antananarivo Province'
        },
        {
          code: 'D',
          name: 'Antsiranana Province'
        },
        {
          code: 'F',
          name: 'Fianarantsoa Province'
        },
        {
          code: 'M',
          name: 'Mahajanga Province'
        },
        {
          code: 'A',
          name: 'Toamasina Province'
        },
        {
          code: 'U',
          name: 'Toliara Province'
        }
      ]
    },
    {
      code: 'MW',
      name: 'Malawi',
      states: [
        {
          code: 'BA',
          name: 'Balaka District'
        },
        {
          code: 'BL',
          name: 'Blantyre District'
        },
        {
          code: 'C',
          name: 'Central Region'
        },
        {
          code: 'CK',
          name: 'Chikwawa District'
        },
        {
          code: 'CR',
          name: 'Chiradzulu District'
        },
        {
          code: 'CT',
          name: 'Chitipa district'
        },
        {
          code: 'DE',
          name: 'Dedza District'
        },
        {
          code: 'DO',
          name: 'Dowa District'
        },
        {
          code: 'KR',
          name: 'Karonga District'
        },
        {
          code: 'KS',
          name: 'Kasungu District'
        },
        {
          code: 'LK',
          name: 'Likoma District'
        },
        {
          code: 'LI',
          name: 'Lilongwe District'
        },
        {
          code: 'MH',
          name: 'Machinga District'
        },
        {
          code: 'MG',
          name: 'Mangochi District'
        },
        {
          code: 'MC',
          name: 'Mchinji District'
        },
        {
          code: 'MU',
          name: 'Mulanje District'
        },
        {
          code: 'MW',
          name: 'Mwanza District'
        },
        {
          code: 'MZ',
          name: 'Mzimba District'
        },
        {
          code: 'NB',
          name: 'Nkhata Bay District'
        },
        {
          code: 'NK',
          name: 'Nkhotakota District'
        },
        {
          code: 'N',
          name: 'Northern Region'
        },
        {
          code: 'NS',
          name: 'Nsanje District'
        },
        {
          code: 'NU',
          name: 'Ntcheu District'
        },
        {
          code: 'NI',
          name: 'Ntchisi District'
        },
        {
          code: 'PH',
          name: 'Phalombe District'
        },
        {
          code: 'RU',
          name: 'Rumphi District'
        },
        {
          code: 'SA',
          name: 'Salima District'
        },
        {
          code: 'S',
          name: 'Southern Region'
        },
        {
          code: 'TH',
          name: 'Thyolo District'
        },
        {
          code: 'ZO',
          name: 'Zomba District'
        }
      ]
    },
    {
      code: 'MY',
      name: 'Malaysia',
      states: [
        {
          code: '01',
          name: 'Johor'
        },
        {
          code: '02',
          name: 'Kedah'
        },
        {
          code: '03',
          name: 'Kelantan'
        },
        {
          code: '14',
          name: 'Kuala Lumpur'
        },
        {
          code: '15',
          name: 'Labuan'
        },
        {
          code: '04',
          name: 'Malacca'
        },
        {
          code: '05',
          name: 'Negeri Sembilan'
        },
        {
          code: '06',
          name: 'Pahang'
        },
        {
          code: '07',
          name: 'Penang'
        },
        {
          code: '08',
          name: 'Perak'
        },
        {
          code: '09',
          name: 'Perlis'
        },
        {
          code: '16',
          name: 'Putrajaya'
        },
        {
          code: '12',
          name: 'Sabah'
        },
        {
          code: '13',
          name: 'Sarawak'
        },
        {
          code: '10',
          name: 'Selangor'
        },
        {
          code: '11',
          name: 'Terengganu'
        }
      ]
    },
    {
      code: 'MV',
      name: 'Maldives',
      states: [
        {
          code: '01',
          name: 'Addu Atoll'
        },
        {
          code: '02',
          name: 'Alif Alif Atoll'
        },
        {
          code: '00',
          name: 'Alif Dhaal Atoll'
        },
        {
          code: 'CE',
          name: 'Central Province'
        },
        {
          code: '17',
          name: 'Dhaalu Atoll'
        },
        {
          code: '14',
          name: 'Faafu Atoll'
        },
        {
          code: '27',
          name: 'Gaafu Alif Atoll'
        },
        {
          code: '28',
          name: 'Gaafu Dhaalu Atoll'
        },
        {
          code: '29',
          name: 'Gnaviyani Atoll'
        },
        {
          code: '07',
          name: 'Haa Alif Atoll'
        },
        {
          code: '23',
          name: 'Haa Dhaalu Atoll'
        },
        {
          code: '26',
          name: 'Kaafu Atoll'
        },
        {
          code: '05',
          name: 'Laamu Atoll'
        },
        {
          code: '03',
          name: 'Lhaviyani Atoll'
        },
        {
          code: 'MLE',
          name: 'Malé'
        },
        {
          code: '12',
          name: 'Meemu Atoll'
        },
        {
          code: '25',
          name: 'Noonu Atoll'
        },
        {
          code: 'NC',
          name: 'North Central Province'
        },
        {
          code: 'NO',
          name: 'North Province'
        },
        {
          code: '13',
          name: 'Raa Atoll'
        },
        {
          code: '24',
          name: 'Shaviyani Atoll'
        },
        {
          code: 'SC',
          name: 'South Central Province'
        },
        {
          code: 'SU',
          name: 'South Province'
        },
        {
          code: '08',
          name: 'Thaa Atoll'
        },
        {
          code: 'US',
          name: 'Upper South Province'
        },
        {
          code: '04',
          name: 'Vaavu Atoll'
        }
      ]
    },
    {
      code: 'ML',
      name: 'Mali',
      states: [
        {
          code: 'BKO',
          name: 'Bamako'
        },
        {
          code: '7',
          name: 'Gao Region'
        },
        {
          code: '1',
          name: 'Kayes Region'
        },
        {
          code: '8',
          name: 'Kidal Region'
        },
        {
          code: '2',
          name: 'Koulikoro Region'
        },
        {
          code: '9',
          name: 'Ménaka Region'
        },
        {
          code: '5',
          name: 'Mopti Region'
        },
        {
          code: '4',
          name: 'Ségou Region'
        },
        {
          code: '3',
          name: 'Sikasso Region'
        },
        {
          code: '10',
          name: 'Taoudénit Region'
        },
        {
          code: '6',
          name: 'Tombouctou Region'
        }
      ]
    },
    {
      code: 'MT',
      name: 'Malta',
      states: [
        {
          code: '01',
          name: 'Attard'
        },
        {
          code: '02',
          name: 'Balzan'
        },
        {
          code: '03',
          name: 'Birgu'
        },
        {
          code: '04',
          name: 'Birkirkara'
        },
        {
          code: '05',
          name: 'Birżebbuġa'
        },
        {
          code: '06',
          name: 'Cospicua'
        },
        {
          code: '07',
          name: 'Dingli'
        },
        {
          code: '08',
          name: 'Fgura'
        },
        {
          code: '09',
          name: 'Floriana'
        },
        {
          code: '10',
          name: 'Fontana'
        },
        {
          code: '13',
          name: 'Għajnsielem'
        },
        {
          code: '14',
          name: 'Għarb'
        },
        {
          code: '15',
          name: 'Għargħur'
        },
        {
          code: '16',
          name: 'Għasri'
        },
        {
          code: '17',
          name: 'Għaxaq'
        },
        {
          code: '11',
          name: 'Gudja'
        },
        {
          code: '12',
          name: 'Gżira'
        },
        {
          code: '18',
          name: 'Ħamrun'
        },
        {
          code: '19',
          name: 'Iklin'
        },
        {
          code: '21',
          name: 'Kalkara'
        },
        {
          code: '22',
          name: 'Kerċem'
        },
        {
          code: '23',
          name: 'Kirkop'
        },
        {
          code: '24',
          name: 'Lija'
        },
        {
          code: '25',
          name: 'Luqa'
        },
        {
          code: '26',
          name: 'Marsa'
        },
        {
          code: '27',
          name: 'Marsaskala'
        },
        {
          code: '28',
          name: 'Marsaxlokk'
        },
        {
          code: '29',
          name: 'Mdina'
        },
        {
          code: '30',
          name: 'Mellieħa'
        },
        {
          code: '31',
          name: 'Mġarr'
        },
        {
          code: '32',
          name: 'Mosta'
        },
        {
          code: '33',
          name: 'Mqabba'
        },
        {
          code: '34',
          name: 'Msida'
        },
        {
          code: '35',
          name: 'Mtarfa'
        },
        {
          code: '36',
          name: 'Munxar'
        },
        {
          code: '37',
          name: 'Nadur'
        },
        {
          code: '38',
          name: 'Naxxar'
        },
        {
          code: '39',
          name: 'Paola'
        },
        {
          code: '40',
          name: 'Pembroke'
        },
        {
          code: '41',
          name: 'Pietà'
        },
        {
          code: '42',
          name: 'Qala'
        },
        {
          code: '43',
          name: 'Qormi'
        },
        {
          code: '44',
          name: 'Qrendi'
        },
        {
          code: '46',
          name: 'Rabat'
        },
        {
          code: '49',
          name: 'San Ġwann'
        },
        {
          code: '50',
          name: 'San Lawrenz'
        },
        {
          code: '52',
          name: 'Sannat'
        },
        {
          code: '53',
          name: 'Santa Luċija'
        },
        {
          code: '54',
          name: 'Santa Venera'
        },
        {
          code: '20',
          name: 'Senglea'
        },
        {
          code: '55',
          name: 'Siġġiewi'
        },
        {
          code: '56',
          name: 'Sliema'
        },
        {
          code: '48',
          name: "St. Julian's"
        },
        {
          code: '51',
          name: "St. Paul's Bay"
        },
        {
          code: '57',
          name: 'Swieqi'
        },
        {
          code: '58',
          name: "Ta' Xbiex"
        },
        {
          code: '59',
          name: 'Tarxien'
        },
        {
          code: '60',
          name: 'Valletta'
        },
        {
          code: '45',
          name: 'Victoria'
        },
        {
          code: '61',
          name: 'Xagħra'
        },
        {
          code: '62',
          name: 'Xewkija'
        },
        {
          code: '63',
          name: 'Xgħajra'
        },
        {
          code: '64',
          name: 'Żabbar'
        },
        {
          code: '65',
          name: 'Żebbuġ Gozo'
        },
        {
          code: '66',
          name: 'Żebbuġ Malta'
        },
        {
          code: '67',
          name: 'Żejtun'
        },
        {
          code: '68',
          name: 'Żurrieq'
        }
      ]
    },
    {
      code: 'IM',
      name: 'Man (Isle of)',
      states: []
    },
    {
      code: 'MH',
      name: 'Marshall Islands',
      states: [
        {
          code: 'L',
          name: 'Ralik Chain'
        },
        {
          code: 'T',
          name: 'Ratak Chain'
        }
      ]
    },
    {
      code: 'MQ',
      name: 'Martinique',
      states: []
    },
    {
      code: 'MR',
      name: 'Mauritania',
      states: [
        {
          code: '07',
          name: 'Adrar'
        },
        {
          code: '03',
          name: 'Assaba'
        },
        {
          code: '05',
          name: 'Brakna'
        },
        {
          code: '08',
          name: 'Dakhlet Nouadhibou'
        },
        {
          code: '04',
          name: 'Gorgol'
        },
        {
          code: '10',
          name: 'Guidimaka'
        },
        {
          code: '01',
          name: 'Hodh Ech Chargui'
        },
        {
          code: '02',
          name: 'Hodh El Gharbi'
        },
        {
          code: '12',
          name: 'Inchiri'
        },
        {
          code: '14',
          name: 'Nouakchott-Nord'
        },
        {
          code: '13',
          name: 'Nouakchott-Ouest'
        },
        {
          code: '15',
          name: 'Nouakchott-Sud'
        },
        {
          code: '09',
          name: 'Tagant'
        },
        {
          code: '11',
          name: 'Tiris Zemmour'
        },
        {
          code: '06',
          name: 'Trarza'
        }
      ]
    },
    {
      code: 'MU',
      name: 'Mauritius',
      states: [
        {
          code: 'AG',
          name: 'Agalega Islands'
        },
        {
          code: 'BL',
          name: 'Black River'
        },
        {
          code: 'FL',
          name: 'Flacq'
        },
        {
          code: 'GP',
          name: 'Grand Port'
        },
        {
          code: 'MO',
          name: 'Moka'
        },
        {
          code: 'PA',
          name: 'Pamplemousses'
        },
        {
          code: 'PW',
          name: 'Plaines Wilhems'
        },
        {
          code: 'PL',
          name: 'Port Louis'
        },
        {
          code: 'RR',
          name: 'Rivière du Rempart'
        },
        {
          code: 'RO',
          name: 'Rodrigues Island'
        },
        {
          code: 'CC',
          name: 'Saint Brandon Islands'
        },
        {
          code: 'SA',
          name: 'Savanne'
        }
      ]
    },
    {
      code: 'YT',
      name: 'Mayotte',
      states: []
    },
    {
      code: 'MX',
      name: 'Mexico',
      states: [
        {
          code: 'AGU',
          name: 'Aguascalientes'
        },
        {
          code: 'BCN',
          name: 'Baja California'
        },
        {
          code: 'BCS',
          name: 'Baja California Sur'
        },
        {
          code: 'CAM',
          name: 'Campeche'
        },
        {
          code: 'CHP',
          name: 'Chiapas'
        },
        {
          code: 'CHH',
          name: 'Chihuahua'
        },
        {
          code: 'CMX',
          name: 'Ciudad de México'
        },
        {
          code: 'COA',
          name: 'Coahuila de Zaragoza'
        },
        {
          code: 'COL',
          name: 'Colima'
        },
        {
          code: 'DUR',
          name: 'Durango'
        },
        {
          code: 'MEX',
          name: 'Estado de México'
        },
        {
          code: 'GUA',
          name: 'Guanajuato'
        },
        {
          code: 'GRO',
          name: 'Guerrero'
        },
        {
          code: 'HID',
          name: 'Hidalgo'
        },
        {
          code: 'JAL',
          name: 'Jalisco'
        },
        {
          code: 'MIC',
          name: 'Michoacán de Ocampo'
        },
        {
          code: 'MOR',
          name: 'Morelos'
        },
        {
          code: 'NAY',
          name: 'Nayarit'
        },
        {
          code: 'NLE',
          name: 'Nuevo León'
        },
        {
          code: 'OAX',
          name: 'Oaxaca'
        },
        {
          code: 'PUE',
          name: 'Puebla'
        },
        {
          code: 'QUE',
          name: 'Querétaro'
        },
        {
          code: 'ROO',
          name: 'Quintana Roo'
        },
        {
          code: 'SLP',
          name: 'San Luis Potosí'
        },
        {
          code: 'SIN',
          name: 'Sinaloa'
        },
        {
          code: 'SON',
          name: 'Sonora'
        },
        {
          code: 'TAB',
          name: 'Tabasco'
        },
        {
          code: 'TAM',
          name: 'Tamaulipas'
        },
        {
          code: 'TLA',
          name: 'Tlaxcala'
        },
        {
          code: 'VER',
          name: 'Veracruz de Ignacio de la Llave'
        },
        {
          code: 'YUC',
          name: 'Yucatán'
        },
        {
          code: 'ZAC',
          name: 'Zacatecas'
        }
      ]
    },
    {
      code: 'FM',
      name: 'Micronesia',
      states: [
        {
          code: 'TRK',
          name: 'Chuuk State'
        },
        {
          code: 'KSA',
          name: 'Kosrae State'
        },
        {
          code: 'PNI',
          name: 'Pohnpei State'
        },
        {
          code: 'YAP',
          name: 'Yap State'
        }
      ]
    },
    {
      code: 'MD',
      name: 'Moldova',
      states: [
        {
          code: 'AN',
          name: 'Anenii Noi District'
        },
        {
          code: 'BA',
          name: 'Bălți Municipality'
        },
        {
          code: 'BS',
          name: 'Basarabeasca District'
        },
        {
          code: 'BD',
          name: 'Bender Municipality'
        },
        {
          code: 'BR',
          name: 'Briceni District'
        },
        {
          code: 'CA',
          name: 'Cahul District'
        },
        {
          code: 'CL',
          name: 'Călărași District'
        },
        {
          code: 'CT',
          name: 'Cantemir District'
        },
        {
          code: 'CS',
          name: 'Căușeni District'
        },
        {
          code: 'CU',
          name: 'Chișinău Municipality'
        },
        {
          code: 'CM',
          name: 'Cimișlia District'
        },
        {
          code: 'CR',
          name: 'Criuleni District'
        },
        {
          code: 'DO',
          name: 'Dondușeni District'
        },
        {
          code: 'DR',
          name: 'Drochia District'
        },
        {
          code: 'DU',
          name: 'Dubăsari District'
        },
        {
          code: 'ED',
          name: 'Edineț District'
        },
        {
          code: 'FA',
          name: 'Fălești District'
        },
        {
          code: 'FL',
          name: 'Florești District'
        },
        {
          code: 'GA',
          name: 'Gagauzia'
        },
        {
          code: 'GL',
          name: 'Glodeni District'
        },
        {
          code: 'HI',
          name: 'Hîncești District'
        },
        {
          code: 'IA',
          name: 'Ialoveni District'
        },
        {
          code: 'NI',
          name: 'Nisporeni District'
        },
        {
          code: 'OC',
          name: 'Ocnița District'
        },
        {
          code: 'OR',
          name: 'Orhei District'
        },
        {
          code: 'RE',
          name: 'Rezina District'
        },
        {
          code: 'RI',
          name: 'Rîșcani District'
        },
        {
          code: 'SI',
          name: 'Sîngerei District'
        },
        {
          code: 'SD',
          name: 'Șoldănești District'
        },
        {
          code: 'SO',
          name: 'Soroca District'
        },
        {
          code: 'SV',
          name: 'Ștefan Vodă District'
        },
        {
          code: 'ST',
          name: 'Strășeni District'
        },
        {
          code: 'TA',
          name: 'Taraclia District'
        },
        {
          code: 'TE',
          name: 'Telenești District'
        },
        {
          code: 'SN',
          name: 'Transnistria autonomous territorial unit'
        },
        {
          code: 'UN',
          name: 'Ungheni District'
        }
      ]
    },
    {
      code: 'MC',
      name: 'Monaco',
      states: [
        {
          code: 'CL',
          name: 'La Colle'
        },
        {
          code: 'CO',
          name: 'La Condamine'
        },
        {
          code: 'MG',
          name: 'Moneghetti'
        }
      ]
    },
    {
      code: 'MN',
      name: 'Mongolia',
      states: [
        {
          code: '073',
          name: 'Arkhangai Province'
        },
        {
          code: '071',
          name: 'Bayan-Ölgii Province'
        },
        {
          code: '069',
          name: 'Bayankhongor Province'
        },
        {
          code: '067',
          name: 'Bulgan Province'
        },
        {
          code: '037',
          name: 'Darkhan-Uul Province'
        },
        {
          code: '061',
          name: 'Dornod Province'
        },
        {
          code: '063',
          name: 'Dornogovi Province'
        },
        {
          code: '059',
          name: 'Dundgovi Province'
        },
        {
          code: '065',
          name: 'Govi-Altai Province'
        },
        {
          code: '064',
          name: 'Govisümber Province'
        },
        {
          code: '039',
          name: 'Khentii Province'
        },
        {
          code: '043',
          name: 'Khovd Province'
        },
        {
          code: '041',
          name: 'Khövsgöl Province'
        },
        {
          code: '053',
          name: 'Ömnögovi Province'
        },
        {
          code: '035',
          name: 'Orkhon Province'
        },
        {
          code: '055',
          name: 'Övörkhangai Province'
        },
        {
          code: '049',
          name: 'Selenge Province'
        },
        {
          code: '051',
          name: 'Sükhbaatar Province'
        },
        {
          code: '047',
          name: 'Töv Province'
        },
        {
          code: '046',
          name: 'Uvs Province'
        },
        {
          code: '057',
          name: 'Zavkhan Province'
        }
      ]
    },
    {
      code: 'ME',
      name: 'Montenegro',
      states: [
        {
          code: '01',
          name: 'Andrijevica Municipality'
        },
        {
          code: '02',
          name: 'Bar Municipality'
        },
        {
          code: '03',
          name: 'Berane Municipality'
        },
        {
          code: '04',
          name: 'Bijelo Polje Municipality'
        },
        {
          code: '05',
          name: 'Budva Municipality'
        },
        {
          code: '07',
          name: 'Danilovgrad Municipality'
        },
        {
          code: '22',
          name: 'Gusinje Municipality'
        },
        {
          code: '09',
          name: 'Kolašin Municipality'
        },
        {
          code: '10',
          name: 'Kotor Municipality'
        },
        {
          code: '11',
          name: 'Mojkovac Municipality'
        },
        {
          code: '12',
          name: 'Nikšić Municipality'
        },
        {
          code: '06',
          name: 'Old Royal Capital Cetinje'
        },
        {
          code: '23',
          name: 'Petnjica Municipality'
        },
        {
          code: '13',
          name: 'Plav Municipality'
        },
        {
          code: '14',
          name: 'Pljevlja Municipality'
        },
        {
          code: '15',
          name: 'Plužine Municipality'
        },
        {
          code: '16',
          name: 'Podgorica Municipality'
        },
        {
          code: '17',
          name: 'Rožaje Municipality'
        },
        {
          code: '18',
          name: 'Šavnik Municipality'
        },
        {
          code: '19',
          name: 'Tivat Municipality'
        },
        {
          code: '20',
          name: 'Ulcinj Municipality'
        },
        {
          code: '21',
          name: 'Žabljak Municipality'
        }
      ]
    },
    {
      code: 'MS',
      name: 'Montserrat',
      states: []
    },
    {
      code: 'MA',
      name: 'Morocco',
      states: [
        {
          code: 'AGD',
          name: 'Agadir-Ida-Ou-Tanane'
        },
        {
          code: 'HAO',
          name: 'Al Haouz'
        },
        {
          code: 'HOC',
          name: 'Al Hoceïma'
        },
        {
          code: 'AOU',
          name: 'Aousserd (EH)'
        },
        {
          code: 'ASZ',
          name: 'Assa-Zag (EH-partial)'
        },
        {
          code: 'AZI',
          name: 'Azilal'
        },
        {
          code: 'BEM',
          name: 'Béni Mellal'
        },
        {
          code: '05',
          name: 'Béni Mellal-Khénifra'
        },
        {
          code: 'BES',
          name: 'Benslimane'
        },
        {
          code: 'BER',
          name: 'Berkane'
        },
        {
          code: 'BRR',
          name: 'Berrechid'
        },
        {
          code: 'BOD',
          name: 'Boujdour (EH)'
        },
        {
          code: 'BOM',
          name: 'Boulemane'
        },
        {
          code: 'CAS',
          name: 'Casablanca'
        },
        {
          code: '06',
          name: 'Casablanca-Settat'
        },
        {
          code: 'CHE',
          name: 'Chefchaouen'
        },
        {
          code: 'CHI',
          name: 'Chichaoua'
        },
        {
          code: 'CHT',
          name: 'Chtouka-Ait Baha'
        },
        {
          code: '12',
          name: 'Dakhla-Oued Ed-Dahab (EH)'
        },
        {
          code: '08',
          name: 'Drâa-Tafilalet'
        },
        {
          code: 'DRI',
          name: 'Driouch'
        },
        {
          code: 'HAJ',
          name: 'El Hajeb'
        },
        {
          code: 'JDI',
          name: 'El Jadida'
        },
        {
          code: 'KES',
          name: 'El Kelâa des Sraghna'
        },
        {
          code: 'ERR',
          name: 'Errachidia'
        },
        {
          code: 'ESM',
          name: 'Es-Semara (EH-partial)'
        },
        {
          code: 'ESI',
          name: 'Essaouira'
        },
        {
          code: 'FAH',
          name: 'Fahs-Anjra'
        },
        {
          code: 'FES',
          name: 'Fès'
        },
        {
          code: '03',
          name: 'Fès-Meknès'
        },
        {
          code: 'FIG',
          name: 'Figuig'
        },
        {
          code: 'FQH',
          name: 'Fquih Ben Salah'
        },
        {
          code: 'GUE',
          name: 'Guelmim'
        },
        {
          code: '10',
          name: 'Guelmim-Oued Noun (EH-partial)'
        },
        {
          code: 'GUF',
          name: 'Guercif'
        },
        {
          code: 'IFR',
          name: 'Ifrane'
        },
        {
          code: 'INE',
          name: 'Inezgane-Ait Melloul'
        },
        {
          code: 'JRA',
          name: 'Jerada'
        },
        {
          code: 'KEN',
          name: 'Kénitra'
        },
        {
          code: 'KHE',
          name: 'Khémisset'
        },
        {
          code: 'KHN',
          name: 'Khénifra'
        },
        {
          code: 'KHO',
          name: 'Khouribga'
        },
        {
          code: '02',
          name: "L'Oriental"
        },
        {
          code: 'LAA',
          name: 'Laâyoune (EH)'
        },
        {
          code: '11',
          name: 'Laâyoune-Sakia El Hamra (EH-partial)'
        },
        {
          code: 'LAR',
          name: 'Larache'
        },
        {
          code: 'MDF',
          name: 'M\u2019diq-Fnideq'
        },
        {
          code: 'MAR',
          name: 'Marrakech'
        },
        {
          code: '07',
          name: 'Marrakesh-Safi'
        },
        {
          code: 'MED',
          name: 'Médiouna'
        },
        {
          code: 'MEK',
          name: 'Meknès'
        },
        {
          code: 'MID',
          name: 'Midelt'
        },
        {
          code: 'MOH',
          name: 'Mohammadia'
        },
        {
          code: 'MOU',
          name: 'Moulay Yacoub'
        },
        {
          code: 'NAD',
          name: 'Nador'
        },
        {
          code: 'NOU',
          name: 'Nouaceur'
        },
        {
          code: 'OUA',
          name: 'Ouarzazate'
        },
        {
          code: 'OUD',
          name: 'Oued Ed-Dahab (EH)'
        },
        {
          code: 'OUZ',
          name: 'Ouezzane'
        },
        {
          code: 'OUJ',
          name: 'Oujda-Angad'
        },
        {
          code: 'RAB',
          name: 'Rabat'
        },
        {
          code: '04',
          name: 'Rabat-Salé-Kénitra'
        },
        {
          code: 'REH',
          name: 'Rehamna'
        },
        {
          code: 'SAF',
          name: 'Safi'
        },
        {
          code: 'SAL',
          name: 'Salé'
        },
        {
          code: 'SEF',
          name: 'Sefrou'
        },
        {
          code: 'SET',
          name: 'Settat'
        },
        {
          code: 'SIB',
          name: 'Sidi Bennour'
        },
        {
          code: 'SIF',
          name: 'Sidi Ifni'
        },
        {
          code: 'SIK',
          name: 'Sidi Kacem'
        },
        {
          code: 'SIL',
          name: 'Sidi Slimane'
        },
        {
          code: 'SKH',
          name: 'Skhirate-Témara'
        },
        {
          code: '09',
          name: 'Souss-Massa'
        },
        {
          code: 'TNT',
          name: 'Tan-Tan (EH-partial)'
        },
        {
          code: 'TNG',
          name: 'Tanger-Assilah'
        },
        {
          code: '01',
          name: 'Tanger-Tétouan-Al Hoceïma'
        },
        {
          code: 'TAO',
          name: 'Taounate'
        },
        {
          code: 'TAI',
          name: 'Taourirt'
        },
        {
          code: 'TAF',
          name: 'Tarfaya (EH-partial)'
        },
        {
          code: 'TAR',
          name: 'Taroudannt'
        },
        {
          code: 'TAT',
          name: 'Tata'
        },
        {
          code: 'TAZ',
          name: 'Taza'
        },
        {
          code: 'TET',
          name: 'Tétouan'
        },
        {
          code: 'TIN',
          name: 'Tinghir'
        },
        {
          code: 'TIZ',
          name: 'Tiznit'
        },
        {
          code: 'YUS',
          name: 'Youssoufia'
        },
        {
          code: 'ZAG',
          name: 'Zagora'
        }
      ]
    },
    {
      code: 'MZ',
      name: 'Mozambique',
      states: [
        {
          code: 'P',
          name: 'Cabo Delgado Province'
        },
        {
          code: 'G',
          name: 'Gaza Province'
        },
        {
          code: 'I',
          name: 'Inhambane Province'
        },
        {
          code: 'B',
          name: 'Manica Province'
        },
        {
          code: 'MPM',
          name: 'Maputo'
        },
        {
          code: 'L',
          name: 'Maputo Province'
        },
        {
          code: 'N',
          name: 'Nampula Province'
        },
        {
          code: 'A',
          name: 'Niassa Province'
        },
        {
          code: 'S',
          name: 'Sofala Province'
        },
        {
          code: 'T',
          name: 'Tete Province'
        },
        {
          code: 'Q',
          name: 'Zambezia Province'
        }
      ]
    },
    {
      code: 'MM',
      name: 'Myanmar',
      states: [
        {
          code: '07',
          name: 'Ayeyarwady Region'
        },
        {
          code: '02',
          name: 'Bago'
        },
        {
          code: '14',
          name: 'Chin State'
        },
        {
          code: '11',
          name: 'Kachin State'
        },
        {
          code: '12',
          name: 'Kayah State'
        },
        {
          code: '13',
          name: 'Kayin State'
        },
        {
          code: '03',
          name: 'Magway Region'
        },
        {
          code: '04',
          name: 'Mandalay Region'
        },
        {
          code: '15',
          name: 'Mon State'
        },
        {
          code: '18',
          name: 'Naypyidaw Union Territory'
        },
        {
          code: '16',
          name: 'Rakhine State'
        },
        {
          code: '01',
          name: 'Sagaing Region'
        },
        {
          code: '17',
          name: 'Shan State'
        },
        {
          code: '05',
          name: 'Tanintharyi Region'
        },
        {
          code: '06',
          name: 'Yangon Region'
        }
      ]
    },
    {
      code: 'NA',
      name: 'Namibia',
      states: [
        {
          code: 'ER',
          name: 'Erongo Region'
        },
        {
          code: 'HA',
          name: 'Hardap Region'
        },
        {
          code: 'KA',
          name: 'Karas Region'
        },
        {
          code: 'KE',
          name: 'Kavango East Region'
        },
        {
          code: 'KW',
          name: 'Kavango West Region'
        },
        {
          code: 'KH',
          name: 'Khomas Region'
        },
        {
          code: 'KU',
          name: 'Kunene Region'
        },
        {
          code: 'OW',
          name: 'Ohangwena Region'
        },
        {
          code: 'OH',
          name: 'Omaheke Region'
        },
        {
          code: 'OS',
          name: 'Omusati Region'
        },
        {
          code: 'ON',
          name: 'Oshana Region'
        },
        {
          code: 'OT',
          name: 'Oshikoto Region'
        },
        {
          code: 'OD',
          name: 'Otjozondjupa Region'
        },
        {
          code: 'CA',
          name: 'Zambezi Region'
        }
      ]
    },
    {
      code: 'NR',
      name: 'Nauru',
      states: [
        {
          code: '01',
          name: 'Aiwo District'
        },
        {
          code: '02',
          name: 'Anabar District'
        },
        {
          code: '03',
          name: 'Anetan District'
        },
        {
          code: '04',
          name: 'Anibare District'
        },
        {
          code: '05',
          name: 'Baiti District'
        },
        {
          code: '06',
          name: 'Boe District'
        },
        {
          code: '07',
          name: 'Buada District'
        },
        {
          code: '08',
          name: 'Denigomodu District'
        },
        {
          code: '09',
          name: 'Ewa District'
        },
        {
          code: '10',
          name: 'Ijuw District'
        },
        {
          code: '11',
          name: 'Meneng District'
        },
        {
          code: '12',
          name: 'Nibok District'
        },
        {
          code: '13',
          name: 'Uaboe District'
        },
        {
          code: '14',
          name: 'Yaren District'
        }
      ]
    },
    {
      code: 'NP',
      name: 'Nepal',
      states: [
        {
          code: 'BA',
          name: 'Bagmati Zone'
        },
        {
          code: 'BH',
          name: 'Bheri Zone'
        },
        {
          code: '1',
          name: 'Central Region'
        },
        {
          code: 'DH',
          name: 'Dhaulagiri Zone'
        },
        {
          code: '4',
          name: 'Eastern Development Region'
        },
        {
          code: '5',
          name: 'Far-Western Development Region'
        },
        {
          code: 'GA',
          name: 'Gandaki Zone'
        },
        {
          code: 'JA',
          name: 'Janakpur Zone'
        },
        {
          code: 'KA',
          name: 'Karnali Zone'
        },
        {
          code: 'KO',
          name: 'Kosi Zone'
        },
        {
          code: 'LU',
          name: 'Lumbini Zone'
        },
        {
          code: 'MA',
          name: 'Mahakali Zone'
        },
        {
          code: 'ME',
          name: 'Mechi Zone'
        },
        {
          code: '2',
          name: 'Mid-Western Region'
        },
        {
          code: 'NA',
          name: 'Narayani Zone'
        },
        {
          code: 'RA',
          name: 'Rapti Zone'
        },
        {
          code: 'SA',
          name: 'Sagarmatha Zone'
        },
        {
          code: 'SE',
          name: 'Seti Zone'
        },
        {
          code: '3',
          name: 'Western Region'
        }
      ]
    },
    {
      code: 'NL',
      name: 'Netherlands',
      states: [
        {
          code: 'BQ1',
          name: 'Bonaire'
        },
        {
          code: 'DR',
          name: 'Drenthe'
        },
        {
          code: 'FL',
          name: 'Flevoland'
        },
        {
          code: 'FR',
          name: 'Friesland'
        },
        {
          code: 'GE',
          name: 'Gelderland'
        },
        {
          code: 'GR',
          name: 'Groningen'
        },
        {
          code: 'LI',
          name: 'Limburg'
        },
        {
          code: 'NB',
          name: 'North Brabant'
        },
        {
          code: 'NH',
          name: 'North Holland'
        },
        {
          code: 'OV',
          name: 'Overijssel'
        },
        {
          code: 'BQ2',
          name: 'Saba'
        },
        {
          code: 'BQ3',
          name: 'Sint Eustatius'
        },
        {
          code: 'ZH',
          name: 'South Holland'
        },
        {
          code: 'UT',
          name: 'Utrecht'
        },
        {
          code: 'ZE',
          name: 'Zeeland'
        }
      ]
    },
    {
      code: 'NC',
      name: 'New Caledonia',
      states: [
        {
          code: '03',
          name: 'Loyalty Islands Province'
        },
        {
          code: '02',
          name: 'North Province'
        },
        {
          code: '01',
          name: 'South Province'
        }
      ]
    },
    {
      code: 'NZ',
      name: 'New Zealand',
      states: [
        {
          code: 'AUK',
          name: 'Auckland Region'
        },
        {
          code: 'BOP',
          name: 'Bay of Plenty Region'
        },
        {
          code: 'CAN',
          name: 'Canterbury Region'
        },
        {
          code: 'CIT',
          name: 'Chatham Islands'
        },
        {
          code: 'GIS',
          name: 'Gisborne District'
        },
        {
          code: 'HKB',
          name: "Hawke's Bay Region"
        },
        {
          code: 'MWT',
          name: 'Manawatu-Wanganui Region'
        },
        {
          code: 'MBH',
          name: 'Marlborough Region'
        },
        {
          code: 'NSN',
          name: 'Nelson Region'
        },
        {
          code: 'NTL',
          name: 'Northland Region'
        },
        {
          code: 'OTA',
          name: 'Otago Region'
        },
        {
          code: 'STL',
          name: 'Southland Region'
        },
        {
          code: 'TKI',
          name: 'Taranaki Region'
        },
        {
          code: 'TAS',
          name: 'Tasman District'
        },
        {
          code: 'WKO',
          name: 'Waikato Region'
        },
        {
          code: 'WGN',
          name: 'Wellington Region'
        },
        {
          code: 'WTC',
          name: 'West Coast Region'
        }
      ]
    },
    {
      code: 'NI',
      name: 'Nicaragua',
      states: [
        {
          code: 'BO',
          name: 'Boaco'
        },
        {
          code: 'CA',
          name: 'Carazo'
        },
        {
          code: 'CI',
          name: 'Chinandega'
        },
        {
          code: 'CO',
          name: 'Chontales'
        },
        {
          code: 'ES',
          name: 'Estelí'
        },
        {
          code: 'GR',
          name: 'Granada'
        },
        {
          code: 'JI',
          name: 'Jinotega'
        },
        {
          code: 'LE',
          name: 'León'
        },
        {
          code: 'MD',
          name: 'Madriz'
        },
        {
          code: 'MN',
          name: 'Managua'
        },
        {
          code: 'MS',
          name: 'Masaya'
        },
        {
          code: 'MT',
          name: 'Matagalpa'
        },
        {
          code: 'AN',
          name: 'North Caribbean Coast'
        },
        {
          code: 'NS',
          name: 'Nueva Segovia'
        },
        {
          code: 'SJ',
          name: 'Río San Juan'
        },
        {
          code: 'RI',
          name: 'Rivas'
        },
        {
          code: 'AS',
          name: 'South Caribbean Coast'
        }
      ]
    },
    {
      code: 'NE',
      name: 'Niger',
      states: [
        {
          code: '1',
          name: 'Agadez Region'
        },
        {
          code: '2',
          name: 'Diffa Region'
        },
        {
          code: '3',
          name: 'Dosso Region'
        },
        {
          code: '4',
          name: 'Maradi Region'
        },
        {
          code: '5',
          name: 'Tahoua Region'
        },
        {
          code: '6',
          name: 'Tillabéri Region'
        },
        {
          code: '7',
          name: 'Zinder Region'
        }
      ]
    },
    {
      code: 'NG',
      name: 'Nigeria',
      states: [
        {
          code: 'AB',
          name: 'Abia'
        },
        {
          code: 'FC',
          name: 'Abuja Federal Capital Territory'
        },
        {
          code: 'AD',
          name: 'Adamawa'
        },
        {
          code: 'AK',
          name: 'Akwa Ibom'
        },
        {
          code: 'AN',
          name: 'Anambra'
        },
        {
          code: 'BA',
          name: 'Bauchi'
        },
        {
          code: 'BY',
          name: 'Bayelsa'
        },
        {
          code: 'BE',
          name: 'Benue'
        },
        {
          code: 'BO',
          name: 'Borno'
        },
        {
          code: 'CR',
          name: 'Cross River'
        },
        {
          code: 'DE',
          name: 'Delta'
        },
        {
          code: 'EB',
          name: 'Ebonyi'
        },
        {
          code: 'ED',
          name: 'Edo'
        },
        {
          code: 'EK',
          name: 'Ekiti'
        },
        {
          code: 'EN',
          name: 'Enugu'
        },
        {
          code: 'GO',
          name: 'Gombe'
        },
        {
          code: 'IM',
          name: 'Imo'
        },
        {
          code: 'JI',
          name: 'Jigawa'
        },
        {
          code: 'KD',
          name: 'Kaduna'
        },
        {
          code: 'KN',
          name: 'Kano'
        },
        {
          code: 'KT',
          name: 'Katsina'
        },
        {
          code: 'KE',
          name: 'Kebbi'
        },
        {
          code: 'KO',
          name: 'Kogi'
        },
        {
          code: 'KW',
          name: 'Kwara'
        },
        {
          code: 'LA',
          name: 'Lagos'
        },
        {
          code: 'NA',
          name: 'Nasarawa'
        },
        {
          code: 'NI',
          name: 'Niger'
        },
        {
          code: 'OG',
          name: 'Ogun'
        },
        {
          code: 'ON',
          name: 'Ondo'
        },
        {
          code: 'OS',
          name: 'Osun'
        },
        {
          code: 'OY',
          name: 'Oyo'
        },
        {
          code: 'PL',
          name: 'Plateau'
        },
        {
          code: 'RI',
          name: 'Rivers'
        },
        {
          code: 'SO',
          name: 'Sokoto'
        },
        {
          code: 'TA',
          name: 'Taraba'
        },
        {
          code: 'YO',
          name: 'Yobe'
        },
        {
          code: 'ZA',
          name: 'Zamfara'
        }
      ]
    },
    {
      code: 'NU',
      name: 'Niue',
      states: []
    },
    {
      code: 'NF',
      name: 'Norfolk Island',
      states: []
    },
    {
      code: 'KP',
      name: 'North Korea',
      states: [
        {
          code: '04',
          name: 'Chagang Province'
        },
        {
          code: '07',
          name: 'Kangwon Province'
        },
        {
          code: '09',
          name: 'North Hamgyong Province'
        },
        {
          code: '06',
          name: 'North Hwanghae Province'
        },
        {
          code: '03',
          name: 'North Pyongan Province'
        },
        {
          code: '01',
          name: 'Pyongyang'
        },
        {
          code: '13',
          name: 'Rason'
        },
        {
          code: '10',
          name: 'Ryanggang Province'
        },
        {
          code: '08',
          name: 'South Hamgyong Province'
        },
        {
          code: '05',
          name: 'South Hwanghae Province'
        },
        {
          code: '02',
          name: 'South Pyongan Province'
        }
      ]
    },
    {
      code: 'MK',
      name: 'North Macedonia',
      states: [
        {
          code: '01',
          name: 'Aerodrom Municipality'
        },
        {
          code: '02',
          name: 'Aračinovo Municipality'
        },
        {
          code: '03',
          name: 'Berovo Municipality'
        },
        {
          code: '04',
          name: 'Bitola Municipality'
        },
        {
          code: '05',
          name: 'Bogdanci Municipality'
        },
        {
          code: '06',
          name: 'Bogovinje Municipality'
        },
        {
          code: '07',
          name: 'Bosilovo Municipality'
        },
        {
          code: '08',
          name: 'Brvenica Municipality'
        },
        {
          code: '09',
          name: 'Butel Municipality'
        },
        {
          code: '79',
          name: 'Čair Municipality'
        },
        {
          code: '80',
          name: 'Čaška Municipality'
        },
        {
          code: '77',
          name: 'Centar Municipality'
        },
        {
          code: '78',
          name: 'Centar Župa Municipality'
        },
        {
          code: '81',
          name: 'Češinovo-Obleševo Municipality'
        },
        {
          code: '82',
          name: 'Čučer-Sandevo Municipality'
        },
        {
          code: '22',
          name: 'Debarca Municipality'
        },
        {
          code: '23',
          name: 'Delčevo Municipality'
        },
        {
          code: '25',
          name: 'Demir Hisar Municipality'
        },
        {
          code: '24',
          name: 'Demir Kapija Municipality'
        },
        {
          code: '26',
          name: 'Dojran Municipality'
        },
        {
          code: '27',
          name: 'Dolneni Municipality'
        },
        {
          code: '28',
          name: 'Drugovo Municipality'
        },
        {
          code: '17',
          name: 'Gazi Baba Municipality'
        },
        {
          code: '18',
          name: 'Gevgelija Municipality'
        },
        {
          code: '29',
          name: 'Gjorče Petrov Municipality'
        },
        {
          code: '19',
          name: 'Gostivar Municipality'
        },
        {
          code: '20',
          name: 'Gradsko Municipality'
        },
        {
          code: '85',
          name: 'Greater Skopje'
        },
        {
          code: '34',
          name: 'Ilinden Municipality'
        },
        {
          code: '35',
          name: 'Jegunovce Municipality'
        },
        {
          code: '37',
          name: 'Karbinci'
        },
        {
          code: '38',
          name: 'Karpoš Municipality'
        },
        {
          code: '36',
          name: 'Kavadarci Municipality'
        },
        {
          code: '40',
          name: 'Kičevo Municipality'
        },
        {
          code: '39',
          name: 'Kisela Voda Municipality'
        },
        {
          code: '42',
          name: 'Kočani Municipality'
        },
        {
          code: '41',
          name: 'Konče Municipality'
        },
        {
          code: '43',
          name: 'Kratovo Municipality'
        },
        {
          code: '44',
          name: 'Kriva Palanka Municipality'
        },
        {
          code: '45',
          name: 'Krivogaštani Municipality'
        },
        {
          code: '46',
          name: 'Kruševo Municipality'
        },
        {
          code: '47',
          name: 'Kumanovo Municipality'
        },
        {
          code: '48',
          name: 'Lipkovo Municipality'
        },
        {
          code: '49',
          name: 'Lozovo Municipality'
        },
        {
          code: '51',
          name: 'Makedonska Kamenica Municipality'
        },
        {
          code: '52',
          name: 'Makedonski Brod Municipality'
        },
        {
          code: '50',
          name: 'Mavrovo and Rostuša Municipality'
        },
        {
          code: '53',
          name: 'Mogila Municipality'
        },
        {
          code: '54',
          name: 'Negotino Municipality'
        },
        {
          code: '55',
          name: 'Novaci Municipality'
        },
        {
          code: '56',
          name: 'Novo Selo Municipality'
        },
        {
          code: '58',
          name: 'Ohrid Municipality'
        },
        {
          code: '57',
          name: 'Oslomej Municipality'
        },
        {
          code: '60',
          name: 'Pehčevo Municipality'
        },
        {
          code: '59',
          name: 'Petrovec Municipality'
        },
        {
          code: '61',
          name: 'Plasnica Municipality'
        },
        {
          code: '62',
          name: 'Prilep Municipality'
        },
        {
          code: '63',
          name: 'Probištip Municipality'
        },
        {
          code: '64',
          name: 'Radoviš Municipality'
        },
        {
          code: '65',
          name: 'Rankovce Municipality'
        },
        {
          code: '66',
          name: 'Resen Municipality'
        },
        {
          code: '67',
          name: 'Rosoman Municipality'
        },
        {
          code: '68',
          name: 'Saraj Municipality'
        },
        {
          code: '70',
          name: 'Sopište Municipality'
        },
        {
          code: '71',
          name: 'Staro Nagoričane Municipality'
        },
        {
          code: '83',
          name: 'Štip Municipality'
        },
        {
          code: '72',
          name: 'Struga Municipality'
        },
        {
          code: '73',
          name: 'Strumica Municipality'
        },
        {
          code: '74',
          name: 'Studeničani Municipality'
        },
        {
          code: '84',
          name: 'Šuto Orizari Municipality'
        },
        {
          code: '69',
          name: 'Sveti Nikole Municipality'
        },
        {
          code: '75',
          name: 'Tearce Municipality'
        },
        {
          code: '76',
          name: 'Tetovo Municipality'
        },
        {
          code: '10',
          name: 'Valandovo Municipality'
        },
        {
          code: '11',
          name: 'Vasilevo Municipality'
        },
        {
          code: '13',
          name: 'Veles Municipality'
        },
        {
          code: '12',
          name: 'Vevčani Municipality'
        },
        {
          code: '14',
          name: 'Vinica Municipality'
        },
        {
          code: '15',
          name: 'Vraneštica Municipality'
        },
        {
          code: '16',
          name: 'Vrapčište Municipality'
        },
        {
          code: '31',
          name: 'Zajas Municipality'
        },
        {
          code: '32',
          name: 'Zelenikovo Municipality'
        },
        {
          code: '30',
          name: 'Želino Municipality'
        },
        {
          code: '33',
          name: 'Zrnovci Municipality'
        }
      ]
    },
    {
      code: 'MP',
      name: 'Northern Mariana Islands',
      states: []
    },
    {
      code: 'NO',
      name: 'Norway',
      states: [
        {
          code: '42',
          name: 'Agder'
        },
        {
          code: '34',
          name: 'Innlandet'
        },
        {
          code: '22',
          name: 'Jan Mayen'
        },
        {
          code: '15',
          name: 'Møre og Romsdal'
        },
        {
          code: '18',
          name: 'Nordland'
        },
        {
          code: '03',
          name: 'Oslo'
        },
        {
          code: '11',
          name: 'Rogaland'
        },
        {
          code: '21',
          name: 'Svalbard'
        },
        {
          code: '54',
          name: 'Troms og Finnmark'
        },
        {
          code: '50',
          name: 'Trøndelag'
        },
        {
          code: '38',
          name: 'Vestfold og Telemark'
        },
        {
          code: '46',
          name: 'Vestland'
        },
        {
          code: '30',
          name: 'Viken'
        }
      ]
    },
    {
      code: 'OM',
      name: 'Oman',
      states: [
        {
          code: 'DA',
          name: 'Ad Dakhiliyah'
        },
        {
          code: 'ZA',
          name: 'Ad Dhahirah'
        },
        {
          code: 'BS',
          name: 'Al Batinah North'
        },
        {
          code: 'BA',
          name: 'Al Batinah Region'
        },
        {
          code: 'BJ',
          name: 'Al Batinah South'
        },
        {
          code: 'BU',
          name: 'Al Buraimi'
        },
        {
          code: 'WU',
          name: 'Al Wusta'
        },
        {
          code: 'SS',
          name: 'Ash Sharqiyah North'
        },
        {
          code: 'SH',
          name: 'Ash Sharqiyah Region'
        },
        {
          code: 'SJ',
          name: 'Ash Sharqiyah South'
        },
        {
          code: 'ZU',
          name: 'Dhofar'
        },
        {
          code: 'MU',
          name: 'Musandam'
        },
        {
          code: 'MA',
          name: 'Muscat'
        }
      ]
    },
    {
      code: 'PK',
      name: 'Pakistan',
      states: [
        {
          code: 'JK',
          name: 'Azad Kashmir'
        },
        {
          code: 'BA',
          name: 'Balochistan'
        },
        {
          code: 'TA',
          name: 'Federally Administered Tribal Areas'
        },
        {
          code: 'GB',
          name: 'Gilgit-Baltistan'
        },
        {
          code: 'IS',
          name: 'Islamabad Capital Territory'
        },
        {
          code: 'KP',
          name: 'Khyber Pakhtunkhwa'
        },
        {
          code: 'PB',
          name: 'Punjab'
        },
        {
          code: 'SD',
          name: 'Sindh'
        }
      ]
    },
    {
      code: 'PW',
      name: 'Palau',
      states: [
        {
          code: '002',
          name: 'Aimeliik'
        },
        {
          code: '004',
          name: 'Airai'
        },
        {
          code: '010',
          name: 'Angaur'
        },
        {
          code: '050',
          name: 'Hatohobei'
        },
        {
          code: '100',
          name: 'Kayangel'
        },
        {
          code: '150',
          name: 'Koror'
        },
        {
          code: '212',
          name: 'Melekeok'
        },
        {
          code: '214',
          name: 'Ngaraard'
        },
        {
          code: '218',
          name: 'Ngarchelong'
        },
        {
          code: '222',
          name: 'Ngardmau'
        },
        {
          code: '224',
          name: 'Ngatpang'
        },
        {
          code: '226',
          name: 'Ngchesar'
        },
        {
          code: '227',
          name: 'Ngeremlengui'
        },
        {
          code: '228',
          name: 'Ngiwal'
        },
        {
          code: '350',
          name: 'Peleliu'
        },
        {
          code: '370',
          name: 'Sonsorol'
        }
      ]
    },
    {
      code: 'PS',
      name: 'Palestinian Territory Occupied',
      states: [
        {
          code: 'BTH',
          name: 'Bethlehem'
        },
        {
          code: 'DEB',
          name: 'Deir El Balah'
        },
        {
          code: 'GZA',
          name: 'Gaza'
        },
        {
          code: 'HBN',
          name: 'Hebron'
        },
        {
          code: 'JEN',
          name: 'Jenin'
        },
        {
          code: 'JRH',
          name: 'Jericho and Al Aghwar'
        },
        {
          code: 'JEM',
          name: 'Jerusalem'
        },
        {
          code: 'KYS',
          name: 'Khan Yunis'
        },
        {
          code: 'NBS',
          name: 'Nablus'
        },
        {
          code: 'NGZ',
          name: 'North Gaza'
        },
        {
          code: 'QQA',
          name: 'Qalqilya'
        },
        {
          code: 'RFH',
          name: 'Rafah'
        },
        {
          code: 'RBH',
          name: 'Ramallah'
        },
        {
          code: 'SLT',
          name: 'Salfit'
        },
        {
          code: 'TBS',
          name: 'Tubas'
        },
        {
          code: 'TKM',
          name: 'Tulkarm'
        }
      ]
    },
    {
      code: 'PA',
      name: 'Panama',
      states: [
        {
          code: '1',
          name: 'Bocas del Toro Province'
        },
        {
          code: '4',
          name: 'Chiriquí Province'
        },
        {
          code: '2',
          name: 'Coclé Province'
        },
        {
          code: '3',
          name: 'Colón Province'
        },
        {
          code: '5',
          name: 'Darién Province'
        },
        {
          code: 'EM',
          name: 'Emberá-Wounaan Comarca'
        },
        {
          code: 'KY',
          name: 'Guna Yala'
        },
        {
          code: '6',
          name: 'Herrera Province'
        },
        {
          code: '7',
          name: 'Los Santos Province'
        },
        {
          code: 'NB',
          name: 'Ngöbe-Buglé Comarca'
        },
        {
          code: '10',
          name: 'Panamá Oeste Province'
        },
        {
          code: '8',
          name: 'Panamá Province'
        },
        {
          code: '9',
          name: 'Veraguas Province'
        }
      ]
    },
    {
      code: 'PG',
      name: 'Papua New Guinea',
      states: [
        {
          code: 'NSB',
          name: 'Bougainville'
        },
        {
          code: 'CPM',
          name: 'Central Province'
        },
        {
          code: 'CPK',
          name: 'Chimbu Province'
        },
        {
          code: 'EBR',
          name: 'East New Britain'
        },
        {
          code: 'ESW',
          name: 'East Sepik'
        },
        {
          code: 'EHG',
          name: 'Eastern Highlands Province'
        },
        {
          code: 'EPW',
          name: 'Enga Province'
        },
        {
          code: 'GPK',
          name: 'Gulf'
        },
        {
          code: 'HLA',
          name: 'Hela'
        },
        {
          code: 'JWK',
          name: 'Jiwaka Province'
        },
        {
          code: 'MPM',
          name: 'Madang Province'
        },
        {
          code: 'MRL',
          name: 'Manus Province'
        },
        {
          code: 'MBA',
          name: 'Milne Bay Province'
        },
        {
          code: 'MPL',
          name: 'Morobe Province'
        },
        {
          code: 'NIK',
          name: 'New Ireland Province'
        },
        {
          code: 'NPP',
          name: 'Oro Province'
        },
        {
          code: 'NCD',
          name: 'Port Moresby'
        },
        {
          code: 'SAN',
          name: 'Sandaun Province'
        },
        {
          code: 'SHM',
          name: 'Southern Highlands Province'
        },
        {
          code: 'WBK',
          name: 'West New Britain Province'
        },
        {
          code: 'WHM',
          name: 'Western Highlands Province'
        },
        {
          code: 'WPD',
          name: 'Western Province'
        }
      ]
    },
    {
      code: 'PY',
      name: 'Paraguay',
      states: [
        {
          code: '16',
          name: 'Alto Paraguay Department'
        },
        {
          code: '10',
          name: 'Alto Paraná Department'
        },
        {
          code: '13',
          name: 'Amambay Department'
        },
        {
          code: 'ASU',
          name: 'Asuncion'
        },
        {
          code: '19',
          name: 'Boquerón Department'
        },
        {
          code: '5',
          name: 'Caaguazú'
        },
        {
          code: '6',
          name: 'Caazapá'
        },
        {
          code: '14',
          name: 'Canindeyú'
        },
        {
          code: '11',
          name: 'Central Department'
        },
        {
          code: '1',
          name: 'Concepción Department'
        },
        {
          code: '3',
          name: 'Cordillera Department'
        },
        {
          code: '4',
          name: 'Guairá Department'
        },
        {
          code: '7',
          name: 'Itapúa'
        },
        {
          code: '8',
          name: 'Misiones Department'
        },
        {
          code: '12',
          name: 'Ñeembucú Department'
        },
        {
          code: '9',
          name: 'Paraguarí Department'
        },
        {
          code: '15',
          name: 'Presidente Hayes Department'
        },
        {
          code: '2',
          name: 'San Pedro Department'
        }
      ]
    },
    {
      code: 'PE',
      name: 'Peru',
      states: [
        {
          code: 'AMA',
          name: 'Amazonas'
        },
        {
          code: 'ANC',
          name: 'Áncash'
        },
        {
          code: 'APU',
          name: 'Apurímac'
        },
        {
          code: 'ARE',
          name: 'Arequipa'
        },
        {
          code: 'AYA',
          name: 'Ayacucho'
        },
        {
          code: 'CAJ',
          name: 'Cajamarca'
        },
        {
          code: 'CAL',
          name: 'Callao'
        },
        {
          code: 'CUS',
          name: 'Cusco'
        },
        {
          code: 'HUV',
          name: 'Huancavelica'
        },
        {
          code: 'HUC',
          name: 'Huanuco'
        },
        {
          code: 'ICA',
          name: 'Ica'
        },
        {
          code: 'JUN',
          name: 'Junín'
        },
        {
          code: 'LAL',
          name: 'La Libertad'
        },
        {
          code: 'LAM',
          name: 'Lambayeque'
        },
        {
          code: 'LIM',
          name: 'Lima'
        },
        {
          code: 'LOR',
          name: 'Loreto'
        },
        {
          code: 'MDD',
          name: 'Madre de Dios'
        },
        {
          code: 'MOQ',
          name: 'Moquegua'
        },
        {
          code: 'PAS',
          name: 'Pasco'
        },
        {
          code: 'PIU',
          name: 'Piura'
        },
        {
          code: 'PUN',
          name: 'Puno'
        },
        {
          code: 'SAM',
          name: 'San Martín'
        },
        {
          code: 'TAC',
          name: 'Tacna'
        },
        {
          code: 'TUM',
          name: 'Tumbes'
        },
        {
          code: 'UCA',
          name: 'Ucayali'
        }
      ]
    },
    {
      code: 'PH',
      name: 'Philippines',
      states: [
        {
          code: 'ABR',
          name: 'Abra'
        },
        {
          code: 'AGN',
          name: 'Agusan del Norte'
        },
        {
          code: 'AGS',
          name: 'Agusan del Sur'
        },
        {
          code: 'AKL',
          name: 'Aklan'
        },
        {
          code: 'ALB',
          name: 'Albay'
        },
        {
          code: 'ANT',
          name: 'Antique'
        },
        {
          code: 'APA',
          name: 'Apayao'
        },
        {
          code: 'AUR',
          name: 'Aurora'
        },
        {
          code: '14',
          name: 'Autonomous Region in Muslim Mindanao'
        },
        {
          code: 'BAS',
          name: 'Basilan'
        },
        {
          code: 'BAN',
          name: 'Bataan'
        },
        {
          code: 'BTN',
          name: 'Batanes'
        },
        {
          code: 'BTG',
          name: 'Batangas'
        },
        {
          code: 'BEN',
          name: 'Benguet'
        },
        {
          code: '05',
          name: 'Bicol'
        },
        {
          code: 'BIL',
          name: 'Biliran'
        },
        {
          code: 'BOH',
          name: 'Bohol'
        },
        {
          code: 'BUK',
          name: 'Bukidnon'
        },
        {
          code: 'BUL',
          name: 'Bulacan'
        },
        {
          code: 'CAG',
          name: 'Cagayan'
        },
        {
          code: '02',
          name: 'Cagayan Valley'
        },
        {
          code: '40',
          name: 'Calabarzon'
        },
        {
          code: 'CAN',
          name: 'Camarines Norte'
        },
        {
          code: 'CAS',
          name: 'Camarines Sur'
        },
        {
          code: 'CAM',
          name: 'Camiguin'
        },
        {
          code: 'CAP',
          name: 'Capiz'
        },
        {
          code: '13',
          name: 'Caraga'
        },
        {
          code: 'CAT',
          name: 'Catanduanes'
        },
        {
          code: 'CAV',
          name: 'Cavite'
        },
        {
          code: 'CEB',
          name: 'Cebu'
        },
        {
          code: '03',
          name: 'Central Luzon'
        },
        {
          code: '07',
          name: 'Central Visayas'
        },
        {
          code: 'COM',
          name: 'Compostela Valley'
        },
        {
          code: '15',
          name: 'Cordillera Administrative'
        },
        {
          code: 'NCO',
          name: 'Cotabato'
        },
        {
          code: '11',
          name: 'Davao'
        },
        {
          code: 'DAV',
          name: 'Davao del Norte'
        },
        {
          code: 'DAS',
          name: 'Davao del Sur'
        },
        {
          code: 'DVO',
          name: 'Davao Occidental'
        },
        {
          code: 'DAO',
          name: 'Davao Oriental'
        },
        {
          code: 'DIN',
          name: 'Dinagat Islands'
        },
        {
          code: 'EAS',
          name: 'Eastern Samar'
        },
        {
          code: '08',
          name: 'Eastern Visayas'
        },
        {
          code: 'GUI',
          name: 'Guimaras'
        },
        {
          code: 'IFU',
          name: 'Ifugao'
        },
        {
          code: '01',
          name: 'Ilocos'
        },
        {
          code: 'ILN',
          name: 'Ilocos Norte'
        },
        {
          code: 'ILS',
          name: 'Ilocos Sur'
        },
        {
          code: 'ILI',
          name: 'Iloilo'
        },
        {
          code: 'ISA',
          name: 'Isabela'
        },
        {
          code: 'KAL',
          name: 'Kalinga'
        },
        {
          code: 'LUN',
          name: 'La Union'
        },
        {
          code: 'LAG',
          name: 'Laguna'
        },
        {
          code: 'LAN',
          name: 'Lanao del Norte'
        },
        {
          code: 'LAS',
          name: 'Lanao del Sur'
        },
        {
          code: 'LEY',
          name: 'Leyte'
        },
        {
          code: 'MAG',
          name: 'Maguindanao'
        },
        {
          code: 'MAD',
          name: 'Marinduque'
        },
        {
          code: 'MAS',
          name: 'Masbate'
        },
        {
          code: 'NCR',
          name: 'Metro Manila'
        },
        {
          code: '41',
          name: 'Mimaropa'
        },
        {
          code: 'MSC',
          name: 'Misamis Occidental'
        },
        {
          code: 'MSR',
          name: 'Misamis Oriental'
        },
        {
          code: 'MOU',
          name: 'Mountain Province'
        },
        {
          code: 'NEC',
          name: 'Negros Occidental'
        },
        {
          code: 'NER',
          name: 'Negros Oriental'
        },
        {
          code: '10',
          name: 'Northern Mindanao'
        },
        {
          code: 'NSA',
          name: 'Northern Samar'
        },
        {
          code: 'NUE',
          name: 'Nueva Ecija'
        },
        {
          code: 'NUV',
          name: 'Nueva Vizcaya'
        },
        {
          code: 'MDC',
          name: 'Occidental Mindoro'
        },
        {
          code: 'MDR',
          name: 'Oriental Mindoro'
        },
        {
          code: 'PLW',
          name: 'Palawan'
        },
        {
          code: 'PAM',
          name: 'Pampanga'
        },
        {
          code: 'PAN',
          name: 'Pangasinan'
        },
        {
          code: 'QUE',
          name: 'Quezon'
        },
        {
          code: 'QUI',
          name: 'Quirino'
        },
        {
          code: 'RIZ',
          name: 'Rizal'
        },
        {
          code: 'ROM',
          name: 'Romblon'
        },
        {
          code: 'SAR',
          name: 'Sarangani'
        },
        {
          code: 'SIG',
          name: 'Siquijor'
        },
        {
          code: '12',
          name: 'Soccsksargen'
        },
        {
          code: 'SOR',
          name: 'Sorsogon'
        },
        {
          code: 'SCO',
          name: 'South Cotabato'
        },
        {
          code: 'SLE',
          name: 'Southern Leyte'
        },
        {
          code: 'SUK',
          name: 'Sultan Kudarat'
        },
        {
          code: 'SLU',
          name: 'Sulu'
        },
        {
          code: 'SUN',
          name: 'Surigao del Norte'
        },
        {
          code: 'SUR',
          name: 'Surigao del Sur'
        },
        {
          code: 'TAR',
          name: 'Tarlac'
        },
        {
          code: 'TAW',
          name: 'Tawi-Tawi'
        },
        {
          code: 'WSA',
          name: 'Western Samar'
        },
        {
          code: '06',
          name: 'Western Visayas'
        },
        {
          code: 'ZMB',
          name: 'Zambales'
        },
        {
          code: 'ZAN',
          name: 'Zamboanga del Norte'
        },
        {
          code: 'ZAS',
          name: 'Zamboanga del Sur'
        },
        {
          code: '09',
          name: 'Zamboanga Peninsula'
        },
        {
          code: 'ZSI',
          name: 'Zamboanga Sibugay'
        }
      ]
    },
    {
      code: 'PN',
      name: 'Pitcairn Island',
      states: []
    },
    {
      code: 'PL',
      name: 'Poland',
      states: [
        {
          code: '30',
          name: 'Greater Poland'
        },
        {
          code: '26',
          name: 'Holy Cross'
        },
        {
          code: '04',
          name: 'Kuyavia-Pomerania'
        },
        {
          code: '12',
          name: 'Lesser Poland'
        },
        {
          code: '02',
          name: 'Lower Silesia'
        },
        {
          code: '06',
          name: 'Lublin'
        },
        {
          code: '08',
          name: 'Lubusz'
        },
        {
          code: '10',
          name: 'Łódź'
        },
        {
          code: '14',
          name: 'Mazovia'
        },
        {
          code: '20',
          name: 'Podlaskie'
        },
        {
          code: '22',
          name: 'Pomerania'
        },
        {
          code: '24',
          name: 'Silesia'
        },
        {
          code: '18',
          name: 'Subcarpathia'
        },
        {
          code: '16',
          name: 'Upper Silesia'
        },
        {
          code: '28',
          name: 'Warmia-Masuria'
        },
        {
          code: '32',
          name: 'West Pomerania'
        }
      ]
    },
    {
      code: 'PT',
      name: 'Portugal',
      states: [
        {
          code: '20',
          name: 'Açores'
        },
        {
          code: '01',
          name: 'Aveiro'
        },
        {
          code: '02',
          name: 'Beja'
        },
        {
          code: '03',
          name: 'Braga'
        },
        {
          code: '04',
          name: 'Bragança'
        },
        {
          code: '05',
          name: 'Castelo Branco'
        },
        {
          code: '06',
          name: 'Coimbra'
        },
        {
          code: '07',
          name: 'Évora'
        },
        {
          code: '08',
          name: 'Faro'
        },
        {
          code: '09',
          name: 'Guarda'
        },
        {
          code: '10',
          name: 'Leiria'
        },
        {
          code: '11',
          name: 'Lisbon'
        },
        {
          code: '30',
          name: 'Madeira'
        },
        {
          code: '12',
          name: 'Portalegre'
        },
        {
          code: '13',
          name: 'Porto'
        },
        {
          code: '14',
          name: 'Santarém'
        },
        {
          code: '15',
          name: 'Setúbal'
        },
        {
          code: '16',
          name: 'Viana do Castelo'
        },
        {
          code: '17',
          name: 'Vila Real'
        },
        {
          code: '18',
          name: 'Viseu'
        }
      ]
    },
    {
      code: 'PR',
      name: 'Puerto Rico',
      states: [
        {
          code: '001',
          name: 'Adjuntas'
        },
        {
          code: '003',
          name: 'Aguada'
        },
        {
          code: '005',
          name: 'Aguadilla'
        },
        {
          code: '007',
          name: 'Aguas Buenas'
        },
        {
          code: '009',
          name: 'Aibonito'
        },
        {
          code: '011',
          name: 'Añasco'
        },
        {
          code: '013',
          name: 'Arecibo'
        },
        {
          code: 'AR',
          name: 'Arecibo'
        },
        {
          code: '015',
          name: 'Arroyo'
        },
        {
          code: '017',
          name: 'Barceloneta'
        },
        {
          code: '019',
          name: 'Barranquitas'
        },
        {
          code: 'BY',
          name: 'Bayamon'
        },
        {
          code: '021',
          name: 'Bayamón'
        },
        {
          code: '023',
          name: 'Cabo Rojo'
        },
        {
          code: 'CG',
          name: 'Caguas'
        },
        {
          code: '025',
          name: 'Caguas'
        },
        {
          code: '027',
          name: 'Camuy'
        },
        {
          code: '029',
          name: 'Canóvanas'
        },
        {
          code: 'CL',
          name: 'Carolina'
        },
        {
          code: '031',
          name: 'Carolina'
        },
        {
          code: '033',
          name: 'Cataño'
        },
        {
          code: '035',
          name: 'Cayey'
        },
        {
          code: '037',
          name: 'Ceiba'
        },
        {
          code: '039',
          name: 'Ciales'
        },
        {
          code: '041',
          name: 'Cidra'
        },
        {
          code: '043',
          name: 'Coamo'
        },
        {
          code: '045',
          name: 'Comerío'
        },
        {
          code: '047',
          name: 'Corozal'
        },
        {
          code: '049',
          name: 'Culebra'
        },
        {
          code: '051',
          name: 'Dorado'
        },
        {
          code: '053',
          name: 'Fajardo'
        },
        {
          code: '054',
          name: 'Florida'
        },
        {
          code: '055',
          name: 'Guánica'
        },
        {
          code: '057',
          name: 'Guayama'
        },
        {
          code: '059',
          name: 'Guayanilla'
        },
        {
          code: 'GN',
          name: 'Guaynabo'
        },
        {
          code: '061',
          name: 'Guaynabo'
        },
        {
          code: '063',
          name: 'Gurabo'
        },
        {
          code: '065',
          name: 'Hatillo'
        },
        {
          code: '067',
          name: 'Hormigueros'
        },
        {
          code: '069',
          name: 'Humacao'
        },
        {
          code: '071',
          name: 'Isabela'
        },
        {
          code: '073',
          name: 'Jayuya'
        },
        {
          code: '075',
          name: 'Juana Díaz'
        },
        {
          code: '077',
          name: 'Juncos'
        },
        {
          code: '079',
          name: 'Lajas'
        },
        {
          code: '081',
          name: 'Lares'
        },
        {
          code: '083',
          name: 'Las Marías'
        },
        {
          code: '085',
          name: 'Las Piedras'
        },
        {
          code: '087',
          name: 'Loíza'
        },
        {
          code: '089',
          name: 'Luquillo'
        },
        {
          code: '091',
          name: 'Manatí'
        },
        {
          code: '093',
          name: 'Maricao'
        },
        {
          code: '095',
          name: 'Maunabo'
        },
        {
          code: 'MG',
          name: 'Mayagüez'
        },
        {
          code: '097',
          name: 'Mayagüez'
        },
        {
          code: '099',
          name: 'Moca'
        },
        {
          code: '101',
          name: 'Morovis'
        },
        {
          code: '103',
          name: 'Naguabo'
        },
        {
          code: '105',
          name: 'Naranjito'
        },
        {
          code: '107',
          name: 'Orocovis'
        },
        {
          code: '109',
          name: 'Patillas'
        },
        {
          code: '111',
          name: 'Peñuelas'
        },
        {
          code: 'PO',
          name: 'Ponce'
        },
        {
          code: '113',
          name: 'Ponce'
        },
        {
          code: '115',
          name: 'Quebradillas'
        },
        {
          code: '117',
          name: 'Rincón'
        },
        {
          code: '119',
          name: 'Río Grande'
        },
        {
          code: '121',
          name: 'Sabana Grande'
        },
        {
          code: '123',
          name: 'Salinas'
        },
        {
          code: '125',
          name: 'San Germán'
        },
        {
          code: '127',
          name: 'San Juan'
        },
        {
          code: 'SJ',
          name: 'San Juan'
        },
        {
          code: '129',
          name: 'San Lorenzo'
        },
        {
          code: '131',
          name: 'San Sebastián'
        },
        {
          code: '133',
          name: 'Santa Isabel'
        },
        {
          code: '135',
          name: 'Toa Alta'
        },
        {
          code: 'TB',
          name: 'Toa Baja'
        },
        {
          code: '137',
          name: 'Toa Baja'
        },
        {
          code: 'TA',
          name: 'Trujillo Alto'
        },
        {
          code: '139',
          name: 'Trujillo Alto'
        },
        {
          code: '141',
          name: 'Utuado'
        },
        {
          code: '143',
          name: 'Vega Alta'
        },
        {
          code: '145',
          name: 'Vega Baja'
        },
        {
          code: '147',
          name: 'Vieques'
        },
        {
          code: '149',
          name: 'Villalba'
        },
        {
          code: '151',
          name: 'Yabucoa'
        },
        {
          code: '153',
          name: 'Yauco'
        }
      ]
    },
    {
      code: 'QA',
      name: 'Qatar',
      states: [
        {
          code: 'ZA',
          name: 'Al Daayen'
        },
        {
          code: 'KH',
          name: 'Al Khor'
        },
        {
          code: 'RA',
          name: 'Al Rayyan Municipality'
        },
        {
          code: 'WA',
          name: 'Al Wakrah'
        },
        {
          code: 'SH',
          name: 'Al-Shahaniya'
        },
        {
          code: 'DA',
          name: 'Doha'
        },
        {
          code: 'MS',
          name: 'Madinat ash Shamal'
        },
        {
          code: 'US',
          name: 'Umm Salal Municipality'
        }
      ]
    },
    {
      code: 'RE',
      name: 'Reunion',
      states: []
    },
    {
      code: 'RO',
      name: 'Romania',
      states: [
        {
          code: 'AB',
          name: 'Alba'
        },
        {
          code: 'AR',
          name: 'Arad County'
        },
        {
          code: 'AG',
          name: 'Arges'
        },
        {
          code: 'BC',
          name: 'Bacău County'
        },
        {
          code: 'BH',
          name: 'Bihor County'
        },
        {
          code: 'BN',
          name: 'Bistrița-Năsăud County'
        },
        {
          code: 'BT',
          name: 'Botoșani County'
        },
        {
          code: 'BR',
          name: 'Braila'
        },
        {
          code: 'BV',
          name: 'Brașov County'
        },
        {
          code: 'B',
          name: 'Bucharest'
        },
        {
          code: 'BZ',
          name: 'Buzău County'
        },
        {
          code: 'CL',
          name: 'Călărași County'
        },
        {
          code: 'CS',
          name: 'Caraș-Severin County'
        },
        {
          code: 'CJ',
          name: 'Cluj County'
        },
        {
          code: 'CT',
          name: 'Constanța County'
        },
        {
          code: 'CV',
          name: 'Covasna County'
        },
        {
          code: 'DB',
          name: 'Dâmbovița County'
        },
        {
          code: 'DJ',
          name: 'Dolj County'
        },
        {
          code: 'GL',
          name: 'Galați County'
        },
        {
          code: 'GR',
          name: 'Giurgiu County'
        },
        {
          code: 'GJ',
          name: 'Gorj County'
        },
        {
          code: 'HR',
          name: 'Harghita County'
        },
        {
          code: 'HD',
          name: 'Hunedoara County'
        },
        {
          code: 'IL',
          name: 'Ialomița County'
        },
        {
          code: 'IS',
          name: 'Iași County'
        },
        {
          code: 'IF',
          name: 'Ilfov County'
        },
        {
          code: 'MM',
          name: 'Maramureș County'
        },
        {
          code: 'MH',
          name: 'Mehedinți County'
        },
        {
          code: 'MS',
          name: 'Mureș County'
        },
        {
          code: 'NT',
          name: 'Neamț County'
        },
        {
          code: 'OT',
          name: 'Olt County'
        },
        {
          code: 'PH',
          name: 'Prahova County'
        },
        {
          code: 'SJ',
          name: 'Sălaj County'
        },
        {
          code: 'SM',
          name: 'Satu Mare County'
        },
        {
          code: 'SB',
          name: 'Sibiu County'
        },
        {
          code: 'SV',
          name: 'Suceava County'
        },
        {
          code: 'TR',
          name: 'Teleorman County'
        },
        {
          code: 'TM',
          name: 'Timiș County'
        },
        {
          code: 'TL',
          name: 'Tulcea County'
        },
        {
          code: 'VL',
          name: 'Vâlcea County'
        },
        {
          code: 'VS',
          name: 'Vaslui County'
        },
        {
          code: 'VN',
          name: 'Vrancea County'
        }
      ]
    },
    {
      code: 'RU',
      name: 'Russia',
      states: [
        {
          code: 'ALT',
          name: 'Altai Krai'
        },
        {
          code: 'AL',
          name: 'Altai Republic'
        },
        {
          code: 'AMU',
          name: 'Amur Oblast'
        },
        {
          code: 'ARK',
          name: 'Arkhangelsk'
        },
        {
          code: 'AST',
          name: 'Astrakhan Oblast'
        },
        {
          code: 'BEL',
          name: 'Belgorod Oblast'
        },
        {
          code: 'BRY',
          name: 'Bryansk Oblast'
        },
        {
          code: 'CE',
          name: 'Chechen Republic'
        },
        {
          code: 'CHE',
          name: 'Chelyabinsk Oblast'
        },
        {
          code: 'CHU',
          name: 'Chukotka Autonomous Okrug'
        },
        {
          code: 'CU',
          name: 'Chuvash Republic'
        },
        {
          code: 'IRK',
          name: 'Irkutsk'
        },
        {
          code: 'IVA',
          name: 'Ivanovo Oblast'
        },
        {
          code: 'YEV',
          name: 'Jewish Autonomous Oblast'
        },
        {
          code: 'KB',
          name: 'Kabardino-Balkar Republic'
        },
        {
          code: 'KGD',
          name: 'Kaliningrad'
        },
        {
          code: 'KLU',
          name: 'Kaluga Oblast'
        },
        {
          code: 'KAM',
          name: 'Kamchatka Krai'
        },
        {
          code: 'KC',
          name: 'Karachay-Cherkess Republic'
        },
        {
          code: 'KEM',
          name: 'Kemerovo Oblast'
        },
        {
          code: 'KHA',
          name: 'Khabarovsk Krai'
        },
        {
          code: 'KHM',
          name: 'Khanty-Mansi Autonomous Okrug'
        },
        {
          code: 'KIR',
          name: 'Kirov Oblast'
        },
        {
          code: 'KO',
          name: 'Komi Republic'
        },
        {
          code: 'KOS',
          name: 'Kostroma Oblast'
        },
        {
          code: 'KDA',
          name: 'Krasnodar Krai'
        },
        {
          code: 'KYA',
          name: 'Krasnoyarsk Krai'
        },
        {
          code: 'KGN',
          name: 'Kurgan Oblast'
        },
        {
          code: 'KRS',
          name: 'Kursk Oblast'
        },
        {
          code: 'LEN',
          name: 'Leningrad Oblast'
        },
        {
          code: 'LIP',
          name: 'Lipetsk Oblast'
        },
        {
          code: 'MAG',
          name: 'Magadan Oblast'
        },
        {
          code: 'ME',
          name: 'Mari El Republic'
        },
        {
          code: 'MOW',
          name: 'Moscow'
        },
        {
          code: 'MOS',
          name: 'Moscow Oblast'
        },
        {
          code: 'MUR',
          name: 'Murmansk Oblast'
        },
        {
          code: 'NEN',
          name: 'Nenets Autonomous Okrug'
        },
        {
          code: 'NIZ',
          name: 'Nizhny Novgorod Oblast'
        },
        {
          code: 'NGR',
          name: 'Novgorod Oblast'
        },
        {
          code: 'NVS',
          name: 'Novosibirsk'
        },
        {
          code: 'OMS',
          name: 'Omsk Oblast'
        },
        {
          code: 'ORE',
          name: 'Orenburg Oblast'
        },
        {
          code: 'ORL',
          name: 'Oryol Oblast'
        },
        {
          code: 'PNZ',
          name: 'Penza Oblast'
        },
        {
          code: 'PER',
          name: 'Perm Krai'
        },
        {
          code: 'PRI',
          name: 'Primorsky Krai'
        },
        {
          code: 'PSK',
          name: 'Pskov Oblast'
        },
        {
          code: 'AD',
          name: 'Republic of Adygea'
        },
        {
          code: 'BA',
          name: 'Republic of Bashkortostan'
        },
        {
          code: 'BU',
          name: 'Republic of Buryatia'
        },
        {
          code: 'DA',
          name: 'Republic of Dagestan'
        },
        {
          code: 'IN',
          name: 'Republic of Ingushetia'
        },
        {
          code: 'KL',
          name: 'Republic of Kalmykia'
        },
        {
          code: 'KR',
          name: 'Republic of Karelia'
        },
        {
          code: 'KK',
          name: 'Republic of Khakassia'
        },
        {
          code: 'MO',
          name: 'Republic of Mordovia'
        },
        {
          code: 'SE',
          name: 'Republic of North Ossetia-Alania'
        },
        {
          code: 'TA',
          name: 'Republic of Tatarstan'
        },
        {
          code: 'ROS',
          name: 'Rostov Oblast'
        },
        {
          code: 'RYA',
          name: 'Ryazan Oblast'
        },
        {
          code: 'SPE',
          name: 'Saint Petersburg'
        },
        {
          code: 'SA',
          name: 'Sakha Republic'
        },
        {
          code: 'SAK',
          name: 'Sakhalin'
        },
        {
          code: 'SAM',
          name: 'Samara Oblast'
        },
        {
          code: 'SAR',
          name: 'Saratov Oblast'
        },
        {
          code: 'SMO',
          name: 'Smolensk Oblast'
        },
        {
          code: 'STA',
          name: 'Stavropol Krai'
        },
        {
          code: 'SVE',
          name: 'Sverdlovsk'
        },
        {
          code: 'TAM',
          name: 'Tambov Oblast'
        },
        {
          code: 'TOM',
          name: 'Tomsk Oblast'
        },
        {
          code: 'TUL',
          name: 'Tula Oblast'
        },
        {
          code: 'TY',
          name: 'Tuva Republic'
        },
        {
          code: 'TVE',
          name: 'Tver Oblast'
        },
        {
          code: 'TYU',
          name: 'Tyumen Oblast'
        },
        {
          code: 'UD',
          name: 'Udmurt Republic'
        },
        {
          code: 'ULY',
          name: 'Ulyanovsk Oblast'
        },
        {
          code: 'VLA',
          name: 'Vladimir Oblast'
        },
        {
          code: 'VGG',
          name: 'Volgograd Oblast'
        },
        {
          code: 'VLG',
          name: 'Vologda Oblast'
        },
        {
          code: 'VOR',
          name: 'Voronezh Oblast'
        },
        {
          code: 'YAN',
          name: 'Yamalo-Nenets Autonomous Okrug'
        },
        {
          code: 'YAR',
          name: 'Yaroslavl Oblast'
        },
        {
          code: 'ZAB',
          name: 'Zabaykalsky Krai'
        }
      ]
    },
    {
      code: 'RW',
      name: 'Rwanda',
      states: [
        {
          code: '02',
          name: 'Eastern Province'
        },
        {
          code: '01',
          name: 'Kigali district'
        },
        {
          code: '03',
          name: 'Northern Province'
        },
        {
          code: '05',
          name: 'Southern Province'
        },
        {
          code: '04',
          name: 'Western Province'
        }
      ]
    },
    {
      code: 'SH',
      name: 'Saint Helena',
      states: []
    },
    {
      code: 'KN',
      name: 'Saint Kitts and Nevis',
      states: [
        {
          code: '01',
          name: 'Christ Church Nichola Town Parish'
        },
        {
          code: 'N',
          name: 'Nevis'
        },
        {
          code: '02',
          name: 'Saint Anne Sandy Point Parish'
        },
        {
          code: '04',
          name: 'Saint George Gingerland Parish'
        },
        {
          code: '05',
          name: 'Saint James Windward Parish'
        },
        {
          code: '06',
          name: 'Saint John Capisterre Parish'
        },
        {
          code: '07',
          name: 'Saint John Figtree Parish'
        },
        {
          code: 'K',
          name: 'Saint Kitts'
        },
        {
          code: '08',
          name: 'Saint Mary Cayon Parish'
        },
        {
          code: '09',
          name: 'Saint Paul Capisterre Parish'
        },
        {
          code: '10',
          name: 'Saint Paul Charlestown Parish'
        },
        {
          code: '11',
          name: 'Saint Peter Basseterre Parish'
        },
        {
          code: '12',
          name: 'Saint Thomas Lowland Parish'
        },
        {
          code: '13',
          name: 'Saint Thomas Middle Island Parish'
        },
        {
          code: '15',
          name: 'Trinity Palmetto Point Parish'
        }
      ]
    },
    {
      code: 'LC',
      name: 'Saint Lucia',
      states: [
        {
          code: '01',
          name: 'Anse la Raye Quarter'
        },
        {
          code: '12',
          name: 'Canaries'
        },
        {
          code: '02',
          name: 'Castries Quarter'
        },
        {
          code: '03',
          name: 'Choiseul Quarter'
        },
        {
          code: '04',
          name: 'Dauphin Quarter'
        },
        {
          code: '05',
          name: 'Dennery Quarter'
        },
        {
          code: '06',
          name: 'Gros Islet Quarter'
        },
        {
          code: '07',
          name: 'Laborie Quarter'
        },
        {
          code: '08',
          name: 'Micoud Quarter'
        },
        {
          code: '09',
          name: 'Praslin Quarter'
        },
        {
          code: '10',
          name: 'Soufrière Quarter'
        },
        {
          code: '11',
          name: 'Vieux Fort Quarter'
        }
      ]
    },
    {
      code: 'PM',
      name: 'Saint Pierre and Miquelon',
      states: []
    },
    {
      code: 'VC',
      name: 'Saint Vincent and the Grenadines',
      states: [
        {
          code: '01',
          name: 'Charlotte Parish'
        },
        {
          code: '06',
          name: 'Grenadines Parish'
        },
        {
          code: '02',
          name: 'Saint Andrew Parish'
        },
        {
          code: '03',
          name: 'Saint David Parish'
        },
        {
          code: '04',
          name: 'Saint George Parish'
        },
        {
          code: '05',
          name: 'Saint Patrick Parish'
        }
      ]
    },
    {
      code: 'BL',
      name: 'Saint-Barthelemy',
      states: []
    },
    {
      code: 'MF',
      name: 'Saint-Martin (French part)',
      states: []
    },
    {
      code: 'WS',
      name: 'Samoa',
      states: [
        {
          code: 'AA',
          name: "A'ana"
        },
        {
          code: 'AL',
          name: 'Aiga-i-le-Tai'
        },
        {
          code: 'AT',
          name: 'Atua'
        },
        {
          code: 'FA',
          name: "Fa'asaleleaga"
        },
        {
          code: 'GE',
          name: "Gaga'emauga"
        },
        {
          code: 'GI',
          name: "Gaga'ifomauga"
        },
        {
          code: 'PA',
          name: 'Palauli'
        },
        {
          code: 'SA',
          name: "Satupa'itea"
        },
        {
          code: 'TU',
          name: 'Tuamasaga'
        },
        {
          code: 'VF',
          name: "Va'a-o-Fonoti"
        },
        {
          code: 'VS',
          name: 'Vaisigano'
        }
      ]
    },
    {
      code: 'SM',
      name: 'San Marino',
      states: [
        {
          code: '01',
          name: 'Acquaviva'
        },
        {
          code: '06',
          name: 'Borgo Maggiore'
        },
        {
          code: '02',
          name: 'Chiesanuova'
        },
        {
          code: '03',
          name: 'Domagnano'
        },
        {
          code: '04',
          name: 'Faetano'
        },
        {
          code: '05',
          name: 'Fiorentino'
        },
        {
          code: '08',
          name: 'Montegiardino'
        },
        {
          code: '07',
          name: 'San Marino'
        },
        {
          code: '09',
          name: 'Serravalle'
        }
      ]
    },
    {
      code: 'ST',
      name: 'Sao Tome and Principe',
      states: [
        {
          code: 'P',
          name: 'Príncipe Province'
        },
        {
          code: 'S',
          name: 'São Tomé Province'
        }
      ]
    },
    {
      code: 'SA',
      name: 'Saudi Arabia',
      states: [
        {
          code: '14',
          name: "'Asir"
        },
        {
          code: '11',
          name: 'Al Bahah'
        },
        {
          code: '12',
          name: 'Al Jawf'
        },
        {
          code: '03',
          name: 'Al Madinah'
        },
        {
          code: '05',
          name: 'Al-Qassim'
        },
        {
          code: '04',
          name: 'Eastern Province'
        },
        {
          code: '06',
          name: "Ha'il"
        },
        {
          code: '09',
          name: 'Jizan'
        },
        {
          code: '02',
          name: 'Makkah'
        },
        {
          code: '10',
          name: 'Najran'
        },
        {
          code: '08',
          name: 'Northern Borders'
        },
        {
          code: '01',
          name: 'Riyadh'
        },
        {
          code: '07',
          name: 'Tabuk'
        }
      ]
    },
    {
      code: 'SN',
      name: 'Senegal',
      states: [
        {
          code: 'DK',
          name: 'Dakar'
        },
        {
          code: 'DB',
          name: 'Diourbel Region'
        },
        {
          code: 'FK',
          name: 'Fatick'
        },
        {
          code: 'KA',
          name: 'Kaffrine'
        },
        {
          code: 'KL',
          name: 'Kaolack'
        },
        {
          code: 'KE',
          name: 'Kédougou'
        },
        {
          code: 'KD',
          name: 'Kolda'
        },
        {
          code: 'LG',
          name: 'Louga'
        },
        {
          code: 'MT',
          name: 'Matam'
        },
        {
          code: 'SL',
          name: 'Saint-Louis'
        },
        {
          code: 'SE',
          name: 'Sédhiou'
        },
        {
          code: 'TC',
          name: 'Tambacounda Region'
        },
        {
          code: 'TH',
          name: 'Thiès Region'
        },
        {
          code: 'ZG',
          name: 'Ziguinchor'
        }
      ]
    },
    {
      code: 'RS',
      name: 'Serbia',
      states: [
        {
          code: '00',
          name: 'Belgrade'
        },
        {
          code: '14',
          name: 'Bor District'
        },
        {
          code: '11',
          name: 'Braničevo District'
        },
        {
          code: '02',
          name: 'Central Banat District'
        },
        {
          code: '23',
          name: 'Jablanica District'
        },
        {
          code: '09',
          name: 'Kolubara District'
        },
        {
          code: '08',
          name: 'Mačva District'
        },
        {
          code: '17',
          name: 'Moravica District'
        },
        {
          code: '20',
          name: 'Nišava District'
        },
        {
          code: '01',
          name: 'North Bačka District'
        },
        {
          code: '03',
          name: 'North Banat District'
        },
        {
          code: '24',
          name: 'Pčinja District'
        },
        {
          code: '22',
          name: 'Pirot District'
        },
        {
          code: '10',
          name: 'Podunavlje District'
        },
        {
          code: '13',
          name: 'Pomoravlje District'
        },
        {
          code: '19',
          name: 'Rasina District'
        },
        {
          code: '18',
          name: 'Raška District'
        },
        {
          code: '06',
          name: 'South Bačka District'
        },
        {
          code: '04',
          name: 'South Banat District'
        },
        {
          code: '07',
          name: 'Srem District'
        },
        {
          code: '12',
          name: 'Šumadija District'
        },
        {
          code: '21',
          name: 'Toplica District'
        },
        {
          code: 'VO',
          name: 'Vojvodina'
        },
        {
          code: '05',
          name: 'West Bačka District'
        },
        {
          code: '15',
          name: 'Zaječar District'
        },
        {
          code: '16',
          name: 'Zlatibor District'
        }
      ]
    },
    {
      code: 'SC',
      name: 'Seychelles',
      states: [
        {
          code: '02',
          name: 'Anse Boileau'
        },
        {
          code: '05',
          name: 'Anse Royale'
        },
        {
          code: '01',
          name: 'Anse-aux-Pins'
        },
        {
          code: '04',
          name: 'Au Cap'
        },
        {
          code: '06',
          name: 'Baie Lazare'
        },
        {
          code: '07',
          name: 'Baie Sainte Anne'
        },
        {
          code: '08',
          name: 'Beau Vallon'
        },
        {
          code: '09',
          name: 'Bel Air'
        },
        {
          code: '10',
          name: 'Bel Ombre'
        },
        {
          code: '11',
          name: 'Cascade'
        },
        {
          code: '12',
          name: 'Glacis'
        },
        {
          code: '13',
          name: "Grand'Anse Mahé"
        },
        {
          code: '14',
          name: "Grand'Anse Praslin"
        },
        {
          code: '15',
          name: 'La Digue'
        },
        {
          code: '16',
          name: 'La Rivière Anglaise'
        },
        {
          code: '24',
          name: 'Les Mamelles'
        },
        {
          code: '17',
          name: 'Mont Buxton'
        },
        {
          code: '18',
          name: 'Mont Fleuri'
        },
        {
          code: '19',
          name: 'Plaisance'
        },
        {
          code: '20',
          name: 'Pointe La Rue'
        },
        {
          code: '21',
          name: 'Port Glaud'
        },
        {
          code: '25',
          name: 'Roche Caiman'
        },
        {
          code: '22',
          name: 'Saint Louis'
        },
        {
          code: '23',
          name: 'Takamaka'
        }
      ]
    },
    {
      code: 'SL',
      name: 'Sierra Leone',
      states: [
        {
          code: 'E',
          name: 'Eastern Province'
        },
        {
          code: 'N',
          name: 'Northern Province'
        },
        {
          code: 'S',
          name: 'Southern Province'
        },
        {
          code: 'W',
          name: 'Western Area'
        }
      ]
    },
    {
      code: 'SG',
      name: 'Singapore',
      states: [
        {
          code: '01',
          name: 'Central Singapore'
        },
        {
          code: '02',
          name: 'North East'
        },
        {
          code: '03',
          name: 'North West'
        },
        {
          code: '04',
          name: 'South East'
        },
        {
          code: '05',
          name: 'South West'
        }
      ]
    },
    {
      code: 'SX',
      name: 'Sint Maarten (Dutch part)',
      states: []
    },
    {
      code: 'SK',
      name: 'Slovakia',
      states: [
        {
          code: 'BC',
          name: 'Banská Bystrica Region'
        },
        {
          code: 'BL',
          name: 'Bratislava Region'
        },
        {
          code: 'KI',
          name: 'Košice Region'
        },
        {
          code: 'NI',
          name: 'Nitra Region'
        },
        {
          code: 'PV',
          name: 'Prešov Region'
        },
        {
          code: 'TC',
          name: 'Trenčín Region'
        },
        {
          code: 'TA',
          name: 'Trnava Region'
        },
        {
          code: 'ZI',
          name: 'Žilina Region'
        }
      ]
    },
    {
      code: 'SI',
      name: 'Slovenia',
      states: [
        {
          code: '001',
          name: 'Ajdovščina Municipality'
        },
        {
          code: '213',
          name: 'Ankaran Municipality'
        },
        {
          code: '002',
          name: 'Beltinci Municipality'
        },
        {
          code: '148',
          name: 'Benedikt Municipality'
        },
        {
          code: '149',
          name: 'Bistrica ob Sotli Municipality'
        },
        {
          code: '003',
          name: 'Bled Municipality'
        },
        {
          code: '150',
          name: 'Bloke Municipality'
        },
        {
          code: '004',
          name: 'Bohinj Municipality'
        },
        {
          code: '005',
          name: 'Borovnica Municipality'
        },
        {
          code: '006',
          name: 'Bovec Municipality'
        },
        {
          code: '151',
          name: 'Braslovče Municipality'
        },
        {
          code: '007',
          name: 'Brda Municipality'
        },
        {
          code: '009',
          name: 'Brežice Municipality'
        },
        {
          code: '008',
          name: 'Brezovica Municipality'
        },
        {
          code: '152',
          name: 'Cankova Municipality'
        },
        {
          code: '012',
          name: 'Cerklje na Gorenjskem Municipality'
        },
        {
          code: '013',
          name: 'Cerknica Municipality'
        },
        {
          code: '014',
          name: 'Cerkno Municipality'
        },
        {
          code: '153',
          name: 'Cerkvenjak Municipality'
        },
        {
          code: '011',
          name: 'City Municipality of Celje'
        },
        {
          code: '085',
          name: 'City Municipality of Novo Mesto'
        },
        {
          code: '015',
          name: 'Črenšovci Municipality'
        },
        {
          code: '016',
          name: 'Črna na Koroškem Municipality'
        },
        {
          code: '017',
          name: 'Črnomelj Municipality'
        },
        {
          code: '018',
          name: 'Destrnik Municipality'
        },
        {
          code: '019',
          name: 'Divača Municipality'
        },
        {
          code: '154',
          name: 'Dobje Municipality'
        },
        {
          code: '020',
          name: 'Dobrepolje Municipality'
        },
        {
          code: '155',
          name: 'Dobrna Municipality'
        },
        {
          code: '021',
          name: 'Dobrova\u2013Polhov Gradec Municipality'
        },
        {
          code: '156',
          name: 'Dobrovnik Municipality'
        },
        {
          code: '022',
          name: 'Dol pri Ljubljani Municipality'
        },
        {
          code: '157',
          name: 'Dolenjske Toplice Municipality'
        },
        {
          code: '023',
          name: 'Domžale Municipality'
        },
        {
          code: '024',
          name: 'Dornava Municipality'
        },
        {
          code: '025',
          name: 'Dravograd Municipality'
        },
        {
          code: '026',
          name: 'Duplek Municipality'
        },
        {
          code: '027',
          name: 'Gorenja Vas\u2013Poljane Municipality'
        },
        {
          code: '028',
          name: 'Gorišnica Municipality'
        },
        {
          code: '207',
          name: 'Gorje Municipality'
        },
        {
          code: '029',
          name: 'Gornja Radgona Municipality'
        },
        {
          code: '030',
          name: 'Gornji Grad Municipality'
        },
        {
          code: '031',
          name: 'Gornji Petrovci Municipality'
        },
        {
          code: '158',
          name: 'Grad Municipality'
        },
        {
          code: '032',
          name: 'Grosuplje Municipality'
        },
        {
          code: '159',
          name: 'Hajdina Municipality'
        },
        {
          code: '160',
          name: 'Hoče\u2013Slivnica Municipality'
        },
        {
          code: '161',
          name: 'Hodoš Municipality'
        },
        {
          code: '162',
          name: 'Horjul Municipality'
        },
        {
          code: '034',
          name: 'Hrastnik Municipality'
        },
        {
          code: '035',
          name: 'Hrpelje\u2013Kozina Municipality'
        },
        {
          code: '036',
          name: 'Idrija Municipality'
        },
        {
          code: '037',
          name: 'Ig Municipality'
        },
        {
          code: '039',
          name: 'Ivančna Gorica Municipality'
        },
        {
          code: '040',
          name: 'Izola Municipality'
        },
        {
          code: '041',
          name: 'Jesenice Municipality'
        },
        {
          code: '163',
          name: 'Jezersko Municipality'
        },
        {
          code: '042',
          name: 'Juršinci Municipality'
        },
        {
          code: '043',
          name: 'Kamnik Municipality'
        },
        {
          code: '044',
          name: 'Kanal ob Soči Municipality'
        },
        {
          code: '045',
          name: 'Kidričevo Municipality'
        },
        {
          code: '046',
          name: 'Kobarid Municipality'
        },
        {
          code: '047',
          name: 'Kobilje Municipality'
        },
        {
          code: '048',
          name: 'Kočevje Municipality'
        },
        {
          code: '049',
          name: 'Komen Municipality'
        },
        {
          code: '164',
          name: 'Komenda Municipality'
        },
        {
          code: '050',
          name: 'Koper City Municipality'
        },
        {
          code: '197',
          name: 'Kostanjevica na Krki Municipality'
        },
        {
          code: '165',
          name: 'Kostel Municipality'
        },
        {
          code: '051',
          name: 'Kozje Municipality'
        },
        {
          code: '052',
          name: 'Kranj City Municipality'
        },
        {
          code: '053',
          name: 'Kranjska Gora Municipality'
        },
        {
          code: '166',
          name: 'Križevci Municipality'
        },
        {
          code: '055',
          name: 'Kungota'
        },
        {
          code: '056',
          name: 'Kuzma Municipality'
        },
        {
          code: '057',
          name: 'Laško Municipality'
        },
        {
          code: '058',
          name: 'Lenart Municipality'
        },
        {
          code: '059',
          name: 'Lendava Municipality'
        },
        {
          code: '060',
          name: 'Litija Municipality'
        },
        {
          code: '061',
          name: 'Ljubljana City Municipality'
        },
        {
          code: '062',
          name: 'Ljubno Municipality'
        },
        {
          code: '063',
          name: 'Ljutomer Municipality'
        },
        {
          code: '208',
          name: 'Log\u2013Dragomer Municipality'
        },
        {
          code: '064',
          name: 'Logatec Municipality'
        },
        {
          code: '065',
          name: 'Loška Dolina Municipality'
        },
        {
          code: '066',
          name: 'Loški Potok Municipality'
        },
        {
          code: '167',
          name: 'Lovrenc na Pohorju Municipality'
        },
        {
          code: '067',
          name: 'Luče Municipality'
        },
        {
          code: '068',
          name: 'Lukovica Municipality'
        },
        {
          code: '069',
          name: 'Majšperk Municipality'
        },
        {
          code: '198',
          name: 'Makole Municipality'
        },
        {
          code: '070',
          name: 'Maribor City Municipality'
        },
        {
          code: '168',
          name: 'Markovci Municipality'
        },
        {
          code: '071',
          name: 'Medvode Municipality'
        },
        {
          code: '072',
          name: 'Mengeš Municipality'
        },
        {
          code: '073',
          name: 'Metlika Municipality'
        },
        {
          code: '074',
          name: 'Mežica Municipality'
        },
        {
          code: '169',
          name: 'Miklavž na Dravskem Polju Municipality'
        },
        {
          code: '075',
          name: 'Miren\u2013Kostanjevica Municipality'
        },
        {
          code: '212',
          name: 'Mirna Municipality'
        },
        {
          code: '170',
          name: 'Mirna Peč Municipality'
        },
        {
          code: '076',
          name: 'Mislinja Municipality'
        },
        {
          code: '199',
          name: 'Mokronog\u2013Trebelno Municipality'
        },
        {
          code: '077',
          name: 'Moravče Municipality'
        },
        {
          code: '078',
          name: 'Moravske Toplice Municipality'
        },
        {
          code: '079',
          name: 'Mozirje Municipality'
        },
        {
          code: '195',
          name: 'Municipality of Apače'
        },
        {
          code: '196',
          name: 'Municipality of Cirkulane'
        },
        {
          code: '038',
          name: 'Municipality of Ilirska Bistrica'
        },
        {
          code: '054',
          name: 'Municipality of Krško'
        },
        {
          code: '123',
          name: 'Municipality of Škofljica'
        },
        {
          code: '080',
          name: 'Murska Sobota City Municipality'
        },
        {
          code: '081',
          name: 'Muta Municipality'
        },
        {
          code: '082',
          name: 'Naklo Municipality'
        },
        {
          code: '083',
          name: 'Nazarje Municipality'
        },
        {
          code: '084',
          name: 'Nova Gorica City Municipality'
        },
        {
          code: '086',
          name: 'Odranci Municipality'
        },
        {
          code: '171',
          name: 'Oplotnica'
        },
        {
          code: '087',
          name: 'Ormož Municipality'
        },
        {
          code: '088',
          name: 'Osilnica Municipality'
        },
        {
          code: '089',
          name: 'Pesnica Municipality'
        },
        {
          code: '090',
          name: 'Piran Municipality'
        },
        {
          code: '091',
          name: 'Pivka Municipality'
        },
        {
          code: '092',
          name: 'Podčetrtek Municipality'
        },
        {
          code: '172',
          name: 'Podlehnik Municipality'
        },
        {
          code: '093',
          name: 'Podvelka Municipality'
        },
        {
          code: '200',
          name: 'Poljčane Municipality'
        },
        {
          code: '173',
          name: 'Polzela Municipality'
        },
        {
          code: '094',
          name: 'Postojna Municipality'
        },
        {
          code: '174',
          name: 'Prebold Municipality'
        },
        {
          code: '095',
          name: 'Preddvor Municipality'
        },
        {
          code: '175',
          name: 'Prevalje Municipality'
        },
        {
          code: '096',
          name: 'Ptuj City Municipality'
        },
        {
          code: '097',
          name: 'Puconci Municipality'
        },
        {
          code: '098',
          name: 'Rače\u2013Fram Municipality'
        },
        {
          code: '099',
          name: 'Radeče Municipality'
        },
        {
          code: '100',
          name: 'Radenci Municipality'
        },
        {
          code: '101',
          name: 'Radlje ob Dravi Municipality'
        },
        {
          code: '102',
          name: 'Radovljica Municipality'
        },
        {
          code: '103',
          name: 'Ravne na Koroškem Municipality'
        },
        {
          code: '176',
          name: 'Razkrižje Municipality'
        },
        {
          code: '209',
          name: 'Rečica ob Savinji Municipality'
        },
        {
          code: '201',
          name: 'Renče\u2013Vogrsko Municipality'
        },
        {
          code: '104',
          name: 'Ribnica Municipality'
        },
        {
          code: '177',
          name: 'Ribnica na Pohorju Municipality'
        },
        {
          code: '106',
          name: 'Rogaška Slatina Municipality'
        },
        {
          code: '105',
          name: 'Rogašovci Municipality'
        },
        {
          code: '107',
          name: 'Rogatec Municipality'
        },
        {
          code: '108',
          name: 'Ruše Municipality'
        },
        {
          code: '033',
          name: 'Šalovci Municipality'
        },
        {
          code: '178',
          name: 'Selnica ob Dravi Municipality'
        },
        {
          code: '109',
          name: 'Semič Municipality'
        },
        {
          code: '183',
          name: 'Šempeter\u2013Vrtojba Municipality'
        },
        {
          code: '117',
          name: 'Šenčur Municipality'
        },
        {
          code: '118',
          name: 'Šentilj Municipality'
        },
        {
          code: '119',
          name: 'Šentjernej Municipality'
        },
        {
          code: '120',
          name: 'Šentjur Municipality'
        },
        {
          code: '211',
          name: 'Šentrupert Municipality'
        },
        {
          code: '110',
          name: 'Sevnica Municipality'
        },
        {
          code: '111',
          name: 'Sežana Municipality'
        },
        {
          code: '121',
          name: 'Škocjan Municipality'
        },
        {
          code: '122',
          name: 'Škofja Loka Municipality'
        },
        {
          code: '112',
          name: 'Slovenj Gradec City Municipality'
        },
        {
          code: '113',
          name: 'Slovenska Bistrica Municipality'
        },
        {
          code: '114',
          name: 'Slovenske Konjice Municipality'
        },
        {
          code: '124',
          name: 'Šmarje pri Jelšah Municipality'
        },
        {
          code: '206',
          name: 'Šmarješke Toplice Municipality'
        },
        {
          code: '125',
          name: 'Šmartno ob Paki Municipality'
        },
        {
          code: '194',
          name: 'Šmartno pri Litiji Municipality'
        },
        {
          code: '179',
          name: 'Sodražica Municipality'
        },
        {
          code: '180',
          name: 'Solčava Municipality'
        },
        {
          code: '126',
          name: 'Šoštanj Municipality'
        },
        {
          code: '202',
          name: 'Središče ob Dravi'
        },
        {
          code: '115',
          name: 'Starše Municipality'
        },
        {
          code: '127',
          name: 'Štore Municipality'
        },
        {
          code: '203',
          name: 'Straža Municipality'
        },
        {
          code: '181',
          name: 'Sveta Ana Municipality'
        },
        {
          code: '204',
          name: 'Sveta Trojica v Slovenskih Goricah Municipality'
        },
        {
          code: '182',
          name: 'Sveti Andraž v Slovenskih Goricah Municipality'
        },
        {
          code: '116',
          name: 'Sveti Jurij ob Ščavnici Municipality'
        },
        {
          code: '210',
          name: 'Sveti Jurij v Slovenskih Goricah Municipality'
        },
        {
          code: '205',
          name: 'Sveti Tomaž Municipality'
        },
        {
          code: '184',
          name: 'Tabor Municipality'
        },
        {
          code: '010',
          name: 'Tišina Municipality'
        },
        {
          code: '128',
          name: 'Tolmin Municipality'
        },
        {
          code: '129',
          name: 'Trbovlje Municipality'
        },
        {
          code: '130',
          name: 'Trebnje Municipality'
        },
        {
          code: '185',
          name: 'Trnovska Vas Municipality'
        },
        {
          code: '131',
          name: 'Tržič Municipality'
        },
        {
          code: '186',
          name: 'Trzin Municipality'
        },
        {
          code: '132',
          name: 'Turnišče Municipality'
        },
        {
          code: '187',
          name: 'Velika Polana Municipality'
        },
        {
          code: '134',
          name: 'Velike Lašče Municipality'
        },
        {
          code: '188',
          name: 'Veržej Municipality'
        },
        {
          code: '135',
          name: 'Videm Municipality'
        },
        {
          code: '136',
          name: 'Vipava Municipality'
        },
        {
          code: '137',
          name: 'Vitanje Municipality'
        },
        {
          code: '138',
          name: 'Vodice Municipality'
        },
        {
          code: '139',
          name: 'Vojnik Municipality'
        },
        {
          code: '189',
          name: 'Vransko Municipality'
        },
        {
          code: '140',
          name: 'Vrhnika Municipality'
        },
        {
          code: '141',
          name: 'Vuzenica Municipality'
        },
        {
          code: '142',
          name: 'Zagorje ob Savi Municipality'
        },
        {
          code: '190',
          name: 'Žalec Municipality'
        },
        {
          code: '143',
          name: 'Zavrč Municipality'
        },
        {
          code: '146',
          name: 'Železniki Municipality'
        },
        {
          code: '191',
          name: 'Žetale Municipality'
        },
        {
          code: '147',
          name: 'Žiri Municipality'
        },
        {
          code: '192',
          name: 'Žirovnica Municipality'
        },
        {
          code: '144',
          name: 'Zreče Municipality'
        },
        {
          code: '193',
          name: 'Žužemberk Municipality'
        }
      ]
    },
    {
      code: 'SB',
      name: 'Solomon Islands',
      states: [
        {
          code: 'CE',
          name: 'Central Province'
        },
        {
          code: 'CH',
          name: 'Choiseul Province'
        },
        {
          code: 'GU',
          name: 'Guadalcanal Province'
        },
        {
          code: 'CT',
          name: 'Honiara'
        },
        {
          code: 'IS',
          name: 'Isabel Province'
        },
        {
          code: 'MK',
          name: 'Makira-Ulawa Province'
        },
        {
          code: 'ML',
          name: 'Malaita Province'
        },
        {
          code: 'RB',
          name: 'Rennell and Bellona Province'
        },
        {
          code: 'TE',
          name: 'Temotu Province'
        },
        {
          code: 'WE',
          name: 'Western Province'
        }
      ]
    },
    {
      code: 'SO',
      name: 'Somalia',
      states: [
        {
          code: 'AW',
          name: 'Awdal Region'
        },
        {
          code: 'BK',
          name: 'Bakool'
        },
        {
          code: 'BN',
          name: 'Banaadir'
        },
        {
          code: 'BR',
          name: 'Bari'
        },
        {
          code: 'BY',
          name: 'Bay'
        },
        {
          code: 'GA',
          name: 'Galguduud'
        },
        {
          code: 'GE',
          name: 'Gedo'
        },
        {
          code: 'HI',
          name: 'Hiran'
        },
        {
          code: 'JH',
          name: 'Lower Juba'
        },
        {
          code: 'SH',
          name: 'Lower Shebelle'
        },
        {
          code: 'JD',
          name: 'Middle Juba'
        },
        {
          code: 'SD',
          name: 'Middle Shebelle'
        },
        {
          code: 'MU',
          name: 'Mudug'
        },
        {
          code: 'NU',
          name: 'Nugal'
        },
        {
          code: 'SA',
          name: 'Sanaag Region'
        },
        {
          code: 'TO',
          name: 'Togdheer Region'
        }
      ]
    },
    {
      code: 'ZA',
      name: 'South Africa',
      states: [
        {
          code: 'EC',
          name: 'Eastern Cape'
        },
        {
          code: 'FS',
          name: 'Free State'
        },
        {
          code: 'GP',
          name: 'Gauteng'
        },
        {
          code: 'KZN',
          name: 'KwaZulu-Natal'
        },
        {
          code: 'LP',
          name: 'Limpopo'
        },
        {
          code: 'MP',
          name: 'Mpumalanga'
        },
        {
          code: 'NW',
          name: 'North West'
        },
        {
          code: 'NC',
          name: 'Northern Cape'
        },
        {
          code: 'WC',
          name: 'Western Cape'
        }
      ]
    },
    {
      code: 'GS',
      name: 'South Georgia',
      states: []
    },
    {
      code: 'KR',
      name: 'South Korea',
      states: [
        {
          code: '26',
          name: 'Busan'
        },
        {
          code: '27',
          name: 'Daegu'
        },
        {
          code: '30',
          name: 'Daejeon'
        },
        {
          code: '42',
          name: 'Gangwon Province'
        },
        {
          code: '29',
          name: 'Gwangju'
        },
        {
          code: '41',
          name: 'Gyeonggi Province'
        },
        {
          code: '28',
          name: 'Incheon'
        },
        {
          code: '49',
          name: 'Jeju'
        },
        {
          code: '43',
          name: 'North Chungcheong Province'
        },
        {
          code: '47',
          name: 'North Gyeongsang Province'
        },
        {
          code: '45',
          name: 'North Jeolla Province'
        },
        {
          code: '50',
          name: 'Sejong City'
        },
        {
          code: '11',
          name: 'Seoul'
        },
        {
          code: '44',
          name: 'South Chungcheong Province'
        },
        {
          code: '48',
          name: 'South Gyeongsang Province'
        },
        {
          code: '46',
          name: 'South Jeolla Province'
        },
        {
          code: '31',
          name: 'Ulsan'
        }
      ]
    },
    {
      code: 'SS',
      name: 'South Sudan',
      states: [
        {
          code: 'EC',
          name: 'Central Equatoria'
        },
        {
          code: 'EE',
          name: 'Eastern Equatoria'
        },
        {
          code: 'JG',
          name: 'Jonglei State'
        },
        {
          code: 'LK',
          name: 'Lakes'
        },
        {
          code: 'BN',
          name: 'Northern Bahr el Ghazal'
        },
        {
          code: 'UY',
          name: 'Unity'
        },
        {
          code: 'NU',
          name: 'Upper Nile'
        },
        {
          code: 'WR',
          name: 'Warrap'
        },
        {
          code: 'BW',
          name: 'Western Bahr el Ghazal'
        },
        {
          code: 'EW',
          name: 'Western Equatoria'
        }
      ]
    },
    {
      code: 'ES',
      name: 'Spain',
      states: [
        {
          code: 'C',
          name: 'A Coruña'
        },
        {
          code: 'AB',
          name: 'Albacete'
        },
        {
          code: 'A',
          name: 'Alicante'
        },
        {
          code: 'AL',
          name: 'Almeria'
        },
        {
          code: 'VI',
          name: 'Araba'
        },
        {
          code: 'O',
          name: 'Asturias'
        },
        {
          code: 'AV',
          name: 'Ávila'
        },
        {
          code: 'BA',
          name: 'Badajoz'
        },
        {
          code: 'B',
          name: 'Barcelona'
        },
        {
          code: 'BI',
          name: 'Bizkaia'
        },
        {
          code: 'BU',
          name: 'Burgos'
        },
        {
          code: 'CC',
          name: 'Caceres'
        },
        {
          code: 'CA',
          name: 'Cádiz'
        },
        {
          code: 'CN',
          name: 'Canarias'
        },
        {
          code: 'S',
          name: 'Cantabria'
        },
        {
          code: 'CS',
          name: 'Castellón'
        },
        {
          code: 'CE',
          name: 'Ceuta'
        },
        {
          code: 'CR',
          name: 'Ciudad Real'
        },
        {
          code: 'CO',
          name: 'Córdoba'
        },
        {
          code: 'CU',
          name: 'Cuenca'
        },
        {
          code: 'SS',
          name: 'Gipuzkoa'
        },
        {
          code: 'GI',
          name: 'Girona'
        },
        {
          code: 'GR',
          name: 'Granada'
        },
        {
          code: 'GU',
          name: 'Guadalajara'
        },
        {
          code: 'H',
          name: 'Huelva'
        },
        {
          code: 'HU',
          name: 'Huesca'
        },
        {
          code: 'PM',
          name: 'Islas Baleares'
        },
        {
          code: 'J',
          name: 'Jaén'
        },
        {
          code: 'LO',
          name: 'La Rioja'
        },
        {
          code: 'GC',
          name: 'Las Palmas'
        },
        {
          code: 'LE',
          name: 'León'
        },
        {
          code: 'L',
          name: 'Lleida'
        },
        {
          code: 'LU',
          name: 'Lugo'
        },
        {
          code: 'M',
          name: 'Madrid'
        },
        {
          code: 'MA',
          name: 'Málaga'
        },
        {
          code: 'ML',
          name: 'Melilla'
        },
        {
          code: 'MU',
          name: 'Murcia'
        },
        {
          code: 'NA',
          name: 'Navarra'
        },
        {
          code: 'OR',
          name: 'Ourense'
        },
        {
          code: 'P',
          name: 'Palencia'
        },
        {
          code: 'PO',
          name: 'Pontevedra'
        },
        {
          code: 'SA',
          name: 'Salamanca'
        },
        {
          code: 'TF',
          name: 'Santa Cruz de Tenerife'
        },
        {
          code: 'SG',
          name: 'Segovia'
        },
        {
          code: 'SE',
          name: 'Sevilla'
        },
        {
          code: 'SO',
          name: 'Soria'
        },
        {
          code: 'T',
          name: 'Tarragona'
        },
        {
          code: 'TE',
          name: 'Teruel'
        },
        {
          code: 'TO',
          name: 'Toledo'
        },
        {
          code: 'V',
          name: 'Valencia'
        },
        {
          code: 'VA',
          name: 'Valladolid'
        },
        {
          code: 'ZA',
          name: 'Zamora'
        },
        {
          code: 'Z',
          name: 'Zaragoza'
        }
      ]
    },
    {
      code: 'LK',
      name: 'Sri Lanka',
      states: [
        {
          code: '52',
          name: 'Ampara District'
        },
        {
          code: '71',
          name: 'Anuradhapura District'
        },
        {
          code: '81',
          name: 'Badulla District'
        },
        {
          code: '51',
          name: 'Batticaloa District'
        },
        {
          code: '2',
          name: 'Central Province'
        },
        {
          code: '11',
          name: 'Colombo District'
        },
        {
          code: '5',
          name: 'Eastern Province'
        },
        {
          code: '31',
          name: 'Galle District'
        },
        {
          code: '12',
          name: 'Gampaha District'
        },
        {
          code: '33',
          name: 'Hambantota District'
        },
        {
          code: '41',
          name: 'Jaffna District'
        },
        {
          code: '13',
          name: 'Kalutara District'
        },
        {
          code: '21',
          name: 'Kandy District'
        },
        {
          code: '92',
          name: 'Kegalle District'
        },
        {
          code: '42',
          name: 'Kilinochchi District'
        },
        {
          code: '43',
          name: 'Mannar District'
        },
        {
          code: '22',
          name: 'Matale District'
        },
        {
          code: '32',
          name: 'Matara District'
        },
        {
          code: '82',
          name: 'Monaragala District'
        },
        {
          code: '45',
          name: 'Mullaitivu District'
        },
        {
          code: '7',
          name: 'North Central Province'
        },
        {
          code: '6',
          name: 'North Western Province'
        },
        {
          code: '4',
          name: 'Northern Province'
        },
        {
          code: '23',
          name: 'Nuwara Eliya District'
        },
        {
          code: '72',
          name: 'Polonnaruwa District'
        },
        {
          code: '62',
          name: 'Puttalam District'
        },
        {
          code: '91',
          name: 'Ratnapura district'
        },
        {
          code: '9',
          name: 'Sabaragamuwa Province'
        },
        {
          code: '3',
          name: 'Southern Province'
        },
        {
          code: '53',
          name: 'Trincomalee District'
        },
        {
          code: '8',
          name: 'Uva Province'
        },
        {
          code: '44',
          name: 'Vavuniya District'
        },
        {
          code: '1',
          name: 'Western Province'
        }
      ]
    },
    {
      code: 'SD',
      name: 'Sudan',
      states: [
        {
          code: 'GZ',
          name: 'Al Jazirah'
        },
        {
          code: 'GD',
          name: 'Al Qadarif'
        },
        {
          code: 'NB',
          name: 'Blue Nile'
        },
        {
          code: 'DC',
          name: 'Central Darfur'
        },
        {
          code: 'DE',
          name: 'East Darfur'
        },
        {
          code: 'KA',
          name: 'Kassala'
        },
        {
          code: 'KH',
          name: 'Khartoum'
        },
        {
          code: 'DN',
          name: 'North Darfur'
        },
        {
          code: 'KN',
          name: 'North Kordofan'
        },
        {
          code: 'NO',
          name: 'Northern'
        },
        {
          code: 'RS',
          name: 'Red Sea'
        },
        {
          code: 'NR',
          name: 'River Nile'
        },
        {
          code: 'SI',
          name: 'Sennar'
        },
        {
          code: 'DS',
          name: 'South Darfur'
        },
        {
          code: 'KS',
          name: 'South Kordofan'
        },
        {
          code: 'DW',
          name: 'West Darfur'
        },
        {
          code: 'GK',
          name: 'West Kordofan'
        },
        {
          code: 'NW',
          name: 'White Nile'
        }
      ]
    },
    {
      code: 'SR',
      name: 'Suriname',
      states: [
        {
          code: 'BR',
          name: 'Brokopondo District'
        },
        {
          code: 'CM',
          name: 'Commewijne District'
        },
        {
          code: 'CR',
          name: 'Coronie District'
        },
        {
          code: 'MA',
          name: 'Marowijne District'
        },
        {
          code: 'NI',
          name: 'Nickerie District'
        },
        {
          code: 'PR',
          name: 'Para District'
        },
        {
          code: 'PM',
          name: 'Paramaribo District'
        },
        {
          code: 'SA',
          name: 'Saramacca District'
        },
        {
          code: 'SI',
          name: 'Sipaliwini District'
        },
        {
          code: 'WA',
          name: 'Wanica District'
        }
      ]
    },
    {
      code: 'SJ',
      name: 'Svalbard and Jan Mayen Islands',
      states: []
    },
    {
      code: 'SE',
      name: 'Sweden',
      states: [
        {
          code: 'K',
          name: 'Blekinge County'
        },
        {
          code: 'W',
          name: 'Dalarna County'
        },
        {
          code: 'X',
          name: 'Gävleborg County'
        },
        {
          code: 'I',
          name: 'Gotland County'
        },
        {
          code: 'N',
          name: 'Halland County'
        },
        {
          code: '0',
          name: 'Jämtland County'
        },
        {
          code: 'F',
          name: 'Jönköping County'
        },
        {
          code: 'H',
          name: 'Kalmar County'
        },
        {
          code: 'G',
          name: 'Kronoberg County'
        },
        {
          code: 'BD',
          name: 'Norrbotten County'
        },
        {
          code: 'T',
          name: 'Örebro County'
        },
        {
          code: 'E',
          name: 'Östergötland County'
        },
        {
          code: 'M',
          name: 'Skåne County'
        },
        {
          code: 'D',
          name: 'Södermanland County'
        },
        {
          code: 'AB',
          name: 'Stockholm County'
        },
        {
          code: 'C',
          name: 'Uppsala County'
        },
        {
          code: 'S',
          name: 'Värmland County'
        },
        {
          code: 'AC',
          name: 'Västerbotten County'
        },
        {
          code: 'Y',
          name: 'Västernorrland County'
        },
        {
          code: 'U',
          name: 'Västmanland County'
        },
        {
          code: 'O',
          name: 'Västra Götaland County'
        }
      ]
    },
    {
      code: 'CH',
      name: 'Switzerland',
      states: [
        {
          code: 'AG',
          name: 'Aargau'
        },
        {
          code: 'AR',
          name: 'Appenzell Ausserrhoden'
        },
        {
          code: 'AI',
          name: 'Appenzell Innerrhoden'
        },
        {
          code: 'BL',
          name: 'Basel-Land'
        },
        {
          code: 'BS',
          name: 'Basel-Stadt'
        },
        {
          code: 'BE',
          name: 'Bern'
        },
        {
          code: 'FR',
          name: 'Fribourg'
        },
        {
          code: 'GE',
          name: 'Geneva'
        },
        {
          code: 'GL',
          name: 'Glarus'
        },
        {
          code: 'GR',
          name: 'Graubünden'
        },
        {
          code: 'JU',
          name: 'Jura'
        },
        {
          code: 'LU',
          name: 'Lucerne'
        },
        {
          code: 'NE',
          name: 'Neuchâtel'
        },
        {
          code: 'NW',
          name: 'Nidwalden'
        },
        {
          code: 'OW',
          name: 'Obwalden'
        },
        {
          code: 'SH',
          name: 'Schaffhausen'
        },
        {
          code: 'SZ',
          name: 'Schwyz'
        },
        {
          code: 'SO',
          name: 'Solothurn'
        },
        {
          code: 'SG',
          name: 'St. Gallen'
        },
        {
          code: 'TG',
          name: 'Thurgau'
        },
        {
          code: 'TI',
          name: 'Ticino'
        },
        {
          code: 'UR',
          name: 'Uri'
        },
        {
          code: 'VS',
          name: 'Valais'
        },
        {
          code: 'VD',
          name: 'Vaud'
        },
        {
          code: 'ZG',
          name: 'Zug'
        },
        {
          code: 'ZH',
          name: 'Zürich'
        }
      ]
    },
    {
      code: 'SY',
      name: 'Syria',
      states: [
        {
          code: 'HA',
          name: 'Al-Hasakah'
        },
        {
          code: 'RA',
          name: 'Al-Raqqah'
        },
        {
          code: 'HL',
          name: 'Aleppo'
        },
        {
          code: 'SU',
          name: 'As-Suwayda'
        },
        {
          code: 'DI',
          name: 'Damascus'
        },
        {
          code: 'DR',
          name: 'Daraa'
        },
        {
          code: 'DY',
          name: 'Deir ez-Zor'
        },
        {
          code: 'HM',
          name: 'Hama'
        },
        {
          code: 'HI',
          name: 'Homs'
        },
        {
          code: 'ID',
          name: 'Idlib'
        },
        {
          code: 'LA',
          name: 'Latakia'
        },
        {
          code: 'QU',
          name: 'Quneitra'
        },
        {
          code: 'RD',
          name: 'Rif Dimashq'
        },
        {
          code: 'TA',
          name: 'Tartus'
        }
      ]
    },
    {
      code: 'TW',
      name: 'Taiwan',
      states: [
        {
          code: 'CHA',
          name: 'Changhua'
        },
        {
          code: 'CYI',
          name: 'Chiayi'
        },
        {
          code: 'CYQ',
          name: 'Chiayi'
        },
        {
          code: 'HSQ',
          name: 'Hsinchu'
        },
        {
          code: 'HSZ',
          name: 'Hsinchu'
        },
        {
          code: 'HUA',
          name: 'Hualien'
        },
        {
          code: 'KHH',
          name: 'Kaohsiung'
        },
        {
          code: 'KEE',
          name: 'Keelung'
        },
        {
          code: 'KIN',
          name: 'Kinmen'
        },
        {
          code: 'LIE',
          name: 'Lienchiang'
        },
        {
          code: 'MIA',
          name: 'Miaoli'
        },
        {
          code: 'NAN',
          name: 'Nantou'
        },
        {
          code: 'NWT',
          name: 'New Taipei'
        },
        {
          code: 'PEN',
          name: 'Penghu'
        },
        {
          code: 'PIF',
          name: 'Pingtung'
        },
        {
          code: 'TXG',
          name: 'Taichung'
        },
        {
          code: 'TNN',
          name: 'Tainan'
        },
        {
          code: 'TPE',
          name: 'Taipei'
        },
        {
          code: 'TTT',
          name: 'Taitung'
        },
        {
          code: 'TAO',
          name: 'Taoyuan'
        },
        {
          code: 'ILA',
          name: 'Yilan'
        },
        {
          code: 'YUN',
          name: 'Yunlin'
        }
      ]
    },
    {
      code: 'TJ',
      name: 'Tajikistan',
      states: [
        {
          code: 'RA',
          name: 'districts of Republican Subordination'
        },
        {
          code: 'GB',
          name: 'Gorno-Badakhshan Autonomous Province'
        },
        {
          code: 'KT',
          name: 'Khatlon Province'
        },
        {
          code: 'SU',
          name: 'Sughd Province'
        }
      ]
    },
    {
      code: 'TZ',
      name: 'Tanzania',
      states: [
        {
          code: '01',
          name: 'Arusha'
        },
        {
          code: '02',
          name: 'Dar es Salaam'
        },
        {
          code: '03',
          name: 'Dodoma'
        },
        {
          code: '27',
          name: 'Geita'
        },
        {
          code: '04',
          name: 'Iringa'
        },
        {
          code: '05',
          name: 'Kagera'
        },
        {
          code: '28',
          name: 'Katavi'
        },
        {
          code: '08',
          name: 'Kigoma'
        },
        {
          code: '09',
          name: 'Kilimanjaro'
        },
        {
          code: '12',
          name: 'Lindi'
        },
        {
          code: '26',
          name: 'Manyara'
        },
        {
          code: '13',
          name: 'Mara'
        },
        {
          code: '14',
          name: 'Mbeya'
        },
        {
          code: '16',
          name: 'Morogoro'
        },
        {
          code: '17',
          name: 'Mtwara'
        },
        {
          code: '18',
          name: 'Mwanza'
        },
        {
          code: '29',
          name: 'Njombe'
        },
        {
          code: '06',
          name: 'Pemba North'
        },
        {
          code: '10',
          name: 'Pemba South'
        },
        {
          code: '19',
          name: 'Pwani'
        },
        {
          code: '20',
          name: 'Rukwa'
        },
        {
          code: '21',
          name: 'Ruvuma'
        },
        {
          code: '22',
          name: 'Shinyanga'
        },
        {
          code: '30',
          name: 'Simiyu'
        },
        {
          code: '23',
          name: 'Singida'
        },
        {
          code: '31',
          name: 'Songwe'
        },
        {
          code: '24',
          name: 'Tabora'
        },
        {
          code: '25',
          name: 'Tanga'
        },
        {
          code: '07',
          name: 'Zanzibar North'
        },
        {
          code: '11',
          name: 'Zanzibar South'
        },
        {
          code: '15',
          name: 'Zanzibar West'
        }
      ]
    },
    {
      code: 'TH',
      name: 'Thailand',
      states: [
        {
          code: '37',
          name: 'Amnat Charoen'
        },
        {
          code: '15',
          name: 'Ang Thong'
        },
        {
          code: '10',
          name: 'Bangkok'
        },
        {
          code: '38',
          name: 'Bueng Kan'
        },
        {
          code: '31',
          name: 'Buri Ram'
        },
        {
          code: '24',
          name: 'Chachoengsao'
        },
        {
          code: '18',
          name: 'Chai Nat'
        },
        {
          code: '36',
          name: 'Chaiyaphum'
        },
        {
          code: '22',
          name: 'Chanthaburi'
        },
        {
          code: '50',
          name: 'Chiang Mai'
        },
        {
          code: '57',
          name: 'Chiang Rai'
        },
        {
          code: '20',
          name: 'Chon Buri'
        },
        {
          code: '86',
          name: 'Chumphon'
        },
        {
          code: '46',
          name: 'Kalasin'
        },
        {
          code: '62',
          name: 'Kamphaeng Phet'
        },
        {
          code: '71',
          name: 'Kanchanaburi'
        },
        {
          code: '40',
          name: 'Khon Kaen'
        },
        {
          code: '81',
          name: 'Krabi'
        },
        {
          code: '52',
          name: 'Lampang'
        },
        {
          code: '51',
          name: 'Lamphun'
        },
        {
          code: '42',
          name: 'Loei'
        },
        {
          code: '16',
          name: 'Lop Buri'
        },
        {
          code: '58',
          name: 'Mae Hong Son'
        },
        {
          code: '44',
          name: 'Maha Sarakham'
        },
        {
          code: '49',
          name: 'Mukdahan'
        },
        {
          code: '26',
          name: 'Nakhon Nayok'
        },
        {
          code: '73',
          name: 'Nakhon Pathom'
        },
        {
          code: '48',
          name: 'Nakhon Phanom'
        },
        {
          code: '30',
          name: 'Nakhon Ratchasima'
        },
        {
          code: '60',
          name: 'Nakhon Sawan'
        },
        {
          code: '80',
          name: 'Nakhon Si Thammarat'
        },
        {
          code: '55',
          name: 'Nan'
        },
        {
          code: '96',
          name: 'Narathiwat'
        },
        {
          code: '39',
          name: 'Nong Bua Lam Phu'
        },
        {
          code: '43',
          name: 'Nong Khai'
        },
        {
          code: '12',
          name: 'Nonthaburi'
        },
        {
          code: '13',
          name: 'Pathum Thani'
        },
        {
          code: '94',
          name: 'Pattani'
        },
        {
          code: 'S',
          name: 'Pattaya'
        },
        {
          code: '82',
          name: 'Phangnga'
        },
        {
          code: '93',
          name: 'Phatthalung'
        },
        {
          code: '56',
          name: 'Phayao'
        },
        {
          code: '67',
          name: 'Phetchabun'
        },
        {
          code: '76',
          name: 'Phetchaburi'
        },
        {
          code: '66',
          name: 'Phichit'
        },
        {
          code: '65',
          name: 'Phitsanulok'
        },
        {
          code: '14',
          name: 'Phra Nakhon Si Ayutthaya'
        },
        {
          code: '54',
          name: 'Phrae'
        },
        {
          code: '83',
          name: 'Phuket'
        },
        {
          code: '25',
          name: 'Prachin Buri'
        },
        {
          code: '77',
          name: 'Prachuap Khiri Khan'
        },
        {
          code: '85',
          name: 'Ranong'
        },
        {
          code: '70',
          name: 'Ratchaburi'
        },
        {
          code: '21',
          name: 'Rayong'
        },
        {
          code: '45',
          name: 'Roi Et'
        },
        {
          code: '27',
          name: 'Sa Kaeo'
        },
        {
          code: '47',
          name: 'Sakon Nakhon'
        },
        {
          code: '11',
          name: 'Samut Prakan'
        },
        {
          code: '74',
          name: 'Samut Sakhon'
        },
        {
          code: '75',
          name: 'Samut Songkhram'
        },
        {
          code: '19',
          name: 'Saraburi'
        },
        {
          code: '91',
          name: 'Satun'
        },
        {
          code: '33',
          name: 'Si Sa Ket'
        },
        {
          code: '17',
          name: 'Sing Buri'
        },
        {
          code: '90',
          name: 'Songkhla'
        },
        {
          code: '64',
          name: 'Sukhothai'
        },
        {
          code: '72',
          name: 'Suphan Buri'
        },
        {
          code: '84',
          name: 'Surat Thani'
        },
        {
          code: '32',
          name: 'Surin'
        },
        {
          code: '63',
          name: 'Tak'
        },
        {
          code: '92',
          name: 'Trang'
        },
        {
          code: '23',
          name: 'Trat'
        },
        {
          code: '34',
          name: 'Ubon Ratchathani'
        },
        {
          code: '41',
          name: 'Udon Thani'
        },
        {
          code: '61',
          name: 'Uthai Thani'
        },
        {
          code: '53',
          name: 'Uttaradit'
        },
        {
          code: '95',
          name: 'Yala'
        },
        {
          code: '35',
          name: 'Yasothon'
        }
      ]
    },
    {
      code: 'BS',
      name: 'The Bahamas',
      states: [
        {
          code: 'AK',
          name: 'Acklins'
        },
        {
          code: 'AC',
          name: 'Acklins and Crooked Islands'
        },
        {
          code: 'BY',
          name: 'Berry Islands'
        },
        {
          code: 'BI',
          name: 'Bimini'
        },
        {
          code: 'BP',
          name: 'Black Point'
        },
        {
          code: 'CI',
          name: 'Cat Island'
        },
        {
          code: 'CO',
          name: 'Central Abaco'
        },
        {
          code: 'CS',
          name: 'Central Andros'
        },
        {
          code: 'CE',
          name: 'Central Eleuthera'
        },
        {
          code: 'CK',
          name: 'Crooked Island'
        },
        {
          code: 'EG',
          name: 'East Grand Bahama'
        },
        {
          code: 'EX',
          name: 'Exuma'
        },
        {
          code: 'FP',
          name: 'Freeport'
        },
        {
          code: 'FC',
          name: 'Fresh Creek'
        },
        {
          code: 'GH',
          name: "Governor's Harbour"
        },
        {
          code: 'GC',
          name: 'Grand Cay'
        },
        {
          code: 'GT',
          name: 'Green Turtle Cay'
        },
        {
          code: 'HI',
          name: 'Harbour Island'
        },
        {
          code: 'HR',
          name: 'High Rock'
        },
        {
          code: 'HT',
          name: 'Hope Town'
        },
        {
          code: 'IN',
          name: 'Inagua'
        },
        {
          code: 'KB',
          name: 'Kemps Bay'
        },
        {
          code: 'LI',
          name: 'Long Island'
        },
        {
          code: 'MC',
          name: 'Mangrove Cay'
        },
        {
          code: 'MH',
          name: 'Marsh Harbour'
        },
        {
          code: 'MG',
          name: 'Mayaguana District'
        },
        {
          code: 'NP',
          name: 'New Providence'
        },
        {
          code: 'NB',
          name: 'Nichollstown and Berry Islands'
        },
        {
          code: 'NO',
          name: 'North Abaco'
        },
        {
          code: 'NS',
          name: 'North Andros'
        },
        {
          code: 'NE',
          name: 'North Eleuthera'
        },
        {
          code: 'RI',
          name: 'Ragged Island'
        },
        {
          code: 'RS',
          name: 'Rock Sound'
        },
        {
          code: 'RC',
          name: 'Rum Cay District'
        },
        {
          code: 'SR',
          name: 'San Salvador and Rum Cay'
        },
        {
          code: 'SS',
          name: 'San Salvador Island'
        },
        {
          code: 'SP',
          name: 'Sandy Point'
        },
        {
          code: 'SO',
          name: 'South Abaco'
        },
        {
          code: 'SA',
          name: 'South Andros'
        },
        {
          code: 'SE',
          name: 'South Eleuthera'
        },
        {
          code: 'SW',
          name: 'Spanish Wells'
        },
        {
          code: 'WG',
          name: 'West Grand Bahama'
        }
      ]
    },
    {
      code: 'TL',
      name: 'Timor-Leste',
      states: [
        {
          code: 'AL',
          name: 'Aileu municipality'
        },
        {
          code: 'AN',
          name: 'Ainaro Municipality'
        },
        {
          code: 'BA',
          name: 'Baucau Municipality'
        },
        {
          code: 'BO',
          name: 'Bobonaro Municipality'
        },
        {
          code: 'CO',
          name: 'Cova Lima Municipality'
        },
        {
          code: 'DI',
          name: 'Dili municipality'
        },
        {
          code: 'ER',
          name: 'Ermera District'
        },
        {
          code: 'LA',
          name: 'Lautém Municipality'
        },
        {
          code: 'LI',
          name: 'Liquiçá Municipality'
        },
        {
          code: 'MT',
          name: 'Manatuto District'
        },
        {
          code: 'MF',
          name: 'Manufahi Municipality'
        },
        {
          code: 'VI',
          name: 'Viqueque Municipality'
        }
      ]
    },
    {
      code: 'TG',
      name: 'Togo',
      states: [
        {
          code: 'C',
          name: 'Centrale Region'
        },
        {
          code: 'K',
          name: 'Kara Region'
        },
        {
          code: 'M',
          name: 'Maritime'
        },
        {
          code: 'P',
          name: 'Plateaux Region'
        },
        {
          code: 'S',
          name: 'Savanes Region'
        }
      ]
    },
    {
      code: 'TK',
      name: 'Tokelau',
      states: []
    },
    {
      code: 'TO',
      name: 'Tonga',
      states: [
        {
          code: '02',
          name: 'Haʻapai'
        },
        {
          code: '01',
          name: 'ʻEua'
        },
        {
          code: '03',
          name: 'Niuas'
        },
        {
          code: '04',
          name: 'Tongatapu'
        },
        {
          code: '05',
          name: 'Vavaʻu'
        }
      ]
    },
    {
      code: 'TT',
      name: 'Trinidad and Tobago',
      states: [
        {
          code: 'ARI',
          name: 'Arima'
        },
        {
          code: 'CHA',
          name: 'Chaguanas'
        },
        {
          code: 'CTT',
          name: 'Couva-Tabaquite-Talparo Regional Corporation'
        },
        {
          code: 'DMN',
          name: 'Diego Martin Regional Corporation'
        },
        {
          code: 'ETO',
          name: 'Eastern Tobago'
        },
        {
          code: 'PED',
          name: 'Penal-Debe Regional Corporation'
        },
        {
          code: 'PTF',
          name: 'Point Fortin'
        },
        {
          code: 'POS',
          name: 'Port of Spain'
        },
        {
          code: 'PRT',
          name: 'Princes Town Regional Corporation'
        },
        {
          code: 'MRC',
          name: 'Rio Claro-Mayaro Regional Corporation'
        },
        {
          code: 'SFO',
          name: 'San Fernando'
        },
        {
          code: 'SJL',
          name: 'San Juan-Laventille Regional Corporation'
        },
        {
          code: 'SGE',
          name: 'Sangre Grande Regional Corporation'
        },
        {
          code: 'SIP',
          name: 'Siparia Regional Corporation'
        },
        {
          code: 'TUP',
          name: 'Tunapuna-Piarco Regional Corporation'
        },
        {
          code: 'WTO',
          name: 'Western Tobago'
        }
      ]
    },
    {
      code: 'TN',
      name: 'Tunisia',
      states: [
        {
          code: '12',
          name: 'Ariana'
        },
        {
          code: '31',
          name: 'Béja'
        },
        {
          code: '13',
          name: 'Ben Arous'
        },
        {
          code: '23',
          name: 'Bizerte'
        },
        {
          code: '81',
          name: 'Gabès'
        },
        {
          code: '71',
          name: 'Gafsa'
        },
        {
          code: '32',
          name: 'Jendouba'
        },
        {
          code: '41',
          name: 'Kairouan'
        },
        {
          code: '42',
          name: 'Kasserine'
        },
        {
          code: '73',
          name: 'Kebili'
        },
        {
          code: '33',
          name: 'Kef'
        },
        {
          code: '53',
          name: 'Mahdia'
        },
        {
          code: '14',
          name: 'Manouba'
        },
        {
          code: '82',
          name: 'Medenine'
        },
        {
          code: '52',
          name: 'Monastir'
        },
        {
          code: '21',
          name: 'Nabeul'
        },
        {
          code: '61',
          name: 'Sfax'
        },
        {
          code: '43',
          name: 'Sidi Bouzid'
        },
        {
          code: '34',
          name: 'Siliana'
        },
        {
          code: '51',
          name: 'Sousse'
        },
        {
          code: '83',
          name: 'Tataouine'
        },
        {
          code: '72',
          name: 'Tozeur'
        },
        {
          code: '11',
          name: 'Tunis'
        },
        {
          code: '22',
          name: 'Zaghouan'
        }
      ]
    },
    {
      code: 'TR',
      name: 'Turkey',
      states: [
        {
          code: '01',
          name: 'Adana'
        },
        {
          code: '02',
          name: 'Adıyaman'
        },
        {
          code: '03',
          name: 'Afyonkarahisar'
        },
        {
          code: '04',
          name: 'Ağrı'
        },
        {
          code: '68',
          name: 'Aksaray'
        },
        {
          code: '05',
          name: 'Amasya'
        },
        {
          code: '06',
          name: 'Ankara'
        },
        {
          code: '07',
          name: 'Antalya'
        },
        {
          code: '75',
          name: 'Ardahan'
        },
        {
          code: '08',
          name: 'Artvin'
        },
        {
          code: '09',
          name: 'Aydın'
        },
        {
          code: '10',
          name: 'Balıkesir'
        },
        {
          code: '74',
          name: 'Bartın'
        },
        {
          code: '72',
          name: 'Batman'
        },
        {
          code: '69',
          name: 'Bayburt'
        },
        {
          code: '11',
          name: 'Bilecik'
        },
        {
          code: '12',
          name: 'Bingöl'
        },
        {
          code: '13',
          name: 'Bitlis'
        },
        {
          code: '14',
          name: 'Bolu'
        },
        {
          code: '15',
          name: 'Burdur'
        },
        {
          code: '16',
          name: 'Bursa'
        },
        {
          code: '17',
          name: 'Çanakkale'
        },
        {
          code: '18',
          name: 'Çankırı'
        },
        {
          code: '19',
          name: 'Çorum'
        },
        {
          code: '20',
          name: 'Denizli'
        },
        {
          code: '21',
          name: 'Diyarbakır'
        },
        {
          code: '81',
          name: 'Düzce'
        },
        {
          code: '22',
          name: 'Edirne'
        },
        {
          code: '23',
          name: 'Elazığ'
        },
        {
          code: '24',
          name: 'Erzincan'
        },
        {
          code: '25',
          name: 'Erzurum'
        },
        {
          code: '26',
          name: 'Eskişehir'
        },
        {
          code: '27',
          name: 'Gaziantep'
        },
        {
          code: '28',
          name: 'Giresun'
        },
        {
          code: '29',
          name: 'Gümüşhane'
        },
        {
          code: '30',
          name: 'Hakkâri'
        },
        {
          code: '31',
          name: 'Hatay'
        },
        {
          code: '76',
          name: 'Iğdır'
        },
        {
          code: '32',
          name: 'Isparta'
        },
        {
          code: '34',
          name: 'İstanbul'
        },
        {
          code: '35',
          name: 'İzmir'
        },
        {
          code: '46',
          name: 'Kahramanmaraş'
        },
        {
          code: '78',
          name: 'Karabük'
        },
        {
          code: '70',
          name: 'Karaman'
        },
        {
          code: '36',
          name: 'Kars'
        },
        {
          code: '37',
          name: 'Kastamonu'
        },
        {
          code: '38',
          name: 'Kayseri'
        },
        {
          code: '79',
          name: 'Kilis'
        },
        {
          code: '71',
          name: 'Kırıkkale'
        },
        {
          code: '39',
          name: 'Kırklareli'
        },
        {
          code: '40',
          name: 'Kırşehir'
        },
        {
          code: '41',
          name: 'Kocaeli'
        },
        {
          code: '42',
          name: 'Konya'
        },
        {
          code: '43',
          name: 'Kütahya'
        },
        {
          code: '44',
          name: 'Malatya'
        },
        {
          code: '45',
          name: 'Manisa'
        },
        {
          code: '47',
          name: 'Mardin'
        },
        {
          code: '33',
          name: 'Mersin'
        },
        {
          code: '48',
          name: 'Muğla'
        },
        {
          code: '49',
          name: 'Muş'
        },
        {
          code: '50',
          name: 'Nevşehir'
        },
        {
          code: '51',
          name: 'Niğde'
        },
        {
          code: '52',
          name: 'Ordu'
        },
        {
          code: '80',
          name: 'Osmaniye'
        },
        {
          code: '53',
          name: 'Rize'
        },
        {
          code: '54',
          name: 'Sakarya'
        },
        {
          code: '55',
          name: 'Samsun'
        },
        {
          code: '63',
          name: 'Şanlıurfa'
        },
        {
          code: '56',
          name: 'Siirt'
        },
        {
          code: '57',
          name: 'Sinop'
        },
        {
          code: '58',
          name: 'Sivas'
        },
        {
          code: '73',
          name: 'Şırnak'
        },
        {
          code: '59',
          name: 'Tekirdağ'
        },
        {
          code: '60',
          name: 'Tokat'
        },
        {
          code: '61',
          name: 'Trabzon'
        },
        {
          code: '62',
          name: 'Tunceli'
        },
        {
          code: '64',
          name: 'Uşak'
        },
        {
          code: '65',
          name: 'Van'
        },
        {
          code: '77',
          name: 'Yalova'
        },
        {
          code: '66',
          name: 'Yozgat'
        },
        {
          code: '67',
          name: 'Zonguldak'
        }
      ]
    },
    {
      code: 'TM',
      name: 'Turkmenistan',
      states: [
        {
          code: 'A',
          name: 'Ahal Region'
        },
        {
          code: 'S',
          name: 'Ashgabat'
        },
        {
          code: 'B',
          name: 'Balkan Region'
        },
        {
          code: 'D',
          name: 'Daşoguz Region'
        },
        {
          code: 'L',
          name: 'Lebap Region'
        },
        {
          code: 'M',
          name: 'Mary Region'
        }
      ]
    },
    {
      code: 'TC',
      name: 'Turks and Caicos Islands',
      states: []
    },
    {
      code: 'TV',
      name: 'Tuvalu',
      states: [
        {
          code: 'FUN',
          name: 'Funafuti'
        },
        {
          code: 'NMG',
          name: 'Nanumanga'
        },
        {
          code: 'NMA',
          name: 'Nanumea'
        },
        {
          code: 'NIT',
          name: 'Niutao Island Council'
        },
        {
          code: 'NUI',
          name: 'Nui'
        },
        {
          code: 'NKF',
          name: 'Nukufetau'
        },
        {
          code: 'NKL',
          name: 'Nukulaelae'
        },
        {
          code: 'VAI',
          name: 'Vaitupu'
        }
      ]
    },
    {
      code: 'UG',
      name: 'Uganda',
      states: [
        {
          code: '314',
          name: 'Abim District'
        },
        {
          code: '301',
          name: 'Adjumani District'
        },
        {
          code: '322',
          name: 'Agago District'
        },
        {
          code: '323',
          name: 'Alebtong District'
        },
        {
          code: '315',
          name: 'Amolatar District'
        },
        {
          code: '324',
          name: 'Amudat District'
        },
        {
          code: '216',
          name: 'Amuria District'
        },
        {
          code: '316',
          name: 'Amuru District'
        },
        {
          code: '302',
          name: 'Apac District'
        },
        {
          code: '303',
          name: 'Arua District'
        },
        {
          code: '217',
          name: 'Budaka District'
        },
        {
          code: '218',
          name: 'Bududa District'
        },
        {
          code: '201',
          name: 'Bugiri District'
        },
        {
          code: '420',
          name: 'Buhweju District'
        },
        {
          code: '117',
          name: 'Buikwe District'
        },
        {
          code: '219',
          name: 'Bukedea District'
        },
        {
          code: '118',
          name: 'Bukomansimbi District'
        },
        {
          code: '220',
          name: 'Bukwo District'
        },
        {
          code: '225',
          name: 'Bulambuli District'
        },
        {
          code: '416',
          name: 'Buliisa District'
        },
        {
          code: '401',
          name: 'Bundibugyo District'
        },
        {
          code: '430',
          name: 'Bunyangabu District'
        },
        {
          code: '402',
          name: 'Bushenyi District'
        },
        {
          code: '202',
          name: 'Busia District'
        },
        {
          code: '221',
          name: 'Butaleja District'
        },
        {
          code: '119',
          name: 'Butambala District'
        },
        {
          code: '233',
          name: 'Butebo District'
        },
        {
          code: '120',
          name: 'Buvuma District'
        },
        {
          code: '226',
          name: 'Buyende District'
        },
        {
          code: 'C',
          name: 'Central Region'
        },
        {
          code: '317',
          name: 'Dokolo District'
        },
        {
          code: 'E',
          name: 'Eastern Region'
        },
        {
          code: '121',
          name: 'Gomba District'
        },
        {
          code: '304',
          name: 'Gulu District'
        },
        {
          code: '417',
          name: 'Ibanda District'
        },
        {
          code: '203',
          name: 'Iganga District'
        },
        {
          code: '418',
          name: 'Isingiro District'
        },
        {
          code: '204',
          name: 'Jinja District'
        },
        {
          code: '318',
          name: 'Kaabong District'
        },
        {
          code: '404',
          name: 'Kabale District'
        },
        {
          code: '405',
          name: 'Kabarole District'
        },
        {
          code: '213',
          name: 'Kaberamaido District'
        },
        {
          code: '427',
          name: 'Kagadi District'
        },
        {
          code: '428',
          name: 'Kakumiro District'
        },
        {
          code: '101',
          name: 'Kalangala District'
        },
        {
          code: '222',
          name: 'Kaliro District'
        },
        {
          code: '122',
          name: 'Kalungu District'
        },
        {
          code: '102',
          name: 'Kampala District'
        },
        {
          code: '205',
          name: 'Kamuli District'
        },
        {
          code: '413',
          name: 'Kamwenge District'
        },
        {
          code: '414',
          name: 'Kanungu District'
        },
        {
          code: '206',
          name: 'Kapchorwa District'
        },
        {
          code: '406',
          name: 'Kasese District'
        },
        {
          code: '207',
          name: 'Katakwi District'
        },
        {
          code: '112',
          name: 'Kayunga District'
        },
        {
          code: '407',
          name: 'Kibaale District'
        },
        {
          code: '103',
          name: 'Kiboga District'
        },
        {
          code: '227',
          name: 'Kibuku District'
        },
        {
          code: '419',
          name: 'Kiruhura District'
        },
        {
          code: '421',
          name: 'Kiryandongo District'
        },
        {
          code: '408',
          name: 'Kisoro District'
        },
        {
          code: '305',
          name: 'Kitgum District'
        },
        {
          code: '319',
          name: 'Koboko District'
        },
        {
          code: '325',
          name: 'Kole District'
        },
        {
          code: '306',
          name: 'Kotido District'
        },
        {
          code: '208',
          name: 'Kumi District'
        },
        {
          code: '228',
          name: 'Kween District'
        },
        {
          code: '123',
          name: 'Kyankwanzi District'
        },
        {
          code: '422',
          name: 'Kyegegwa District'
        },
        {
          code: '415',
          name: 'Kyenjojo District'
        },
        {
          code: '125',
          name: 'Kyotera District'
        },
        {
          code: '326',
          name: 'Lamwo District'
        },
        {
          code: '307',
          name: 'Lira District'
        },
        {
          code: '229',
          name: 'Luuka District'
        },
        {
          code: '104',
          name: 'Luwero District'
        },
        {
          code: '124',
          name: 'Lwengo District'
        },
        {
          code: '114',
          name: 'Lyantonde District'
        },
        {
          code: '223',
          name: 'Manafwa District'
        },
        {
          code: '320',
          name: 'Maracha District'
        },
        {
          code: '105',
          name: 'Masaka District'
        },
        {
          code: '409',
          name: 'Masindi District'
        },
        {
          code: '214',
          name: 'Mayuge District'
        },
        {
          code: '209',
          name: 'Mbale District'
        },
        {
          code: '410',
          name: 'Mbarara District'
        },
        {
          code: '423',
          name: 'Mitooma District'
        },
        {
          code: '115',
          name: 'Mityana District'
        },
        {
          code: '308',
          name: 'Moroto District'
        },
        {
          code: '309',
          name: 'Moyo District'
        },
        {
          code: '106',
          name: 'Mpigi District'
        },
        {
          code: '107',
          name: 'Mubende District'
        },
        {
          code: '108',
          name: 'Mukono District'
        },
        {
          code: '311',
          name: 'Nakapiripirit District'
        },
        {
          code: '116',
          name: 'Nakaseke District'
        },
        {
          code: '109',
          name: 'Nakasongola District'
        },
        {
          code: '230',
          name: 'Namayingo District'
        },
        {
          code: '234',
          name: 'Namisindwa District'
        },
        {
          code: '224',
          name: 'Namutumba District'
        },
        {
          code: '327',
          name: 'Napak District'
        },
        {
          code: '310',
          name: 'Nebbi District'
        },
        {
          code: '231',
          name: 'Ngora District'
        },
        {
          code: 'N',
          name: 'Northern Region'
        },
        {
          code: '424',
          name: 'Ntoroko District'
        },
        {
          code: '411',
          name: 'Ntungamo District'
        },
        {
          code: '328',
          name: 'Nwoya District'
        },
        {
          code: '331',
          name: 'Omoro District'
        },
        {
          code: '329',
          name: 'Otuke District'
        },
        {
          code: '321',
          name: 'Oyam District'
        },
        {
          code: '312',
          name: 'Pader District'
        },
        {
          code: '332',
          name: 'Pakwach District'
        },
        {
          code: '210',
          name: 'Pallisa District'
        },
        {
          code: '110',
          name: 'Rakai District'
        },
        {
          code: '429',
          name: 'Rubanda District'
        },
        {
          code: '425',
          name: 'Rubirizi District'
        },
        {
          code: '431',
          name: 'Rukiga District'
        },
        {
          code: '412',
          name: 'Rukungiri District'
        },
        {
          code: '111',
          name: 'Sembabule District'
        },
        {
          code: '232',
          name: 'Serere District'
        },
        {
          code: '426',
          name: 'Sheema District'
        },
        {
          code: '215',
          name: 'Sironko District'
        },
        {
          code: '211',
          name: 'Soroti District'
        },
        {
          code: '212',
          name: 'Tororo District'
        },
        {
          code: '113',
          name: 'Wakiso District'
        },
        {
          code: 'W',
          name: 'Western Region'
        },
        {
          code: '313',
          name: 'Yumbe District'
        },
        {
          code: '330',
          name: 'Zombo District'
        }
      ]
    },
    {
      code: 'UA',
      name: 'Ukraine',
      states: [
        {
          code: '43',
          name: 'Autonomous Republic of Crimea'
        },
        {
          code: '71',
          name: 'Cherkaska oblast'
        },
        {
          code: '74',
          name: 'Chernihivska oblast'
        },
        {
          code: '77',
          name: 'Chernivetska oblast'
        },
        {
          code: '12',
          name: 'Dnipropetrovska oblast'
        },
        {
          code: '14',
          name: 'Donetska oblast'
        },
        {
          code: '26',
          name: 'Ivano-Frankivska oblast'
        },
        {
          code: '63',
          name: 'Kharkivska oblast'
        },
        {
          code: '65',
          name: 'Khersonska oblast'
        },
        {
          code: '68',
          name: 'Khmelnytska oblast'
        },
        {
          code: '35',
          name: 'Kirovohradska oblast'
        },
        {
          code: '30',
          name: 'Kyiv'
        },
        {
          code: '32',
          name: 'Kyivska oblast'
        },
        {
          code: '09',
          name: 'Luhanska oblast'
        },
        {
          code: '46',
          name: 'Lvivska oblast'
        },
        {
          code: '48',
          name: 'Mykolaivska oblast'
        },
        {
          code: '51',
          name: 'Odeska oblast'
        },
        {
          code: '53',
          name: 'Poltavska oblast'
        },
        {
          code: '56',
          name: 'Rivnenska oblast'
        },
        {
          code: '40',
          name: 'Sevastopol'
        },
        {
          code: '59',
          name: 'Sumska oblast'
        },
        {
          code: '61',
          name: 'Ternopilska oblast'
        },
        {
          code: '05',
          name: 'Vinnytska oblast'
        },
        {
          code: '07',
          name: 'Volynska oblast'
        },
        {
          code: '21',
          name: 'Zakarpatska Oblast'
        },
        {
          code: '23',
          name: 'Zaporizka oblast'
        },
        {
          code: '18',
          name: 'Zhytomyrska oblast'
        }
      ]
    },
    {
      code: 'AE',
      name: 'United Arab Emirates',
      states: [
        {
          code: 'AZ',
          name: 'Abu Dhabi Emirate'
        },
        {
          code: 'AJ',
          name: 'Ajman Emirate'
        },
        {
          code: 'DU',
          name: 'Dubai'
        },
        {
          code: 'FU',
          name: 'Fujairah'
        },
        {
          code: 'RK',
          name: 'Ras al-Khaimah'
        },
        {
          code: 'SH',
          name: 'Sharjah Emirate'
        },
        {
          code: 'UQ',
          name: 'Umm al-Quwain'
        }
      ]
    },
    {
      code: 'GB',
      name: 'United Kingdom',
      states: [
        {
          code: 'ABE',
          name: 'Aberdeen'
        },
        {
          code: 'ABD',
          name: 'Aberdeenshire'
        },
        {
          code: 'ANS',
          name: 'Angus'
        },
        {
          code: 'ANT',
          name: 'Antrim'
        },
        {
          code: 'ANN',
          name: 'Antrim and Newtownabbey'
        },
        {
          code: 'ARD',
          name: 'Ards'
        },
        {
          code: 'AND',
          name: 'Ards and North Down'
        },
        {
          code: 'AGB',
          name: 'Argyll and Bute'
        },
        {
          code: 'ARM',
          name: 'Armagh City and District Council'
        },
        {
          code: 'ABC',
          name: 'Armagh, Banbridge and Craigavon'
        },
        {
          code: 'SH-AC',
          name: 'Ascension Island'
        },
        {
          code: 'BLA',
          name: 'Ballymena Borough'
        },
        {
          code: 'BLY',
          name: 'Ballymoney'
        },
        {
          code: 'BNB',
          name: 'Banbridge'
        },
        {
          code: 'BNS',
          name: 'Barnsley'
        },
        {
          code: 'BAS',
          name: 'Bath and North East Somerset'
        },
        {
          code: 'BDF',
          name: 'Bedford'
        },
        {
          code: 'BFS',
          name: 'Belfast district'
        },
        {
          code: 'BIR',
          name: 'Birmingham'
        },
        {
          code: 'BBD',
          name: 'Blackburn with Darwen'
        },
        {
          code: 'BPL',
          name: 'Blackpool'
        },
        {
          code: 'BGW',
          name: 'Blaenau Gwent County Borough'
        },
        {
          code: 'BOL',
          name: 'Bolton'
        },
        {
          code: 'BMH',
          name: 'Bournemouth'
        },
        {
          code: 'BRC',
          name: 'Bracknell Forest'
        },
        {
          code: 'BRD',
          name: 'Bradford'
        },
        {
          code: 'BGE',
          name: 'Bridgend County Borough'
        },
        {
          code: 'BNH',
          name: 'Brighton and Hove'
        },
        {
          code: 'BKM',
          name: 'Buckinghamshire'
        },
        {
          code: 'BUR',
          name: 'Bury'
        },
        {
          code: 'CAY',
          name: 'Caerphilly County Borough'
        },
        {
          code: 'CLD',
          name: 'Calderdale'
        },
        {
          code: 'CAM',
          name: 'Cambridgeshire'
        },
        {
          code: 'CMN',
          name: 'Carmarthenshire'
        },
        {
          code: 'CKF',
          name: 'Carrickfergus Borough Council'
        },
        {
          code: 'CSR',
          name: 'Castlereagh'
        },
        {
          code: 'CCG',
          name: 'Causeway Coast and Glens'
        },
        {
          code: 'CBF',
          name: 'Central Bedfordshire'
        },
        {
          code: 'CGN',
          name: 'Ceredigion'
        },
        {
          code: 'CHE',
          name: 'Cheshire East'
        },
        {
          code: 'CHW',
          name: 'Cheshire West and Chester'
        },
        {
          code: 'CRF',
          name: 'City and County of Cardiff'
        },
        {
          code: 'SWA',
          name: 'City and County of Swansea'
        },
        {
          code: 'BST',
          name: 'City of Bristol'
        },
        {
          code: 'DER',
          name: 'City of Derby'
        },
        {
          code: 'KHL',
          name: 'City of Kingston upon Hull'
        },
        {
          code: 'LCE',
          name: 'City of Leicester'
        },
        {
          code: 'LND',
          name: 'City of London'
        },
        {
          code: 'NGM',
          name: 'City of Nottingham'
        },
        {
          code: 'PTE',
          name: 'City of Peterborough'
        },
        {
          code: 'PLY',
          name: 'City of Plymouth'
        },
        {
          code: 'POR',
          name: 'City of Portsmouth'
        },
        {
          code: 'STH',
          name: 'City of Southampton'
        },
        {
          code: 'STE',
          name: 'City of Stoke-on-Trent'
        },
        {
          code: 'SND',
          name: 'City of Sunderland'
        },
        {
          code: 'WSM',
          name: 'City of Westminster'
        },
        {
          code: 'WLV',
          name: 'City of Wolverhampton'
        },
        {
          code: 'YOR',
          name: 'City of York'
        },
        {
          code: 'CLK',
          name: 'Clackmannanshire'
        },
        {
          code: 'CLR',
          name: 'Coleraine Borough Council'
        },
        {
          code: 'CWY',
          name: 'Conwy County Borough'
        },
        {
          code: 'CKT',
          name: 'Cookstown District Council'
        },
        {
          code: 'CON',
          name: 'Cornwall'
        },
        {
          code: 'DUR',
          name: 'County Durham'
        },
        {
          code: 'COV',
          name: 'Coventry'
        },
        {
          code: 'CGV',
          name: 'Craigavon Borough Council'
        },
        {
          code: 'CMA',
          name: 'Cumbria'
        },
        {
          code: 'DAL',
          name: 'Darlington'
        },
        {
          code: 'DEN',
          name: 'Denbighshire'
        },
        {
          code: 'DBY',
          name: 'Derbyshire'
        },
        {
          code: 'DRS',
          name: 'Derry City and Strabane'
        },
        {
          code: 'DRY',
          name: 'Derry City Council'
        },
        {
          code: 'DEV',
          name: 'Devon'
        },
        {
          code: 'DNC',
          name: 'Doncaster'
        },
        {
          code: 'DOR',
          name: 'Dorset'
        },
        {
          code: 'DOW',
          name: 'Down District Council'
        },
        {
          code: 'DUD',
          name: 'Dudley'
        },
        {
          code: 'DGY',
          name: 'Dumfries and Galloway'
        },
        {
          code: 'DND',
          name: 'Dundee'
        },
        {
          code: 'DGN',
          name: 'Dungannon and South Tyrone Borough Council'
        },
        {
          code: 'EAY',
          name: 'East Ayrshire'
        },
        {
          code: 'EDU',
          name: 'East Dunbartonshire'
        },
        {
          code: 'ELN',
          name: 'East Lothian'
        },
        {
          code: 'ERW',
          name: 'East Renfrewshire'
        },
        {
          code: 'ERY',
          name: 'East Riding of Yorkshire'
        },
        {
          code: 'ESX',
          name: 'East Sussex'
        },
        {
          code: 'EDH',
          name: 'Edinburgh'
        },
        {
          code: 'ENG',
          name: 'England'
        },
        {
          code: 'ESS',
          name: 'Essex'
        },
        {
          code: 'FAL',
          name: 'Falkirk'
        },
        {
          code: 'FMO',
          name: 'Fermanagh and Omagh'
        },
        {
          code: 'FER',
          name: 'Fermanagh District Council'
        },
        {
          code: 'FIF',
          name: 'Fife'
        },
        {
          code: 'FLN',
          name: 'Flintshire'
        },
        {
          code: 'GAT',
          name: 'Gateshead'
        },
        {
          code: 'GLG',
          name: 'Glasgow'
        },
        {
          code: 'GLS',
          name: 'Gloucestershire'
        },
        {
          code: 'GWN',
          name: 'Gwynedd'
        },
        {
          code: 'HAL',
          name: 'Halton'
        },
        {
          code: 'HAM',
          name: 'Hampshire'
        },
        {
          code: 'HPL',
          name: 'Hartlepool'
        },
        {
          code: 'HEF',
          name: 'Herefordshire'
        },
        {
          code: 'HRT',
          name: 'Hertfordshire'
        },
        {
          code: 'HLD',
          name: 'Highland'
        },
        {
          code: 'IVC',
          name: 'Inverclyde'
        },
        {
          code: 'IOW',
          name: 'Isle of Wight'
        },
        {
          code: 'IOS',
          name: 'Isles of Scilly'
        },
        {
          code: 'KEN',
          name: 'Kent'
        },
        {
          code: 'KIR',
          name: 'Kirklees'
        },
        {
          code: 'KWL',
          name: 'Knowsley'
        },
        {
          code: 'LAN',
          name: 'Lancashire'
        },
        {
          code: 'LRN',
          name: 'Larne Borough Council'
        },
        {
          code: 'LDS',
          name: 'Leeds'
        },
        {
          code: 'LEC',
          name: 'Leicestershire'
        },
        {
          code: 'LMV',
          name: 'Limavady Borough Council'
        },
        {
          code: 'LIN',
          name: 'Lincolnshire'
        },
        {
          code: 'LBC',
          name: 'Lisburn and Castlereagh'
        },
        {
          code: 'LSB',
          name: 'Lisburn City Council'
        },
        {
          code: 'LIV',
          name: 'Liverpool'
        },
        {
          code: 'BDG',
          name: 'London Borough of Barking and Dagenham'
        },
        {
          code: 'BNE',
          name: 'London Borough of Barnet'
        },
        {
          code: 'BEX',
          name: 'London Borough of Bexley'
        },
        {
          code: 'BEN',
          name: 'London Borough of Brent'
        },
        {
          code: 'BRY',
          name: 'London Borough of Bromley'
        },
        {
          code: 'CMD',
          name: 'London Borough of Camden'
        },
        {
          code: 'CRY',
          name: 'London Borough of Croydon'
        },
        {
          code: 'EAL',
          name: 'London Borough of Ealing'
        },
        {
          code: 'ENF',
          name: 'London Borough of Enfield'
        },
        {
          code: 'HCK',
          name: 'London Borough of Hackney'
        },
        {
          code: 'HMF',
          name: 'London Borough of Hammersmith and Fulham'
        },
        {
          code: 'HRY',
          name: 'London Borough of Haringey'
        },
        {
          code: 'HRW',
          name: 'London Borough of Harrow'
        },
        {
          code: 'HAV',
          name: 'London Borough of Havering'
        },
        {
          code: 'HIL',
          name: 'London Borough of Hillingdon'
        },
        {
          code: 'HNS',
          name: 'London Borough of Hounslow'
        },
        {
          code: 'ISL',
          name: 'London Borough of Islington'
        },
        {
          code: 'LBH',
          name: 'London Borough of Lambeth'
        },
        {
          code: 'LEW',
          name: 'London Borough of Lewisham'
        },
        {
          code: 'MRT',
          name: 'London Borough of Merton'
        },
        {
          code: 'NWM',
          name: 'London Borough of Newham'
        },
        {
          code: 'RDB',
          name: 'London Borough of Redbridge'
        },
        {
          code: 'RIC',
          name: 'London Borough of Richmond upon Thames'
        },
        {
          code: 'SWK',
          name: 'London Borough of Southwark'
        },
        {
          code: 'STN',
          name: 'London Borough of Sutton'
        },
        {
          code: 'TWH',
          name: 'London Borough of Tower Hamlets'
        },
        {
          code: 'WFT',
          name: 'London Borough of Waltham Forest'
        },
        {
          code: 'WND',
          name: 'London Borough of Wandsworth'
        },
        {
          code: 'MFT',
          name: 'Magherafelt District Council'
        },
        {
          code: 'MAN',
          name: 'Manchester'
        },
        {
          code: 'MDW',
          name: 'Medway'
        },
        {
          code: 'MTY',
          name: 'Merthyr Tydfil County Borough'
        },
        {
          code: 'WGN',
          name: 'Metropolitan Borough of Wigan'
        },
        {
          code: 'MEA',
          name: 'Mid and East Antrim'
        },
        {
          code: 'MUL',
          name: 'Mid Ulster'
        },
        {
          code: 'MDB',
          name: 'Middlesbrough'
        },
        {
          code: 'MLN',
          name: 'Midlothian'
        },
        {
          code: 'MIK',
          name: 'Milton Keynes'
        },
        {
          code: 'MON',
          name: 'Monmouthshire'
        },
        {
          code: 'MRY',
          name: 'Moray'
        },
        {
          code: 'MYL',
          name: 'Moyle District Council'
        },
        {
          code: 'NTL',
          name: 'Neath Port Talbot County Borough'
        },
        {
          code: 'NET',
          name: 'Newcastle upon Tyne'
        },
        {
          code: 'NWP',
          name: 'Newport'
        },
        {
          code: 'NYM',
          name: 'Newry and Mourne District Council'
        },
        {
          code: 'NMD',
          name: 'Newry, Mourne and Down'
        },
        {
          code: 'NTA',
          name: 'Newtownabbey Borough Council'
        },
        {
          code: 'NFK',
          name: 'Norfolk'
        },
        {
          code: 'NAY',
          name: 'North Ayrshire'
        },
        {
          code: 'NDN',
          name: 'North Down Borough Council'
        },
        {
          code: 'NEL',
          name: 'North East Lincolnshire'
        },
        {
          code: 'NLK',
          name: 'North Lanarkshire'
        },
        {
          code: 'NLN',
          name: 'North Lincolnshire'
        },
        {
          code: 'NSM',
          name: 'North Somerset'
        },
        {
          code: 'NTY',
          name: 'North Tyneside'
        },
        {
          code: 'NYK',
          name: 'North Yorkshire'
        },
        {
          code: 'NTH',
          name: 'Northamptonshire'
        },
        {
          code: 'NIR',
          name: 'Northern Ireland'
        },
        {
          code: 'NBL',
          name: 'Northumberland'
        },
        {
          code: 'NTT',
          name: 'Nottinghamshire'
        },
        {
          code: 'OLD',
          name: 'Oldham'
        },
        {
          code: 'OMH',
          name: 'Omagh District Council'
        },
        {
          code: 'ORK',
          name: 'Orkney Islands'
        },
        {
          code: 'ELS',
          name: 'Outer Hebrides'
        },
        {
          code: 'OXF',
          name: 'Oxfordshire'
        },
        {
          code: 'PEM',
          name: 'Pembrokeshire'
        },
        {
          code: 'PKN',
          name: 'Perth and Kinross'
        },
        {
          code: 'POL',
          name: 'Poole'
        },
        {
          code: 'POW',
          name: 'Powys'
        },
        {
          code: 'RDG',
          name: 'Reading'
        },
        {
          code: 'RCC',
          name: 'Redcar and Cleveland'
        },
        {
          code: 'RFW',
          name: 'Renfrewshire'
        },
        {
          code: 'RCT',
          name: 'Rhondda Cynon Taf'
        },
        {
          code: 'RCH',
          name: 'Rochdale'
        },
        {
          code: 'ROT',
          name: 'Rotherham'
        },
        {
          code: 'GRE',
          name: 'Royal Borough of Greenwich'
        },
        {
          code: 'KEC',
          name: 'Royal Borough of Kensington and Chelsea'
        },
        {
          code: 'KTT',
          name: 'Royal Borough of Kingston upon Thames'
        },
        {
          code: 'RUT',
          name: 'Rutland'
        },
        {
          code: 'SH-HL',
          name: 'Saint Helena'
        },
        {
          code: 'SLF',
          name: 'Salford'
        },
        {
          code: 'SAW',
          name: 'Sandwell'
        },
        {
          code: 'SCT',
          name: 'Scotland'
        },
        {
          code: 'SCB',
          name: 'Scottish Borders'
        },
        {
          code: 'SFT',
          name: 'Sefton'
        },
        {
          code: 'SHF',
          name: 'Sheffield'
        },
        {
          code: 'ZET',
          name: 'Shetland Islands'
        },
        {
          code: 'SHR',
          name: 'Shropshire'
        },
        {
          code: 'SLG',
          name: 'Slough'
        },
        {
          code: 'SOL',
          name: 'Solihull'
        },
        {
          code: 'SOM',
          name: 'Somerset'
        },
        {
          code: 'SAY',
          name: 'South Ayrshire'
        },
        {
          code: 'SGC',
          name: 'South Gloucestershire'
        },
        {
          code: 'SLK',
          name: 'South Lanarkshire'
        },
        {
          code: 'STY',
          name: 'South Tyneside'
        },
        {
          code: 'SOS',
          name: 'Southend-on-Sea'
        },
        {
          code: 'SHN',
          name: 'St Helens'
        },
        {
          code: 'STS',
          name: 'Staffordshire'
        },
        {
          code: 'STG',
          name: 'Stirling'
        },
        {
          code: 'SKP',
          name: 'Stockport'
        },
        {
          code: 'STT',
          name: 'Stockton-on-Tees'
        },
        {
          code: 'STB',
          name: 'Strabane District Council'
        },
        {
          code: 'SFK',
          name: 'Suffolk'
        },
        {
          code: 'SRY',
          name: 'Surrey'
        },
        {
          code: 'SWD',
          name: 'Swindon'
        },
        {
          code: 'TAM',
          name: 'Tameside'
        },
        {
          code: 'TFW',
          name: 'Telford and Wrekin'
        },
        {
          code: 'THR',
          name: 'Thurrock'
        },
        {
          code: 'TOB',
          name: 'Torbay'
        },
        {
          code: 'TOF',
          name: 'Torfaen'
        },
        {
          code: 'TRF',
          name: 'Trafford'
        },
        {
          code: 'UKM',
          name: 'United Kingdom'
        },
        {
          code: 'VGL',
          name: 'Vale of Glamorgan'
        },
        {
          code: 'WKF',
          name: 'Wakefield'
        },
        {
          code: 'WLS',
          name: 'Wales'
        },
        {
          code: 'WLL',
          name: 'Walsall'
        },
        {
          code: 'WRT',
          name: 'Warrington'
        },
        {
          code: 'WAR',
          name: 'Warwickshire'
        },
        {
          code: 'WBK',
          name: 'West Berkshire'
        },
        {
          code: 'WDU',
          name: 'West Dunbartonshire'
        },
        {
          code: 'WLN',
          name: 'West Lothian'
        },
        {
          code: 'WSX',
          name: 'West Sussex'
        },
        {
          code: 'WIL',
          name: 'Wiltshire'
        },
        {
          code: 'WNM',
          name: 'Windsor and Maidenhead'
        },
        {
          code: 'WRL',
          name: 'Wirral'
        },
        {
          code: 'WOK',
          name: 'Wokingham'
        },
        {
          code: 'WOR',
          name: 'Worcestershire'
        },
        {
          code: 'WRX',
          name: 'Wrexham County Borough'
        }
      ]
    },
    {
      code: 'US',
      name: 'United States',
      states: [
        {
          code: 'AL',
          name: 'Alabama'
        },
        {
          code: 'AK',
          name: 'Alaska'
        },
        {
          code: 'AS',
          name: 'American Samoa'
        },
        {
          code: 'AZ',
          name: 'Arizona'
        },
        {
          code: 'AR',
          name: 'Arkansas'
        },
        {
          code: 'UM-81',
          name: 'Baker Island'
        },
        {
          code: 'CA',
          name: 'California'
        },
        {
          code: 'CO',
          name: 'Colorado'
        },
        {
          code: 'CT',
          name: 'Connecticut'
        },
        {
          code: 'DE',
          name: 'Delaware'
        },
        {
          code: 'DC',
          name: 'District of Columbia'
        },
        {
          code: 'FL',
          name: 'Florida'
        },
        {
          code: 'GA',
          name: 'Georgia'
        },
        {
          code: 'GU',
          name: 'Guam'
        },
        {
          code: 'HI',
          name: 'Hawaii'
        },
        {
          code: 'UM-84',
          name: 'Howland Island'
        },
        {
          code: 'ID',
          name: 'Idaho'
        },
        {
          code: 'IL',
          name: 'Illinois'
        },
        {
          code: 'IN',
          name: 'Indiana'
        },
        {
          code: 'IA',
          name: 'Iowa'
        },
        {
          code: 'UM-86',
          name: 'Jarvis Island'
        },
        {
          code: 'UM-67',
          name: 'Johnston Atoll'
        },
        {
          code: 'KS',
          name: 'Kansas'
        },
        {
          code: 'KY',
          name: 'Kentucky'
        },
        {
          code: 'UM-89',
          name: 'Kingman Reef'
        },
        {
          code: 'LA',
          name: 'Louisiana'
        },
        {
          code: 'ME',
          name: 'Maine'
        },
        {
          code: 'MD',
          name: 'Maryland'
        },
        {
          code: 'MA',
          name: 'Massachusetts'
        },
        {
          code: 'MI',
          name: 'Michigan'
        },
        {
          code: 'UM-71',
          name: 'Midway Atoll'
        },
        {
          code: 'MN',
          name: 'Minnesota'
        },
        {
          code: 'MS',
          name: 'Mississippi'
        },
        {
          code: 'MO',
          name: 'Missouri'
        },
        {
          code: 'MT',
          name: 'Montana'
        },
        {
          code: 'UM-76',
          name: 'Navassa Island'
        },
        {
          code: 'NE',
          name: 'Nebraska'
        },
        {
          code: 'NV',
          name: 'Nevada'
        },
        {
          code: 'NH',
          name: 'New Hampshire'
        },
        {
          code: 'NJ',
          name: 'New Jersey'
        },
        {
          code: 'NM',
          name: 'New Mexico'
        },
        {
          code: 'NY',
          name: 'New York'
        },
        {
          code: 'NC',
          name: 'North Carolina'
        },
        {
          code: 'ND',
          name: 'North Dakota'
        },
        {
          code: 'MP',
          name: 'Northern Mariana Islands'
        },
        {
          code: 'OH',
          name: 'Ohio'
        },
        {
          code: 'OK',
          name: 'Oklahoma'
        },
        {
          code: 'OR',
          name: 'Oregon'
        },
        {
          code: 'UM-95',
          name: 'Palmyra Atoll'
        },
        {
          code: 'PA',
          name: 'Pennsylvania'
        },
        {
          code: 'PR',
          name: 'Puerto Rico'
        },
        {
          code: 'RI',
          name: 'Rhode Island'
        },
        {
          code: 'SC',
          name: 'South Carolina'
        },
        {
          code: 'SD',
          name: 'South Dakota'
        },
        {
          code: 'TN',
          name: 'Tennessee'
        },
        {
          code: 'TX',
          name: 'Texas'
        },
        {
          code: 'UM',
          name: 'United States Minor Outlying Islands'
        },
        {
          code: 'VI',
          name: 'United States Virgin Islands'
        },
        {
          code: 'UT',
          name: 'Utah'
        },
        {
          code: 'VT',
          name: 'Vermont'
        },
        {
          code: 'VA',
          name: 'Virginia'
        },
        {
          code: 'UM-79',
          name: 'Wake Island'
        },
        {
          code: 'WA',
          name: 'Washington'
        },
        {
          code: 'WV',
          name: 'West Virginia'
        },
        {
          code: 'WI',
          name: 'Wisconsin'
        },
        {
          code: 'WY',
          name: 'Wyoming'
        }
      ]
    },
    {
      code: 'UM',
      name: 'United States Minor Outlying Islands',
      states: [
        {
          code: '81',
          name: 'Baker Island'
        },
        {
          code: '84',
          name: 'Howland Island'
        },
        {
          code: '86',
          name: 'Jarvis Island'
        },
        {
          code: '67',
          name: 'Johnston Atoll'
        },
        {
          code: '89',
          name: 'Kingman Reef'
        },
        {
          code: '71',
          name: 'Midway Islands'
        },
        {
          code: '76',
          name: 'Navassa Island'
        },
        {
          code: '95',
          name: 'Palmyra Atoll'
        },
        {
          code: '79',
          name: 'Wake Island'
        }
      ]
    },
    {
      code: 'UY',
      name: 'Uruguay',
      states: [
        {
          code: 'AR',
          name: 'Artigas'
        },
        {
          code: 'CA',
          name: 'Canelones'
        },
        {
          code: 'CL',
          name: 'Cerro Largo'
        },
        {
          code: 'CO',
          name: 'Colonia'
        },
        {
          code: 'DU',
          name: 'Durazno'
        },
        {
          code: 'FS',
          name: 'Flores'
        },
        {
          code: 'FD',
          name: 'Florida'
        },
        {
          code: 'LA',
          name: 'Lavalleja'
        },
        {
          code: 'MA',
          name: 'Maldonado'
        },
        {
          code: 'MO',
          name: 'Montevideo'
        },
        {
          code: 'PA',
          name: 'Paysandú'
        },
        {
          code: 'RN',
          name: 'Río Negro'
        },
        {
          code: 'RV',
          name: 'Rivera'
        },
        {
          code: 'RO',
          name: 'Rocha'
        },
        {
          code: 'SA',
          name: 'Salto'
        },
        {
          code: 'SJ',
          name: 'San José'
        },
        {
          code: 'SO',
          name: 'Soriano'
        },
        {
          code: 'TA',
          name: 'Tacuarembó'
        },
        {
          code: 'TT',
          name: 'Treinta y Tres'
        }
      ]
    },
    {
      code: 'UZ',
      name: 'Uzbekistan',
      states: [
        {
          code: 'AN',
          name: 'Andijan Region'
        },
        {
          code: 'BU',
          name: 'Bukhara Region'
        },
        {
          code: 'FA',
          name: 'Fergana Region'
        },
        {
          code: 'JI',
          name: 'Jizzakh Region'
        },
        {
          code: 'QR',
          name: 'Karakalpakstan'
        },
        {
          code: 'NG',
          name: 'Namangan Region'
        },
        {
          code: 'NW',
          name: 'Navoiy Region'
        },
        {
          code: 'QA',
          name: 'Qashqadaryo Region'
        },
        {
          code: 'SA',
          name: 'Samarqand Region'
        },
        {
          code: 'SI',
          name: 'Sirdaryo Region'
        },
        {
          code: 'SU',
          name: 'Surxondaryo Region'
        },
        {
          code: 'TK',
          name: 'Tashkent'
        },
        {
          code: 'TO',
          name: 'Tashkent Region'
        },
        {
          code: 'XO',
          name: 'Xorazm Region'
        }
      ]
    },
    {
      code: 'VU',
      name: 'Vanuatu',
      states: [
        {
          code: 'MAP',
          name: 'Malampa'
        },
        {
          code: 'PAM',
          name: 'Penama'
        },
        {
          code: 'SAM',
          name: 'Sanma'
        },
        {
          code: 'SEE',
          name: 'Shefa'
        },
        {
          code: 'TAE',
          name: 'Tafea'
        },
        {
          code: 'TOB',
          name: 'Torba'
        }
      ]
    },
    {
      code: 'VA',
      name: 'Vatican City State (Holy See)',
      states: []
    },
    {
      code: 'VE',
      name: 'Venezuela',
      states: [
        {
          code: 'Z',
          name: 'Amazonas'
        },
        {
          code: 'B',
          name: 'Anzoátegui'
        },
        {
          code: 'C',
          name: 'Apure'
        },
        {
          code: 'D',
          name: 'Aragua'
        },
        {
          code: 'E',
          name: 'Barinas'
        },
        {
          code: 'F',
          name: 'Bolívar'
        },
        {
          code: 'G',
          name: 'Carabobo'
        },
        {
          code: 'H',
          name: 'Cojedes'
        },
        {
          code: 'Y',
          name: 'Delta Amacuro'
        },
        {
          code: 'A',
          name: 'Distrito Capital'
        },
        {
          code: 'I',
          name: 'Falcón'
        },
        {
          code: 'W',
          name: 'Federal Dependencies of Venezuela'
        },
        {
          code: 'J',
          name: 'Guárico'
        },
        {
          code: 'X',
          name: 'La Guaira'
        },
        {
          code: 'K',
          name: 'Lara'
        },
        {
          code: 'L',
          name: 'Mérida'
        },
        {
          code: 'M',
          name: 'Miranda'
        },
        {
          code: 'N',
          name: 'Monagas'
        },
        {
          code: 'O',
          name: 'Nueva Esparta'
        },
        {
          code: 'P',
          name: 'Portuguesa'
        },
        {
          code: 'R',
          name: 'Sucre'
        },
        {
          code: 'S',
          name: 'Táchira'
        },
        {
          code: 'T',
          name: 'Trujillo'
        },
        {
          code: 'U',
          name: 'Yaracuy'
        },
        {
          code: 'V',
          name: 'Zulia'
        }
      ]
    },
    {
      code: 'VN',
      name: 'Vietnam',
      states: [
        {
          code: '44',
          name: 'An Giang'
        },
        {
          code: '43',
          name: 'Bà Rịa-Vũng Tàu'
        },
        {
          code: '54',
          name: 'Bắc Giang'
        },
        {
          code: '53',
          name: 'Bắc Kạn'
        },
        {
          code: '55',
          name: 'Bạc Liêu'
        },
        {
          code: '56',
          name: 'Bắc Ninh'
        },
        {
          code: '50',
          name: 'Bến Tre'
        },
        {
          code: '57',
          name: 'Bình Dương'
        },
        {
          code: '31',
          name: 'Bình Định'
        },
        {
          code: '58',
          name: 'Bình Phước'
        },
        {
          code: '40',
          name: 'Bình Thuận'
        },
        {
          code: '59',
          name: 'Cà Mau'
        },
        {
          code: 'CT',
          name: 'Cần Thơ'
        },
        {
          code: '04',
          name: 'Cao Bằng'
        },
        {
          code: 'DN',
          name: 'Đà Nẵng'
        },
        {
          code: '33',
          name: 'Đắk Lắk'
        },
        {
          code: '72',
          name: 'Đắk Nông'
        },
        {
          code: '71',
          name: 'Điện Biên'
        },
        {
          code: '39',
          name: 'Đồng Nai'
        },
        {
          code: '45',
          name: 'Đồng Tháp'
        },
        {
          code: '30',
          name: 'Gia Lai'
        },
        {
          code: '03',
          name: 'Hà Giang'
        },
        {
          code: '63',
          name: 'Hà Nam'
        },
        {
          code: 'HN',
          name: 'Hà Nội'
        },
        {
          code: '23',
          name: 'Hà Tĩnh'
        },
        {
          code: '61',
          name: 'Hải Dương'
        },
        {
          code: 'HP',
          name: 'Hải Phòng'
        },
        {
          code: '73',
          name: 'Hậu Giang'
        },
        {
          code: 'SG',
          name: 'Hồ Chí Minh'
        },
        {
          code: '14',
          name: 'Hòa Bình'
        },
        {
          code: '66',
          name: 'Hưng Yên'
        },
        {
          code: '34',
          name: 'Khánh Hòa'
        },
        {
          code: '47',
          name: 'Kiên Giang'
        },
        {
          code: '28',
          name: 'Kon Tum'
        },
        {
          code: '01',
          name: 'Lai Châu'
        },
        {
          code: '35',
          name: 'Lâm Đồng'
        },
        {
          code: '09',
          name: 'Lạng Sơn'
        },
        {
          code: '02',
          name: 'Lào Cai'
        },
        {
          code: '41',
          name: 'Long An'
        },
        {
          code: '67',
          name: 'Nam Định'
        },
        {
          code: '22',
          name: 'Nghệ An'
        },
        {
          code: '18',
          name: 'Ninh Bình'
        },
        {
          code: '36',
          name: 'Ninh Thuận'
        },
        {
          code: '68',
          name: 'Phú Thọ'
        },
        {
          code: '32',
          name: 'Phú Yên'
        },
        {
          code: '24',
          name: 'Quảng Bình'
        },
        {
          code: '27',
          name: 'Quảng Nam'
        },
        {
          code: '29',
          name: 'Quảng Ngãi'
        },
        {
          code: '13',
          name: 'Quảng Ninh'
        },
        {
          code: '25',
          name: 'Quảng Trị'
        },
        {
          code: '52',
          name: 'Sóc Trăng'
        },
        {
          code: '05',
          name: 'Sơn La'
        },
        {
          code: '37',
          name: 'Tây Ninh'
        },
        {
          code: '20',
          name: 'Thái Bình'
        },
        {
          code: '69',
          name: 'Thái Nguyên'
        },
        {
          code: '21',
          name: 'Thanh Hóa'
        },
        {
          code: '26',
          name: 'Thừa Thiên-Huế'
        },
        {
          code: '46',
          name: 'Tiền Giang'
        },
        {
          code: '51',
          name: 'Trà Vinh'
        },
        {
          code: '07',
          name: 'Tuyên Quang'
        },
        {
          code: '49',
          name: 'Vĩnh Long'
        },
        {
          code: '70',
          name: 'Vĩnh Phúc'
        },
        {
          code: '06',
          name: 'Yên Bái'
        }
      ]
    },
    {
      code: 'VG',
      name: 'Virgin Islands (British)',
      states: []
    },
    {
      code: 'VI',
      name: 'Virgin Islands (US)',
      states: [
        {
          code: 'SC',
          name: 'Saint Croix'
        },
        {
          code: 'SJ',
          name: 'Saint John'
        },
        {
          code: 'ST',
          name: 'Saint Thomas'
        }
      ]
    },
    {
      code: 'WF',
      name: 'Wallis and Futuna Islands',
      states: []
    },
    {
      code: 'EH',
      name: 'Western Sahara',
      states: []
    },
    {
      code: 'YE',
      name: 'Yemen',
      states: [
        {
          code: 'AD',
          name: "'Adan"
        },
        {
          code: 'AM',
          name: "'Amran"
        },
        {
          code: 'AB',
          name: 'Abyan'
        },
        {
          code: 'BA',
          name: "Al Bayda'"
        },
        {
          code: 'HU',
          name: 'Al Hudaydah'
        },
        {
          code: 'JA',
          name: 'Al Jawf'
        },
        {
          code: 'MR',
          name: 'Al Mahrah'
        },
        {
          code: 'MW',
          name: 'Al Mahwit'
        },
        {
          code: 'SA',
          name: 'Amanat Al Asimah'
        },
        {
          code: 'DH',
          name: 'Dhamar'
        },
        {
          code: 'HD',
          name: 'Hadhramaut'
        },
        {
          code: 'HJ',
          name: 'Hajjah'
        },
        {
          code: 'IB',
          name: 'Ibb'
        },
        {
          code: 'LA',
          name: 'Lahij'
        },
        {
          code: 'MA',
          name: "Ma'rib"
        },
        {
          code: 'RA',
          name: 'Raymah'
        },
        {
          code: 'SD',
          name: 'Saada'
        },
        {
          code: 'SN',
          name: "Sana'a"
        },
        {
          code: 'SH',
          name: 'Shabwah'
        },
        {
          code: 'SU',
          name: 'Socotra'
        },
        {
          code: 'TA',
          name: "Ta'izz"
        }
      ]
    },
    {
      code: 'ZM',
      name: 'Zambia',
      states: [
        {
          code: '02',
          name: 'Central Province'
        },
        {
          code: '08',
          name: 'Copperbelt Province'
        },
        {
          code: '03',
          name: 'Eastern Province'
        },
        {
          code: '04',
          name: 'Luapula Province'
        },
        {
          code: '09',
          name: 'Lusaka Province'
        },
        {
          code: '10',
          name: 'Muchinga Province'
        },
        {
          code: '05',
          name: 'Northern Province'
        },
        {
          code: '06',
          name: 'Northwestern Province'
        },
        {
          code: '07',
          name: 'Southern Province'
        },
        {
          code: '01',
          name: 'Western Province'
        }
      ]
    },
    {
      code: 'ZW',
      name: 'Zimbabwe',
      states: [
        {
          code: 'BU',
          name: 'Bulawayo Province'
        },
        {
          code: 'HA',
          name: 'Harare Province'
        },
        {
          code: 'MA',
          name: 'Manicaland'
        },
        {
          code: 'MC',
          name: 'Mashonaland Central Province'
        },
        {
          code: 'ME',
          name: 'Mashonaland East Province'
        },
        {
          code: 'MW',
          name: 'Mashonaland West Province'
        },
        {
          code: 'MV',
          name: 'Masvingo Province'
        },
        {
          code: 'MN',
          name: 'Matabeleland North Province'
        },
        {
          code: 'MS',
          name: 'Matabeleland South Province'
        },
        {
          code: 'MI',
          name: 'Midlands Province'
        }
      ]
    }
  ];
  static SiteNames = Object.freeze({
    gocaribbea: 'Gocaribbea',
    roomantic: 'Roomantic',
    shamalgroup: 'ShamalGroup',
    joy: 'Joy',
    prestigate: 'Prestigate',
    noblestay: 'NobleStay',
    hostmytrips: 'HostMyTrips',
    onestopparking: 'OneStopParking',
    hotelUsso: "HotelUsso",
    Sharecare: "Sharecare"
  });

  static accountIds = Object.freeze({
    reservationsDev: 'reservations-test-account',
    reservationsProd: 'reservations-test-account',
    roomanticDev: 'roomantic-test-account',
    roomanticProd: 'roomantic-live-account'
  });

  static PaymentMethod = Object.freeze({
    stripe: 'stripe',
    payBeagle: 'payBeagle',
    nimbbl: 'nimbbl',
    authorization: 'authorization.net',
    vaultera: 'vaultera',
    peachpayment: 'peachpayment',
    noPayment: 'noPayment',
    connexPay: 'connexpay'
  });

  static GoogleTagEventNames = Object.freeze({
    beginCheckout: 'begin_checkout',
    addPayment: 'add_payment',
    purchase: 'purchase'
  });

  static mobileNumberLength = Object.freeze({
    "HostMytrips": 10,
  })
}

